// Sport Energy Guide — wizard runtime (Fase 5.8.1)
//
// FASE 5.8.1 (12. jun 2026): Vegansk nedtonet — quick-filteret er
// flyttet ind under Flere filtre (gruppen Kost), og Vegansk-chippen
// på kortene vises kun når den er relevant (vegansk profil eller
// aktivt vegansk-filter).
//
// FASE 5.8.0 (12. jun 2026): Phillips live-review. Kittet (Din plan
// til passet) udgår — ingen køber til ét enkelt pas; guiden informerer,
// kortene har Læg i kurv, og hele løb planlægges i race-kittet. Fuld
// hvorfor-tekst på alle tre kort med Læs mere-udvidelse (klampen
// styrer højden, ikke teksten), kort 2-3 får samme faktuelle bund som
// kort 1. Gels/barer doseres i hele enheder (rules 5.8.0).
//
// FASE 5.7.0 (12. jun 2026): Konverterings-revision. Planen står nu
// direkte under de tre match (intentionen topper dér — Fitts), og
// sortimentet er kompakt (3 synlige, trinvis udvidelse) og dedupet
// mod top 3, så samme produkt aldrig står to gange. Kort-højderne er
// ens (kompakte hvorfor-tekster, bund-forankret pris/knap), Kopiér
// link bor i handlingsrækken, og en leveringslinje står ved kurv-
// knappen, hvor købs-tøven faktisk opstår.
//
// FASE 5.6.0 (12. jun 2026): Mekanismen bor i banneret (tydelig
// toggle), top 3 ligestillet som bedste match, hele sortimentet åbent
// direkte under de tre kort, specialist-folden fjernet (chips dækker
// behovet), kittet er en plan med køb (Din plan til passet), tips
// statisk fremme, præcise kulhydrater i hvorfor-teksten.
//
// FASE 5.5.0 (12. jun 2026): Kittet ligger bag en fold (Pak til
// passet) — et tilbud atleten åbner, ikke et krav midt på siden.
// Folden bærer hvorfor-linjen og den løbende sum.
//
// FASE 5.3.0 (12. jun 2026): Specialisten og Tag også flyttet til en
// opt-in-fold under kittet ('Hvis du vil videre'). Learning-, explore-
// og alts-folds bruger nu race-kittets fold-anatomi (ikon-cirkel +
// kicker + titel) — den fælles rødtråd på tværs af økosystemet.
//
// FASE 5.2.0 (12. jun 2026): Tre rangerede match i stedet for ét
// Bedste match plus to begrebskategorier — motoren scorede allerede
// hele sortimentet, nu vises rangeringen ærligt. Kittet følger det
// valgte match, og hvorfor-linjen forklarer hvorfor kittet findes
// ('Én gel dækker ikke et pas').
//
// FASE 4.3.0 (11. jun 2026): Bro til race-kit byggeren fra
// resultatsiden — g-målet følger med i linket.
//
// FASE 3.0.2 (10. jun 2026): Selvreview — reset/popstate genlæser
// profilen frem for at nulstille; 'brug estimat' rører kun profilen
// når session-tallet er atletens eget.
//
// FASE 3.0.1 (10. jun 2026): Atlet-profil-integration — målt svedtab
// læses fra og skrives til sport-energy-profile.js. Delte links
// overstyrer for sessionen, men rører aldrig modtagerens profil.
//
// FASE 2.15.2 (10. jun 2026): Kit-checkbox tegnes selv — temaets
// switch-styling kunne ikke overdøves med specificitet (set live).
//
// FASE 2.15.1 (10. jun 2026): Kritisk fix — renderStep1 køres altid
// ved init. Før stod trin 1 tomt efter ankomst via delt link, når
// atleten navigerede tilbage. Fundet ved Phillips live-test.
//
// FASE 2.15.0 (R1, lancerings-porten): Rolig resultatside.
// Kernen synlig (mål, chips, kort, kit) — alt andet opt-in:
// læringsblok, udforsk-sektion og tips/guides er foldet bag rolige
// kicker-toggles. Tilstand persisterer hen over chip-re-renders
// (resultUI), nulstilles ved 'start forfra'. Mobile-FAB kun når
// udforsk er åben. guide_learning_block_shown fyrer nu kun ved
// faktisk visning (udfoldet) — ærlig metrik.
//
// FASE 2.14.3 (10. jun 2026): Rettelser fra første live-screenshot.
// - Tab-badge og panel-tælling bruger nu SAMME pipeline (filtre +
//   dedupe + Maurten-additions). Badget viste før rå gruppe (105)
//   mod panelets 37 — atleten blev lovet ét tal og fik et andet.
// - Banner-dublering slanket: målet bæres af badget alene.
// - Ental ved mængder under 1 ('0,5 gel', ikke '0,5 gels') —
//   rammer multi-serving produkter som PF 300 Flow Gel.
//
// FASE 2.14.1 (10. jun 2026): Finpudsning af hydrering + plan.
// - Hydrerings-badgets svedtab-hint er nu en klikbar handling der
//   åbner svedtab-chippen med slideren fokuseret — og vises IKKE i
//   noEnergyMode, hvor chippen er mave-profilen (hintet var vildledende).
// - Race-planer over 12 slots vises komprimeret (10 + resumé-linje
//   med slut-tid og evt. koffein-tidspunkt); kopi-versionen er fuld.
// - Kopiér-knappen findes nu også på drink-planer.
// - Tom-plan-guard i toggle.
//
// FASE 2.14.0 (10. jun 2026): Race-planen.
// 'Se din race-plan' i kit-kortet folder en time-for-time-timeline
// ud: klokkeslæt pr. enhed, koffein-markering, reserve-linje og
// 'Kopiér planen' til seddel/noter. Genereres af rules-modulets
// getFuelingPlan; genberegnes ved stepper-ændringer mens åben.
//
// FASE 2.13.0 (10. jun 2026): Hydrerings-beregner.
// Hydrering-flowet (og noEnergyMode) får sit eget mål-badge: væske
// og natrium pr. time, oversat til flasker. Svedtab-chippen får en
// slider til atletens målte svedtab (S.sweatRateMl, URL-param sr)
// med målevejledning. Beregningen lever i rules-modulet.
//
// FASE 2.12.1 (9. jun 2026): Finpudsning efter samlet review.
// - chipToggleModifier synker nu S.caffeine (tips læser feltet).
// - guide_kit_shown dedupes på (produkt, antal, addon) — chip-leg
//   inflaterer ikke længere shown→add_to_cart-funnelen.
// - Continue-kortet genopfriskes ved snapshot-save og reset;
//   guide_continue_shown tracker kun én gang pr. page-load.
//
// FASE 2.11.0 (9. jun 2026): 'Fortsæt hvor du slap'.
// Hvert færdigt resultat gemmes i localStorage (60 dages TTL).
// Ved genbesøg uden URL-state vises et stille kort på trin 1 med
// atletens seneste valg og 'Vis min anbefaling'. Afvis sletter.
// Alt i try/catch — private mode må aldrig fejle.
//
// FASE 2.12.0 (9. jun 2026): Robusthed — se rules-modulets header.
//
// FASE 2.10.0 (9. jun 2026): Præcis varighed.
// S.durationMin (minutter, null = bucket-mode). Wizard'en beholder de
// fire hurtige buckets — løftet om '3 spørgsmål' holdes. Præcisionen
// lever på resultatsiden: varigheds-chippen viser formateret tid og
// options-rækken får en slider (30 min – 12 t). Totaler og kit-antal
// regnes af den faktiske tid; g/t-målet er fortsat bucket-baseret.
// URL: dm-parameter, valideret, med defensiv bucket-afledning.
//
// FASE 2.9.0 (9. jun 2026): Live-chips + del-link.
// Resultatet er ikke længere en envejs-tunnel: atletens valg ligger
// som redigerbare chips øverst i resultatet. Tap på et valg åbner en
// inline options-række; tap på en option re-renderer hele resultatet
// med det samme (curated, kit, læringsblok, mål, paneler). Toggles
// (koffein, fast mad m.fl.) skifter med ét tap. Årsag og virkning
// er synlig direkte — det er dér udforskningen sker.
// Trin 3-options er løftet til modul-scope (delt kilde med trinnene).
// Chip-justeringer skriver URL med replaceState (ikke pushState).
// Del-link: 'Kopiér link til din anbefaling' — også coach-værktøjet:
// en træner kan sende en atlet et færdigudfyldt resultat.
//
// FASE 2.8.0 (9. jun 2026): "Pak til passet" — kit-kort.
// Syntesen af guidens anbefaling: Bedste match × beregnet antal
// (getKitQuantity i rules-modulet) med stepper så atleten ejer
// beslutningen, Tag også-produktet som valgfri linje der aktivt
// slås til (ikke forudvalgt — det er ærligt), løbende total og
// én samlet "Læg samlet i kurven" via /cart/add.js items-array.
// Renderes kun i energi-under-flowet, efter curated-cards.
// Tracking: guide_kit_shown / _adjusted / _add_to_cart(_success/_error).
//
// FASE 2.7.0 (9. jun 2026): Mængdelinje på curated-cards.
// Kulhydrat-målet regnes om til konkrete antal af det enkelte produkt
// (pr. time + til hele passet). Beregningen lever i rules-modulet
// (getQuantityEstimate); denne fil formáterer kun teksten på dansk.
// Kun curated-cards — grid-kortene holdes rolige. Udvides evt. senere
// på baggrund af Clarity-data.
//
// FASE 2.6.1 (9. jun 2026): Voice-fix. Step 2-subteksten krediterede
// David Roche — omskrevet til Sport Energys egen coaching-stemme
// (samme ændring i Roche-modalens tekster i page.guide.liquid).
//
// FASE 2.6.0 (9. jun 2026): Tilgængelighed (EAA) + debug-gating.
// - Modal og filter-sheet: Escape lukker, fokus-fælde, fokus-retur.
// - Kort-billede og -navn er nu rigtige <a href>-links (tastatur,
//   cmd-klik til ny fane, SEO). goToProduct returnerer false så
//   tracking og sessionStorage-context stadig kører ved alm. klik.
// - goToStep flytter fokus til aktivt trins overskrift (kun når
//   fokus allerede er i guiden — ingen fokus-tyveri ved load).
// - aria-live region annoncerer produktantal efter filterskift.
// - Al automatisk console.log er gated bag window.SEG_DEBUG = true.
//   SEG_debug() er stadig ugated (manuel diagnose).
// - scrollToActiveStep respekterer prefers-reduced-motion.
//
// Dette er UI-laget. Faglig logik (matching, scoring, curation, carb-target)
// lever i sport-energy-rules.js og eksponeres som window.SportEnergyRules.
// Læringstekster (mekanisme før produkt) lever i sport-energy-learning.js
// og eksponeres som window.SportEnergyLearning.
//
// FASE 2.4.1 (30. apr 2026): Profil- og sport-konsolidering.
// Færre, skarpere valg i UI'en med stærkere differentiering bag hver.
// - Mave-options: 4 → 2 (solid / følsom). Mave-meget-følsom og mave-ny
//   smeltes ind i mave-følsom — i praksis fik de næsten samme produkt-
//   anbefaling alligevel.
// - Svedtab-options: 3 → 2 (normal / meget). Svedtab-salt smeltes ind i
//   svedtab-højt. Saltrande nævnes nu som signal i beskrivelsen.
// - Sport-options: 4 → 3. HYROX fjernet — for få atleter til at
//   retfærdiggøre en plads. Tilhørende hyroxMode-state og pickHyroxMode-
//   funktion er fjernet helt.
// - URL-bagudkompatibilitet: gamle URLs med ?s=hyrox eller fjernede
//   profil-værdier (?p=mave-meget-følsom etc.) reset'er til step 1 så
//   atleten starter forfra. Eneste alternativ var stille mapping, men
//   reset er ærligere.
// - Hero-pill og atletniveau-tekster ryddet op for fjernede værdier.
//
// FASE 2.4.0 (30. apr 2026): Læringsblok mellem result-banner og curated-cards.
// - Atleten skal gå derfra klogere, ikke kun med produkter. Mekanisme-fokus
//   før produkt-fokus. Phillip-stemme: nordisk, rolig, ærlig, mekanisme før
//   produkt, ingen sales-tale.
// - Implementeret som tre-lags arkitektur:
//   * sport-energy-learning.js — modul der eksponerer getBlock(state) der
//     returnerer {title, paragraphs[]} eller null. Bruger arketyper i stedet
//     for state-permutationer (11-12 arketyper dækker hele state-rummet).
//   * page.guide.liquid — loader scriptet og indeholder #r-learning-div'en
//     mellem result-banner og curated-cards.
//   * Denne fil — kalder renderLearningBlock() i renderResult mellem
//     rebuildCollectionButton og buildCuratedSection.
// - Niveau 1: Kun arketype 1 (lange hårde pas / muren-arketypen) + 4
//   generiske fallbacks per formål er aktiveret. Resten af arketyperne
//   skrives efter 1-2 ugers Clarity-data (guide_learning_block_shown event)
//   så vi ved hvilke der reelt vises før vi investerer tid i tekster.
//
// FASE 2.3.5 (29. apr 2026): Design-helhedsforbedringer.
// - Progress-bar skjult på step 4 (atleten er færdig med flowet)
// - Hero reduceret på step 4 (mindre titel, sub-text skjult — fokus skal
//   være på resultatet, ikke flowets indgang)
// - "Vores anbefaling" → "Dine bedste muligheder" (brugercentreret sprog)
// - Product-cards bruger nu specs som chips (samme stil som curated-cards)
//   i stedet for flydende tekst. Max 3 chips for at holde grid-rytme.
// - Step-state class (seg-on-result, seg-step-N) sættes på .seg-root så
//   CSS kan conditionaliseres pr. step.
//
// FASE 2.3.4: Collection-btn-pill polish.
// "Se alle"-knappen er nu en premium centreret pille der matcher
// "LÆG I KURV"-knapperne.
//
// FASE 2.3.3: Premium polish — pris synlig på cards, premium full-width
// "LÆG I KURV"-knapper i versaler, related guides-sektion under tips.
//
// FASE 2.3.2: "Læg i kurv" direkte fra guiden via Kaching cart-drawer.
//
// FASE 2.3.1 SIMPLIFICERET: Smag-dropdown forsøgt og annulleret efter
// opdagelse af shop-arkitektur (én smag = ét produkt). Datalaget eksponerer
// product.default_variant_id som fase 2.3.2 bruger til cart-API.
//
// FASE 2.2.3: Trinvis "Se flere"-knap i grid (12 → 24 → alle).
//
// FASE 2.2.2 (i rules-modulet): Strikt hydrerings-filter. Energi-formater
// og højkulhydrat-pulvere udelukkes uanset elektrolyt-indhold.
//
// FASE 2.2.1: "Ingen ekstra energi"-mode.
// Når atleten vælger energi-under + under-1t + let, er den faglige sandhed
// at de ikke har brug for ekstra energi (Roche regel 1). Tidligere viste
// guiden energi-produkter alligevel — det undergravede sin egen rådgivning.
// Nu skifter renderResult midlertidigt til hydrerings-grenen for produkt-
// anbefalinger, mens banneret tydeligt forklarer hvorfor. Atleten får
// relevante anbefalinger (drikke + elektrolytter) i stedet for produkter
// de ikke har brug for. Implementeret som lokal S.formal-mutation i
// renderResult — alle hjælpefunktioner ser hydrerings-state under render
// og resettes bagefter, så Step 3-tilbage og URL-state stadig virker.
//
// FASE 2 (uændret): Ved init klassificerer guiden alle produkter via FINAL2-
// regelsættet. Det beriger hvert produkt med variant, mainPurpose, subCategory,
// specialFlags osv. baseret på rå metafields. matchProducts bruger nu
// mainPurpose som primær vej, med filter.formal som manuel override (REGEL 11)
// og legacy-fallback for produkter uden variant.
//
// Faglige fix er IKKE forsvundet — de er flyttet til rules-modulet.
// Se sport-energy-rules.js for komplet liste af FIX 1-9 og FINAL2-implementation.

(function() {
  'use strict';

  // Sanity check: data-modul
  if (typeof window.SportEnergyGuideData === 'undefined') {
    console.error('[Sport Energy Guide] Data-snippet ikke loadet. Wizard kan ikke starte.');
    return;
  }

  // Sanity check: regel-modul (NY i fase 1)
  if (typeof window.SportEnergyRules === 'undefined') {
    console.error('[Sport Energy Guide] Regel-modul (sport-energy-rules.js) ikke loadet. ' +
      'Tjek at <script>-tagget er tilføjet til templates/page.guide.liquid før guide-runtime.');
    return;
  }

  // Kort alias for regel-modulet — bruges hyppigt i denne fil.
  var SR = window.SportEnergyRules;

  // FASE 2.6.0: Debug-gating. Automatisk udviklings-logging går gennem
  // DBG() og er slukket i produktion. Aktivér med window.SEG_DEBUG = true
  // i konsollen. SEG_debug() (manuel produkt-diagnose) virker stadig direkte.
  function DBG() {
    if (window.SEG_DEBUG) console.log.apply(console, arguments);
  }

  // FASE 2.4.0: Sanity check + alias for læringsmodulet.
  // Modulet er valgfrit — hvis det ikke er loadet, fortsætter guiden uden
  // læringsblok (graceful degradation). Vi advarer i konsollen så fejlen
  // er synlig under udvikling, men crasher ikke hele wizarden.
  if (typeof window.SportEnergyLearning === 'undefined') {
    console.warn('[Sport Energy Guide / Fase 2.4.0] Læringsmodul ' +
      '(sport-energy-learning.js) ikke loadet. Læringsblokken vil ikke ' +
      'blive vist. Tjek at <script>-tagget er tilføjet til ' +
      'templates/page.guide.liquid før guide-runtime.');
  }
  var SL = window.SportEnergyLearning || null;

  // ══════════════════════════════════════════════════
  //  PRODUCT CATALOG
  // ══════════════════════════════════════════════════
  var P = {};
  window.SportEnergyGuideData.products.forEach(function(p) {
    P[p.handle] = p;
  });
  window.SEG_P = P;

  // FASE 2: Klassificer alle produkter via FINAL2-regelsættet.
  // Det beriger hvert produkt med p.variant, p.mainPurpose, p.subCategory,
  // p.specialFlags osv. Manuel filter.formal vinder over automatik (REGEL 11).
  if (typeof SR.classifyProducts === 'function') {
    SR.classifyProducts(window.SportEnergyGuideData.products);
    DBG('[Sport Energy Guide / Fase 2] Klassifikation kørt på ' +
      window.SportEnergyGuideData.products.length + ' produkter.');
  }

  // ══════════════════════════════════════════════════
  //  STATE
  // ══════════════════════════════════════════════════
  var S = {
    formal: null,
    sport: null,
    duration: null,
    durationMin: null, // FASE 2.10.0: præcis varighed i minutter (null = bucket-mode)
    sweatRateMl: null, // FASE 2.13.0: målt svedtab i ml/t (null = estimat fra profil)
    intensity: null,
    profile: null,
    modifiers: [],
    caffeine: false,
    activeTab: 'under',
    activeFilters: ['alle'],
    advancedFilters: [],
    showAdvanced: false,
    // FASE 2.2.3: Trinvis "Se flere"-state per tab.
    // Holder hvor mange produkter der vises i hvert tab. Default 12 (samme
    // som tidligere top-12-grænse). Klik på "Se flere" øger til 24, derefter
    // til alle. Værdien per tab gemmes så atleten kan skifte mellem tabs
    // uden at miste sin udvidede tilstand. Filter-ændringer påvirker ikke
    // expanded-state — hvis filtered.length falder under værdien, vises
    // bare det der er tilbage.
    expandedTabs: {}
  };
  window.SEG_S = S;

  // ══════════════════════════════════════════════════
  //  KATEGORI-LABELS (kun for UI-rendering)
  // ══════════════════════════════════════════════════
  // Disse mappings ligger nu primært i rules-modulet (SR.SUPPLEMENT_CATEGORY_LABELS).
  // Men UI-laget har brug for direkte adgang til labels for hurtig lookup
  // i fx getMultiCategoryWhy. Vi peger på rules-modulet som single source of truth.
  var SUPPLEMENT_CATEGORY_LABELS = SR.SUPPLEMENT_CATEGORY_LABELS;

  // ══════════════════════════════════════════════════
  //  ICONS
  // ══════════════════════════════════════════════════
  var ICONS = {
    energy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L4.09 12.97a.5.5 0 0 0 .39.81H11l-2 8.22 8.91-10.97a.5.5 0 0 0-.39-.81H13l2-8.22z"/></svg>',
    hydration: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5C12 2.5 5 10 5 15a7 7 0 0 0 14 0c0-5-7-12.5-7-12.5z"/></svg>',
    recovery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 4 21 10 15 10"/></svg>',
    supplement: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4"/><path d="M5 8h14l-1 12.5a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5L5 8z"/><path d="M9 12h6"/><path d="M9 16h6"/></svg>',
    run: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="13" cy="4" r="2"/><path d="M4 22l4-9 4 3-2 6"/><path d="M8 13l3-6 3 4 4-1"/><path d="M14 8l3 4 3-2"/></svg>',
    bike: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path d="M12 17.5L8 8l-2 0M14 6l4 11.5M8 8h6l-2 5"/></svg>',
    hyrox: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 6.5h11"/><path d="M6.5 17.5h11"/><circle cx="5" cy="12" r="2"/><circle cx="19" cy="12" r="2"/><path d="M7 12h10"/></svg>',
    triathlon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 16c2 0 2-1.5 4-1.5s2 1.5 4 1.5 2-1.5 4-1.5 2 1.5 4 1.5 2-1.5 4-1.5"/><path d="M2 20c2 0 2-1.5 4-1.5s2 1.5 4 1.5 2-1.5 4-1.5 2 1.5 4 1.5 2-1.5 4-1.5"/><circle cx="12" cy="6" r="2.5"/><path d="M9 11h6"/></svg>',
    short: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M9 2h6"/></svg>',
    medium: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    long: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l4 2"/><path d="M3 12h2M19 12h2M12 3v2M12 19v2"/></svg>',
    ultra: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18l4-8 4 6 3-4 3 5 4-3"/><path d="M3 21h18"/></svg>',
    easy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12c3-3 5-3 9 0s6 0 9-3"/><path d="M3 17c3-3 5-3 9 0s6 0 9-3"/></svg>',
    moderate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l5-5 4 4 9-9"/><path d="M14 7h7v7"/></svg>',
    race: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 21V3h2v6c5-3 8 3 13 0v9c-5 3-8-3-13 0v3z"/></svg>',
    training: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h2"/><path d="M20 12h2"/><path d="M5 8h2v8H5z"/><path d="M17 8h2v8h-2z"/><path d="M7 12h10"/></svg>',
    simulation: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 3v18M3 12h18"/></svg>',
    stomach: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 4c0 0 0 4 4 4s4-4 4-4"/><path d="M5 9c-1 4 0 11 7 11s8-7 7-11"/><circle cx="10" cy="14" r="0.5" fill="currentColor"/><circle cx="14" cy="14" r="0.5" fill="currentColor"/></svg>',
    caffeine: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h12v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V8z"/><path d="M17 11h2a2 2 0 0 1 0 4h-2"/><path d="M8 4c0 1 1 1 1 2s-1 1-1 2"/><path d="M12 4c0 1 1 1 1 2s-1 1-1 2"/></svg>',
    sodium: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 5v8l-8 5-8-5V8z"/><path d="M12 8v8M8 12h8"/></svg>',
    electrolyte: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="12" r="2"/><circle cx="12" cy="6" r="2"/><circle cx="18" cy="12" r="2"/><circle cx="12" cy="18" r="2"/><path d="M8 12h8M12 8v8"/></svg>',
    solid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="8" width="16" height="8" rx="1"/><path d="M7 12h2M11 12h2M15 12h2"/></svg>',
    tablet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="6" rx="3"/><path d="M12 9v6"/></svg>',
    carbinwater: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10l-1 4h-8z"/><path d="M8 8v11a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8"/><circle cx="11" cy="14" r="0.7" fill="currentColor"/><circle cx="13" cy="17" r="0.7" fill="currentColor"/></svg>',
    fastabsorption: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M13 3L4 14h7l-1 7 9-11h-7z"/></svg>',
    vegan: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c0-6 0-9 5-13"/><path d="M17 9c2-3 4-3 4-3s0 7-4 9c-3 2-7 0-7-4 0-3 4-4 7-2z"/></svg>',
    protein: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 5l4 14M19 5l-4 14"/><path d="M7 12h10"/><path d="M5 5h4M15 5h4M9 19h4M15 19h4"/></svg>',
    creatine: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/><circle cx="12" cy="12" r="3"/></svg>',
    sleep: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
    immune: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-12V4l-8-2-8 2v6c0 8 8 12 8 12z"/><path d="M9 12l2 2 4-4"/></svg>',
    injury: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 6l3-3a3 3 0 1 1 4 4l-3 3"/><path d="M10 18l-3 3a3 3 0 1 1-4-4l3-3"/><path d="M9 9l6 6"/><path d="M14 4l6 6M4 14l6 6"/></svg>',
    performance: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    none: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9 12l2 2 4-4"/></svg>',
    help: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 1-1 2-2.5 2.5"/><circle cx="12" cy="16" r="0.5" fill="currentColor"/></svg>'
  };
  function icon(name) { return ICONS[name] || ICONS.none; }

  // ══════════════════════════════════════════════════
  //  STEP 1: FORMÅL
  // ══════════════════════════════════════════════════
  var formaalGroups = {
    'energi-under': {
      icon: 'energy',
      title: 'Energi under aktivitet',
      desc: 'Til under træning og race',
      formal: ['Alm. træning', 'Lang træning', 'Tempo', 'Ydelse & Udholdenhed', 'Lavt sukkerindhold']
    },
    'hydrering': {
      icon: 'hydration',
      title: 'Hydrering & elektrolytter',
      desc: 'Væskebalance og kramper',
      formal: ['Alm. træning'],
      specialFilter: 'hydrering'
    },
    'restitution': {
      icon: 'recovery',
      title: 'Restitution & protein',
      desc: 'Efter træning',
      formal: ['Efter normal træning', 'Efter hård belastning']
    },
    'sportstilskud': {
      icon: 'supplement',
      title: 'Sportstilskud',
      desc: 'Daglig basis',
      formal: ['Søvn & Restitution', 'Immunforsvar', 'Led & Skadesforebyggelse', 'Fokus & Mental Skarphed', 'Ydelse & Udholdenhed']
    }
  };

  var sportOpts = [
    {v:'løb', icon:'run', l:'Løb', lShort:'Løb'},
    {v:'cykling', icon:'bike', l:'Cykling', lShort:'Cykling'},
    {v:'triathlon', icon:'triathlon', l:'Triathlon', lShort:'Triathlon'}
  ];

  var durOpts = [
    {v:'under-1t', icon:'short', l:'Under 1 time', lShort:'< 1t'},
    {v:'1-2t', icon:'medium', l:'1–2 timer', lShort:'1–2t'},
    {v:'2-4t', icon:'long', l:'2–4 timer', lShort:'2–4t'},
    {v:'over-4t', icon:'ultra', l:'Over 4 timer', lShort:'> 4t'}
  ];

  var intensityOpts = [
    {v:'let', icon:'easy', l:'Let (Z1/Z2)', lShort:'Let'},
    {v:'moderat', icon:'moderate', l:'Hård (Z3+)', lShort:'Hård'},
    {v:'race', icon:'race', l:'Race', lShort:'Race'}
  ];

  // ══════════════════════════════════════════════════
  //  RENDER STEP 1
  // ══════════════════════════════════════════════════
  function renderStep1() {
    var container = document.getElementById('step-1-content');
    if (!container) return;

    var content = Object.keys(formaalGroups).map(function(key) {
      var g = formaalGroups[key];
      return '' +
        '<button class="opt-tile" data-value="' + key + '" onclick="SEG.selectFormal(this)">' +
          '<div class="tile-icon">' + icon(g.icon) + '</div>' +
          '<div class="tile-title">' + g.title + '</div>' +
          '<div class="tile-desc">' + g.desc + '</div>' +
        '</button>';
    }).join('');

    container.innerHTML =
      '<div class="opt-tiles">' + content + '</div>' +
      '<div class="help-box">' +
        '<button class="help-btn" onclick="SEG.toggleHelp(this)">' +
          '<span>Jeg er i tvivl — hvad er forskellen?</span>' +
          '<span class="caret">▾</span>' +
        '</button>' +
        '<div class="help-body">' +
          '<div class="help-inner">' +
            '<p><strong>Energi</strong> tager du under aktivitet for at undgå at "ramme muren". Gels, drikke og bars.</p>' +
            '<p><strong>Hydrering</strong> er væske og elektrolytter — vigtigt ved varme og lange sessioner.</p>' +
            '<p><strong>Restitution</strong> tager du efter træning for at genopbygge musklerne.</p>' +
            '<p><strong>Sportstilskud</strong> er det daglige fundament — søvn, skadesforebyggelse og præstation.</p>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function selectFormal(el) {
    document.querySelectorAll('#step-1-content .opt-tile').forEach(function(t) { t.classList.remove('selected'); });
    el.classList.add('selected');
    S.formal = el.dataset.value;
    S.sport = null; S.duration = null; S.intensity = null; S.profile = null; S.modifiers = [];
    seg_track('guide_step1_completed', {formal: S.formal});
    setTimeout(function() { buildStep2(); goToStep(2); }, 260);
  }

  // ══════════════════════════════════════════════════
  //  STEP 2
  // ══════════════════════════════════════════════════
  function buildStep2() {
    var title = document.getElementById('s2-title');
    var sub = document.getElementById('s2-sub');
    var cont = document.getElementById('s2-content');

    var needsFullDetails = S.formal === 'energi-under' || S.formal === 'hydrering';

    function renderSegOpts(opts, handler) {
      return opts.map(function(o) {
        return '<button class="segmented-option" data-value="' + o.v + '" onclick="SEG.' + handler + '(this)">' +
          '<span class="pill-icon">' + icon(o.icon) + '</span>' +
          '<span class="seg-label-full">' + o.l + '</span>' +
          '<span class="seg-label-short">' + o.lShort + '</span>' +
        '</button>';
      }).join('');
    }

    if (needsFullDetails) {
      title.innerHTML = 'Sport, <em>varighed</em> og intensitet';
      sub.textContent = 'Varighed og intensitet afgør dit kulhydrat-mål — og dermed hvilke produkter der passer.';

      var thirdGroup = buildIntensityGroup();

      cont.innerHTML =
        '<div class="compound-group" id="cg-sport">' +
          '<span class="compound-label"><span class="compound-dot" id="dot-sport"></span>Din sport</span>' +
          '<div class="segmented-control" id="sport-pills">' + renderSegOpts(sportOpts, 'pickSport') + '</div>' +
        '</div>' +
        '<div class="compound-group" id="cg-dur">' +
          '<span class="compound-label"><span class="compound-dot" id="dot-dur"></span>Varighed</span>' +
          '<div class="segmented-control" id="dur-pills">' + renderSegOpts(durOpts, 'pickDuration') + '</div>' +
        '</div>' +
        '<div id="third-group-wrap">' + thirdGroup + '</div>' +
        '<div class="help-box">' +
          '<button class="help-btn" onclick="SEG.toggleHelp(this)">' +
            '<span><span class="help-icon-wrap">' + icon('help') + '</span>Jeg er i tvivl om intensitet</span>' +
            '<span class="caret">▾</span>' +
          '</button>' +
          '<div class="help-body">' +
            '<div class="help-inner">' +
              '<p><strong>Let (Z1/Z2):</strong> Du kan føre en normal samtale mens du træner. Roligt, komfortabelt tempo — typiske søndagsture eller grundtræning.</p>' +
              '<p><strong>Moderat/hård (Z3+):</strong> Du kan kun tale i korte sætninger. Tungere vejrtrækning. Intervaller, tempo-træning eller hårde gruppe-ture.</p>' +
              '<p><strong>Race / konkurrence:</strong> Du kæmper mentalt for at holde tempoet. Konkurrence-dag, tempo-test, eller maksimal indsats.</p>' +
              '<p style="margin-top:12px;"><strong>Varighed</strong> bestemmer kulhydrat-behovet per time. Længere varighed = højere behov.</p>' +
            '</div>' +
          '</div>' +
        '</div>';
    } else {
      title.innerHTML = 'Hvilken <em>sport</em> træner du?';
      sub.textContent = 'Vi tilpasser anbefalingen til din sport.';

      cont.innerHTML =
        '<div class="compound-group">' +
          '<span class="compound-label">Din sport</span>' +
          '<div class="segmented-control" id="sport-pills">' + renderSegOpts(sportOpts, 'pickSport') + '</div>' +
        '</div>';
    }

    var s2btn = document.getElementById('s2-btn');
    if (s2btn) s2btn.disabled = true;
    updateStep2Progress();
  }

  function buildIntensityGroup() {
    return '<div class="compound-group" id="cg-int">' +
      '<span class="compound-label"><span class="compound-dot" id="dot-int"></span>Intensitet</span>' +
      '<div class="segmented-control" id="int-pills">' +
        intensityOpts.map(function(o) {
          return '<button class="segmented-option" data-value="' + o.v + '" onclick="SEG.pickIntensity(this)">' +
            '<span class="pill-icon">' + icon(o.icon) + '</span>' +
            '<span class="seg-label-full">' + o.l + '</span>' +
            '<span class="seg-label-short">' + o.lShort + '</span>' +
          '</button>';
        }).join('') +
      '</div></div>';
  }

  function pickSport(el) {
    document.querySelectorAll('#sport-pills .segmented-option').forEach(function(p) { p.classList.remove('selected'); });
    el.classList.add('selected');
    S.sport = el.dataset.value;

    if (S.formal === 'energi-under' || S.formal === 'hydrering') {
      var wrap = document.getElementById('third-group-wrap');
      if (wrap) {
        S.intensity = null;
        wrap.innerHTML = buildIntensityGroup();
      }
    }
    updateStep2Progress();
    checkStep2Continue();
  }

  function updateStep2Progress() {
    var dotSport = document.getElementById('dot-sport');
    var dotDur = document.getElementById('dot-dur');
    var dotInt = document.getElementById('dot-int');

    if (S.sport) { if (dotSport) dotSport.classList.add('active'); } else { if (dotSport) dotSport.classList.remove('active'); }
    if (S.duration) { if (dotDur) dotDur.classList.add('active'); } else { if (dotDur) dotDur.classList.remove('active'); }

    if (S.intensity) { if (dotInt) dotInt.classList.add('active'); } else { if (dotInt) dotInt.classList.remove('active'); }
  }

  function pickDuration(el) {
    document.querySelectorAll('#dur-pills .segmented-option').forEach(function(p) { p.classList.remove('selected'); });
    el.classList.add('selected');
    S.duration = el.dataset.value;
    S.durationMin = null; // FASE 2.10.0: bucket-valg nulstiller præcis tid
    updateStep2Progress();
    checkStep2Continue();
  }

  function pickIntensity(el) {
    document.querySelectorAll('#int-pills .segmented-option').forEach(function(p) { p.classList.remove('selected'); });
    el.classList.add('selected');
    S.intensity = el.dataset.value;
    updateStep2Progress();
    checkStep2Continue();
  }

  function checkStep2Continue() {
    var btn = document.getElementById('s2-btn');
    var mobileBtn = document.getElementById('mobile-s2-btn');
    var needsFullDetails = S.formal === 'energi-under' || S.formal === 'hydrering';

    var isReady = false;
    if (needsFullDetails) {
      isReady = !!(S.sport && S.duration && S.intensity);
    } else {
      isReady = !!S.sport;
      if (isReady) {
        setTimeout(function() { buildStep3(); goToStep(3); }, 240);
      }
    }

    if (btn) btn.disabled = !isReady;
    if (mobileBtn) mobileBtn.disabled = !isReady;
  }

  function continueStep2() {
    var btn = document.getElementById('s2-btn');
    var mobileBtn = document.getElementById('mobile-s2-btn');
    var isReady = (btn && !btn.disabled) || (mobileBtn && !mobileBtn.disabled);
    if (isReady) {
      seg_track('guide_step2_completed', {
        sport: S.sport, duration: S.duration, intensity: S.intensity
      });
      buildStep3();
      goToStep(3);
    }
  }

  // ══════════════════════════════════════════════════
  //  STEP 3
  // ══════════════════════════════════════════════════
  // FASE 2.9.0: Trin 3-options ligger i modul-scope, så både
  // getStep3Opts (trinnene) og state-chipsene (resultatet) deler
  // samme kilde — ændres en label, følger begge med.
  var STOMACH_SOLID    = {v:'mave-solid',           icon:'none',     l:'Solid mave',           d:'Jeg kan spise hvad som helst under træning'};
  var STOMACH_SENSITIVE = {v:'mave-følsom',         icon:'stomach',  l:'Følsom mave',          d:'Får ondt eller bliver presset på hårde pas'};

  var SWEAT_NORMAL     = {v:'svedtab-normal',       icon:'none',         l:'Normal sveder',     d:'Som de fleste, ingen særlige problemer'};
  var SWEAT_HIGH       = {v:'svedtab-højt',         icon:'electrolyte',  l:'Sveder meget',      d:'Mister væske hurtigt, ofte saltrande på tøjet'};

  var RECOVER_FAST     = {v:'restitution-hurtig',   icon:'fastabsorption', l:'Hurtigt tilbage', d:'Kort tid til næste pas — hydrolyseret protein'};
  var RECOVER_PROTEIN  = {v:'restitution-protein',  icon:'protein',  l:'Mest protein',         d:'Højt indhold per portion'};
  var RECOVER_VEGAN    = {v:'restitution-vegansk',  icon:'vegan',    l:'Plantebaseret',        d:'Jeg spiser ikke animalsk protein'};

  var MOD_CAFFEINE     = {v:'med-koffein',     icon:'caffeine',     l:'Med koffein'};
  var MOD_SOLID_FOOD   = {v:'fast-mad',        icon:'solid',        l:'Noget fast at tygge'};
  var MOD_CARB_IN_HYDR = {v:'med-kulhydrat',   icon:'carbinwater',  l:'Lidt energi i drikken'};
  var MOD_TABLETS      = {v:'tabletter',       icon:'tablet',       l:'Tabletter er lettere'};
  var MOD_CREATINE     = {v:'med-kreatin',     icon:'creatine',     l:'Jeg supplerer med kreatin'};

  var SUP_SLEEP        = {v:'søvn-restitution',     icon:'sleep',         l:'Søvn & restitution',   d:'Magnesium og hvile-fokus'};
  var SUP_INJURY       = {v:'skadesforebyggelse',   icon:'injury',        l:'Skadesforebyggelse',   d:'Kollagen og omega-3'};
  var SUP_IMMUNE       = {v:'immunforsvar',         icon:'immune',        l:'Immunforsvar',         d:'D-vitamin og C-vitamin'};
  var SUP_PERFORMANCE  = {v:'performance',          icon:'performance',   l:'Performance',          d:'Beetroot, koffein, kreatin'};
  var SUP_FOCUS        = {v:'mental-fokus',         icon:'performance',   l:'Mental fokus',         d:'Til de lange pas'};

  function getStep3Opts() {

    var sport = S.sport;
    var dur   = S.duration;
    var inten = S.intensity;
    var isLongOrRace = (dur === '2-4t' || dur === 'over-4t' || inten === 'race');

    if (S.formal === 'energi-under') {
      var toggles = [MOD_CAFFEINE];
      // Fast-mad-toggle vises ved alle pas over 1 time.
      var canEatSolid = (dur === '1-2t' || dur === '2-4t' || dur === 'over-4t');
      if (canEatSolid) toggles.push(MOD_SOLID_FOOD);
      return {
        question: 'Hvordan reagerer din mave på fueling?',
        sub: 'Det vigtigste er at finde noget der ikke laver problemer på lange eller hårde pas.',
        mainOpts: [STOMACH_SOLID, STOMACH_SENSITIVE],
        toggles: toggles,
        multiMode: false
      };
    }

    if (S.formal === 'hydrering') {
      var hToggles = [MOD_CARB_IN_HYDR];
      if (!isLongOrRace) hToggles.push(MOD_TABLETS);
      return {
        question: 'Hvor meget sveder du under træning?',
        sub: 'Højt svedtab kræver målrettet elektrolyt-strategi — saltrande på tøjet er et tydeligt signal.',
        mainOpts: [SWEAT_NORMAL, SWEAT_HIGH],
        toggles: hToggles,
        multiMode: false
      };
    }

    if (S.formal === 'restitution') {
      var rToggles = [];
      return {
        question: 'Hvad er vigtigst for dig efter træning?',
        sub: 'Vi tilpasser anbefalingen til din restitution-strategi.',
        mainOpts: [RECOVER_FAST, RECOVER_PROTEIN, RECOVER_VEGAN],
        toggles: rToggles,
        multiMode: false
      };
    }

    if (S.formal === 'sportstilskud') {
      var opts = [SUP_SLEEP, SUP_INJURY, SUP_IMMUNE];
      if (sport === 'cykling' || sport === 'triathlon') opts.push(SUP_PERFORMANCE);
      if (sport === 'løb') opts.push(SUP_FOCUS);
      return {
        question: 'Hvad arbejder du med?',
        sub: 'Vælg ét eller flere områder — vi anbefaler relevante produkter til hvert.',
        mainOpts: opts,
        toggles: [],
        multiMode: true
      };
    }

    return { question: '', sub: '', mainOpts: [], toggles: [], multiMode: false };
  }

  function buildStep3() {
    var container = document.getElementById('s3-content');
    var titleEl   = document.getElementById('s3-title');
    var subEl     = document.getElementById('s3-sub');
    if (!container) return;
    var cfg = getStep3Opts();
    if (!cfg.mainOpts || !cfg.mainOpts.length) return;

    if (titleEl && cfg.question) {
      var formatted = cfg.question;
      if (S.formal === 'energi-under')  formatted = formatted.replace('mave', '<em>mave</em>');
      if (S.formal === 'hydrering')     formatted = formatted.replace('sveder', '<em>sveder</em>');
      if (S.formal === 'restitution')   formatted = formatted.replace('vigtigst', '<em>vigtigst</em>');
      if (S.formal === 'sportstilskud') formatted = formatted.replace('arbejder', '<em>arbejder</em>');
      titleEl.innerHTML = formatted;
    }
    if (subEl && cfg.sub) subEl.textContent = cfg.sub;

    S.profile = null;
    S.modifiers = [];

    var html = '';

    if (cfg.toggles && cfg.toggles.length) {
      html += '<div class="s3-modifiers-label">Vælg gerne (frivilligt):</div>' +
              '<div class="s3-modifier-chips">' +
                cfg.toggles.map(function(m) {
                  return '<button class="opt-pill s3-modifier" data-value="' + m.v + '" onclick="SEG.toggleModifier(this)">' +
                    '<span class="pill-icon">' + icon(m.icon) + '</span>' + m.l +
                  '</button>';
                }).join('') +
              '</div>';
    }

    if (cfg.multiMode) {
      html += '<div class="opt-tiles">' +
                cfg.mainOpts.map(function(o) {
                  return '<button class="opt-tile multi" data-value="' + o.v + '" onclick="SEG.toggleMultiTile(this)">' +
                    '<div class="tile-icon">' + icon(o.icon) + '</div>' +
                    '<div class="tile-title">' + o.l + '</div>' +
                    '<div class="tile-desc">' + o.d + '</div>' +
                  '</button>';
                }).join('') +
              '</div>' +
              '<div class="s3-multi-continue">' +
                '<button class="btn-continue" id="s3-multi-btn" onclick="SEG.confirmMultiSelect()" disabled>Fortsæt →</button>' +
              '</div>';
    } else {
      html += '<div class="opt-tiles">' +
                cfg.mainOpts.map(function(o) {
                  return '<button class="opt-tile" data-value="' + o.v + '" onclick="SEG.pickProfile(this)">' +
                    '<div class="tile-icon">' + icon(o.icon) + '</div>' +
                    '<div class="tile-title">' + o.l + '</div>' +
                    '<div class="tile-desc">' + o.d + '</div>' +
                  '</button>';
                }).join('') +
              '</div>';
    }

    container.innerHTML = html;
  }

  function toggleModifier(el) {
    var value = el.dataset.value;
    el.classList.toggle('selected');
    if (S.modifiers.indexOf(value) >= 0) {
      S.modifiers = S.modifiers.filter(function(m) { return m !== value; });
    } else {
      S.modifiers.push(value);
    }
    S.caffeine = S.modifiers.indexOf('med-koffein') >= 0;
  }

  function pickProfile(el) {
    document.querySelectorAll('#s3-content .opt-tile').forEach(function(t) { t.classList.remove('selected'); });
    el.classList.add('selected');
    S.profile = el.dataset.value;
    S.caffeine = S.modifiers.indexOf('med-koffein') >= 0;
    setTimeout(function() {
      try {
        renderResult();
        goToStep(4);
        updateURL();
        seg_track('guide_completed', {
          formal: S.formal, sport: S.sport, duration: S.duration,
          intensity: S.intensity, profile: S.profile,
          modifiers_count: (S.modifiers || []).length
        });
      } catch (e) {
        console.error('pickProfile error:', e.message, e.stack);
      }
    }, 280);
  }

  function toggleMultiTile(el) {
    var value = el.dataset.value;
    el.classList.toggle('selected');
    if (S.modifiers.indexOf(value) >= 0) {
      S.modifiers = S.modifiers.filter(function(m) { return m !== value; });
    } else {
      S.modifiers.push(value);
    }
    var btn = document.getElementById('s3-multi-btn');
    if (btn) btn.disabled = S.modifiers.length === 0;
  }

  function confirmMultiSelect() {
    if (S.modifiers.length === 0) return;
    S.profile = 'multi';
    setTimeout(function() {
      try {
        renderResult();
        goToStep(4);
        updateURL();
        seg_track('guide_completed', {
          formal: S.formal, sport: S.sport, profile: 'multi',
          modifiers: (S.modifiers || []).join(',')
        });
      } catch (e) {
        console.error('confirmMultiSelect error:', e.message, e.stack);
      }
    }, 280);
  }

  // ══════════════════════════════════════════════════
  //  REGEL-WRAPPERS — kalder window.SportEnergyRules
  // ══════════════════════════════════════════════════
  function getCarbTarget()      { return SR.getCarbTarget(S); }
  function getRequiredRatios()  { return SR.getRequiredRatios(S); }
  function getAthleteLevel()    { return SR.getAthleteLevel(S); }
  function getProductFormat(p)  { return SR.getProductFormat(p); }
  function scoreProduct(p)      { return SR.scoreProduct(p, S); }

  function matchProducts() {
    return SR.matchProducts(Object.values(P), S);
  }

  function groupByHvornar(products) {
    return SR.groupByHvornar(products);
  }

  var currentMatched = [];
  var currentGroups = {};
  // FASE 2.8.0: Seneste curated-udvalg + kit-tilstand.
  var currentCurated = null;
  // FASE 5.2.0: De tre rangerede match på resultatsiden.
  var currentTop = [];
  var kitState = null;
  var kitLoading = false;
  // FASE 2.12.1: Dedupe-nøgle for guide_kit_shown — chip-leg skal
  // ikke inflatere shown→add_to_cart-funnelen med gen-visninger.
  var lastKitShownKey = null;
  // FASE 2.15.0: Fold-tilstand for resultatsidens opt-in-sektioner.
  // Persisterer hen over chip-re-renders; nulstilles i resetWizard.
  // FASE 5.2.0: matchIdx = hvilket af de tre rangerede match der er
  // valgt (styrer kittet). altsOpen = specialist/supplement-folden.
  // FASE 5.6.0: exploreOpen starter åben — sortimentet er en del af
  // svaret, ikke et tilvalg. altsOpen er udgået med specialist-folden.
  var resultUI = { learningOpen: false, exploreOpen: true, kitOpen: false, matchIdx: 0 };

  // ══════════════════════════════════════════════════
  //  HELPERS
  // ══════════════════════════════════════════════════
  function sportLabel() {
    var labels = {løb:'løb', cykling:'cykling', triathlon:'triathlon'};
    return labels[S.sport] || S.sport;
  }

  function durationLabel() {
    if (!S.duration) return '';
    var labels = {'under-1t':'under 1 time', '1-2t':'i 1–2 timer', '2-4t':'i 2–4 timer', 'over-4t':'over 4 timer'};
    return labels[S.duration] || '';
  }

  function getSportContextText() {
    var texts = {
      løb: 'Løb er hårdere for maven end andre sportsgrene — tag gels med rigeligt vand.',
      cykling: 'På cyklen tolererer maven mere — du kan indtage hurtigere og i større mængder.',
      triathlon: 'Triathlon skifter mellem discipliner — øv ernæringen på cyklen, ikke under løbet.'
    };
    return texts[S.sport] || '';
  }

  function getCollectionTitle() {
    var titles = {
      'energi-under':  'Se alle energi-produkter',
      'hydrering':     'Se alle hydrerings-produkter',
      'restitution':   'Se alle restitutions-produkter',
      'sportstilskud': 'Se alle sportstilskud'
    };
    return titles[S.formal] || '';
  }

  // FASE 2.3.4: Premium pille-knap-tekst til collection-link.
  // Bruges i rebuildCollectionButton. Versaler matcher resten af
  // sidens premium-knapper.
  function getCollectionButtonLabel() {
    var labels = {
      'energi-under':  'Se alle energi-produkter',
      'hydrering':     'Se alle hydrerings-produkter',
      'restitution':   'Se alle restitutions-produkter',
      'sportstilskud': 'Se alle sportstilskud'
    };
    return labels[S.formal] || 'Se alle produkter';
  }

  function rebuildCollectionButton() {
    // Find den eksisterende collection-btn (kommer fra Liquid-template).
    // Vi omskriver hele dens indhold til den nye premium-pille-knap-struktur.
    // Element-id og class beholdes så event-handlers og navigation virker
    // uændret.
    var btn = document.querySelector('.collection-btn');
    if (!btn) return;

    var label = getCollectionButtonLabel();
    btn.classList.add('collection-btn-pill');
    btn.innerHTML = '<span class="collection-btn-label">' + escapeHtml(label) + '</span>'
                  + '<span class="collection-btn-arrow">→</span>';
  }

  function getProfileOpening() {
    var level = getAthleteLevel();

    // FASE 2.4.1: mave-meget-følsom og mave-ny er smeltet ind i mave-følsom.
    // Why-teksten dækker nu hele følsom-spektret med en nuanceret formulering.
    if (S.profile === 'mave-følsom') {
      return level === 'experienced'
        ? 'Du kender allerede grænserne for hvad din mave tåler under hård indsats.'
        : 'Du har en mave der bliver presset på hårde eller lange pas.';
    }
    if (S.profile === 'mave-solid') {
      return level === 'experienced'
        ? 'Din mave håndterer det meste — det giver dig flere taktiske valg.'
        : 'Du har en solid mave der tåler det meste.';
    }

    // FASE 2.4.1: svedtab-salt er smeltet ind i svedtab-højt. Saltrande er
    // nu nævnt som signal i UI'en, og why-teksten kan beskrive det implicit.
    if (S.profile === 'svedtab-højt') {
      return level === 'experienced'
        ? 'Højt svedtab — ofte med saltrande på tøjet — kræver målrettet elektrolyt-strategi.'
        : 'Du sveder meget under træning, måske med saltrande på tøjet.';
    }
    if (S.profile === 'svedtab-normal') {
      return level === 'novice'
        ? 'Du har et normalt svedtab, hvilket giver enklere valg.'
        : 'Du har et normalt svedtab.';
    }

    if (S.profile === 'restitution-hurtig') {
      return level === 'experienced'
        ? 'Kort restitutionstid kræver hurtigt-optaget protein.'
        : 'Du vil hurtigt være tilbage til næste pas.';
    }
    if (S.profile === 'restitution-protein') {
      return 'Du vil maksimere proteinindtaget.';
    }
    if (S.profile === 'restitution-vegansk') {
      return 'Du vil have plantebaseret protein.';
    }

    return '';
  }

  function getModifierOpening() {
    var mods = S.modifiers || [];
    if (mods.indexOf('med-koffein')   >= 0) return 'Du har valgt koffein.';
    if (mods.indexOf('fast-mad')      >= 0) return 'Du vil have noget fast at tygge.';
    if (mods.indexOf('med-kreatin')   >= 0) return 'Du supplerer med kreatin.';
    if (mods.indexOf('med-kulhydrat') >= 0) return 'Du vil have lidt energi i drikken.';
    if (mods.indexOf('tabletter')     >= 0) return 'Du foretrækker tabletter.';
    return '';
  }

  function getBrandCharacter(brand) {
    var chars = {
      'Maurten':            'Maurten er kendt for hydrogel-teknologi og en særligt mavevenlig profil.',
      'Precision Fuel':     'Precision Fuel står for høj-kulhydrat strategi med 2:1 ratio.',
      'Neversecond':        'Neversecond kombinerer premium-følelse med elektrolytter indbygget.',
      'SIS':                'SiS er en klassiker i cykling med pålidelig kvalitet og tyk konsistens.',
      'Tailwind':           'Tailwind er alt-i-én-løsningen elsket af ultra-atleter.',
      'näak':               'näak er trail-fokuseret med naturlige ingredienser og fast-mad-løsninger.',
      'Powerbar':           'Powerbar er den velkendte klassiker med fyldende produkter.',
      'Skratch Labs':       'Skratch Labs fokuserer på naturlige ingredienser og blide formuleringer.',
      'Pillar Performance': 'Pillar Performance laver premium-sportstilskud til restitution og performance.',
      'Beet It Sport':      'Beet It Sport er rødbede-baseret til at forbedre iltudnyttelse.',
      'Nomio':              'Nomio er dansk og fokuserer på restitutionsprodukter.',
      'PUREPOWER':          'PUREPOWER er en solid sportsnæringsbrand med bredt sortiment.'
    };
    return chars[brand] || '';
  }

  // ══════════════════════════════════════════════════
  //  SELECT CURATED wrapper — kalder window.SportEnergyRules
  // ══════════════════════════════════════════════════
  function selectCurated(products) {
    return SR.selectCurated(products, currentGroups, S);
  }

  // ══════════════════════════════════════════════════
  //  WHY-TEKSTER (uændret fra før — bruges af Klassiker/Specialist/Variation)
  // ══════════════════════════════════════════════════
  // FASE 5.7.0: compact udelader coach-halen (levelSuffix) — på
  // match-kortene skal de tre tekster veje ens, så pris og knap kan
  // stå på samme grundlinje. Coachingen bor i mekanismen og tips.
  function getKlassikerWhy(p, compact) {
    var opening = getProfileOpening();
    var modOpen = getModifierOpening();
    var target  = getCarbTarget();
    var targetText = target ? target.display : null;
    var level   = getAthleteLevel();

    var levelSuffix = (function() {
      if (S.formal === 'energi-under') {
        if (level === 'novice') {
          return ' Start forsigtigt — øg kulhydratindtaget gradvist over flere uger træning, ikke pludseligt på race-day.';
        }
        if (level === 'experienced') {
          if (S.duration === 'over-4t') {
            return ' Roter mellem 3-4 produkttyper for at undgå smags-træthed efter time 6, og reducér kulhydrat-koncentration i sidste tredjedel hvor maven typisk bliver mere følsom.';
          }
          if (S.intensity === 'race') {
            return ' Kør den præcise sekvens du har trænet, og hold timingen — fueling-fejl på race-day er som regel for sent indtag, ikke for lidt.';
          }
          return ' Test kombinationen i dine næste lange træninger — særligt på den intensitet du planlægger til race-day.';
        }
        return '';
      }
      if (S.formal === 'hydrering') {
        if (level === 'novice') {
          return ' Begynd med standardanbefaling og juster op hvis du oplever kramper eller træthed der ikke kan forklares af træthed alene.';
        }
        if (level === 'experienced') {
          return ' Hvis du kender din svedrate fra tidligere race, kan du finjustere doseringen — typisk ligger optimal væskeindtag mellem 500-1000ml/time afhængigt af temperatur og intensitet.';
        }
        return '';
      }
      if (S.formal === 'restitution') {
        if (level === 'novice') {
          return ' Det vigtigste er at du faktisk indtager protein efter træning — produktet er sekundært til vanen.';
        }
        if (level === 'experienced') {
          return ' Hvis du træner to gange dagligt eller har race-blok, kan du øge til 30-40g protein per portion uden problemer.';
        }
        return '';
      }
      return '';
    })();
    if (compact) levelSuffix = '';

    if (S.formal === 'energi-under') {
      // FASE 2.4.1: mave-meget-følsom og mave-ny er smeltet ind i mave-følsom.
      // Why-teksten er konsolideret til én stærk formulering der virker for
      // hele følsom-spektret og specielt fremhæver Maurtens hydrogel-teknologi.
      if (S.profile === 'mave-følsom' && p.brand === 'Maurten') {
        return opening + ' Maurtens hydrogel-teknologi er udviklet netop til at undgå mave-problemer på hårde pas — produktet kapsler kulhydrat ind i en blød gel, der ikke irriterer maven. Det er et af de sikreste valg når maven er presset' + (targetText ? ', og det passer til dit mål på <strong>' + targetText + '</strong>' : '') + '.' + levelSuffix;
      }
      // FASE 5.6.0: Præcis mængde frem for kategori-etiket — atleten
      // skal kende tallet, ikke vores interne bucket.
      var carbInfo = p.carbPerPortion
        ? 'leverer <strong>' + p.carbPerPortion + ' g kulhydrat per portion</strong>'
        : (p.kulhydrat ? 'leverer <strong>' + p.kulhydrat.toLowerCase() + '</strong>' : 'er en solid baseline');
      var durTxt = S.duration === 'over-4t' ? 'på ultra-distancer'
                : S.duration === '2-4t'   ? 'på lange ture'
                : S.duration === '1-2t'   ? 'på mellemlange pas'
                : 'på kortere pas';
      var brandPart = levelSuffix ? '' : ' ' + getBrandCharacter(p.brand);
      var why = (opening ? opening + ' ' : '') + 'Det stærkeste samlede match til din situation.' + brandPart + ' Produktet ' + carbInfo + (targetText ? ', hvilket passer til dit mål på <strong>' + targetText + '</strong>' : '') + ' ' + durTxt + '.';
      if (modOpen && p.koffein === 'Med koffein') why += ' ' + modOpen + ' Dette produkt har koffein indbygget.';
      return why + levelSuffix;
    }

    if (S.formal === 'hydrering') {
      // FASE 2.4.1: svedtab-salt er smeltet ind i svedtab-højt. Hvis produktet
      // er Precision PH 1500, fremhæves det stadig som markedets højeste
      // natrium-produkt — relevant for atleter med saltrande på tøjet.
      if (S.profile === 'svedtab-højt' && (p.handle || '').toLowerCase().indexOf('ph-1500') >= 0) {
        return opening + ' Precision PH 1500 er bygget til netop din profil: 1500mg natrium per liter — det højeste på markedet og direkte målrettet høje-natrium-svedere.' + levelSuffix;
      }
      if (S.profile === 'svedtab-højt' && p.natrium === '200 mg+') {
        return opening + ' Dette produkt leverer <strong>200mg+ natrium per portion</strong> — den mængde der reelt erstatter dit høje saltspild og forebygger kramper på lange pas.' + levelSuffix;
      }
      if (S.profile === 'svedtab-højt' && p.elektrolyt === 'Komplet elektrolyt (Alle mineraler)') {
        return opening + ' Komplet elektrolyt-profil med alle mineraler (Na, K, Mg, Ca) — ikke kun natrium. Dækker hele dit elektrolyttab på lange eller varme pas.' + levelSuffix;
      }
      var hDurTxt = S.duration === 'over-4t' ? 'ultra-distancer' : S.duration === '2-4t' ? 'lange pas' : 'moderate pas';
      var hBrandPart = levelSuffix ? '' : getBrandCharacter(p.brand) + ' ';
      var hWhy = (opening ? opening + ' ' : '') + hBrandPart + 'Kombinationen af elektrolytter og format passer godt til ' + hDurTxt + '.';
      if (modOpen) hWhy += ' ' + modOpen;
      return hWhy + levelSuffix;
    }

    if (S.formal === 'restitution') {
      if (S.profile === 'restitution-hurtig' && p.protein_type === 'Hydrolyseret (avanceret)') {
        return opening + ' Hydrolyseret whey er forspaltet protein der optages markant hurtigere end almindelig whey — netop hvad du har brug for når næste pas er tæt på.' + levelSuffix;
      }
      if (S.profile === 'restitution-hurtig' && p.protein_type && p.protein_type.indexOf('Whey') >= 0) {
        return opening + ' Whey-protein optages hurtigere end plantebaseret protein og rammer aminosyre-toppen 30-60 min efter indtag — relevant når du har kort tid mellem pas.' + levelSuffix;
      }
      if (S.profile === 'restitution-protein' && p.protein === 'Højt') {
        return opening + ' Højt proteinindhold per portion — du får mest valuta for kalorierne, og dækker hele dit proteinbehov efter hård træning på én portion.' + levelSuffix;
      }
      if (S.profile === 'restitution-vegansk' && p.kosttype && p.kosttype.indexOf('Vegansk') >= 0) {
        return opening + ' Plantebaseret protein der matcher dit kostvalg uden at gå på kompromis med aminosyreprofil.' + levelSuffix;
      }
      var rBrandPart = levelSuffix ? '' : ' ' + getBrandCharacter(p.brand);
      var rWhy = (opening ? opening + ' ' : '') + 'Et solidt match til din restitution.' + rBrandPart + ' Protein og kulhydrat i en balance der understøtter genopbygning.';
      if (modOpen) rWhy += ' ' + modOpen;
      return rWhy + levelSuffix;
    }

    return 'Stærkeste match til dine valgte fokusområder. ' + getBrandCharacter(p.brand);
  }

  // FASE 2.5.1: getSpecialistWhy med klassiker-sammenligning.
  // Tager nu Bedste match (klassiker) som ekstra parameter, så tekster
  // kan referere til den relative forskel — ikke antage at Specialisten
  // altid er en opgradering. Specialisten kan være højere, lavere, eller
  // samme niveau som Bedste match — teksten skal afspejle hvad der faktisk
  // er forskellen.
  function getSpecialistWhy(p, klassiker) {
    var level = getAthleteLevel();

    if (S.formal === 'energi-under') {
      // ─── Carb-sammenligning (relativ til Bedste match) ────
      // Vi bruger carbPerPortion (mg/portion fra metafelt) for præcis
      // sammenligning, ikke kategorisk kulhydrat-tag. Hvis carbPerPortion
      // mangler på et af produkterne, falder vi tilbage til kategoriske
      // sammenligninger.
      var pCarb = p.carbPerPortion;
      var kCarb = klassiker && klassiker.carbPerPortion;
      var carbDelta = (pCarb != null && kCarb != null) ? (pCarb - kCarb) : null;

      // STEP UP (Specialisten har mere carb end Bedste match)
      if (carbDelta != null && carbDelta >= 8) {
        if (level === 'novice') {
          return 'Et stærkere valg når du har trænet maven op til at tåle højere kulhydrat-mængder. Leverer <strong>' + pCarb + 'g per portion</strong> — værd at kende, men ikke at hoppe direkte til.';
        }
        return 'Et step op i kulhydrat-densitet. <strong>' + pCarb + 'g per portion</strong> gør det lettere at ramme højere timemål uden at tage så mange produkter.';
      }

      // STEP DOWN (Specialisten har mindre carb end Bedste match)
      if (carbDelta != null && carbDelta <= -8) {
        if (level === 'novice') {
          return 'En lettere version med <strong>' + pCarb + 'g per portion</strong>. Værd at kende hvis du oplever maven bliver presset på de hårde pas — så har du et skånsomt alternativ.';
        }
        return 'En mere fordøjelig vej med <strong>' + pCarb + 'g per portion</strong>. Brug det på pas hvor du vil prioritere mave-tolerance over maksimal carb-densitet.';
      }

      // SAMME NIVEAU eller manglende data — fokuser på anden differentiering
      // 2:1 ratio er en klar formuleringsmæssig fordel
      if (p.kulhydratforhold === 'Performance: 2:1' &&
          (!klassiker || klassiker.kulhydratforhold !== 'Performance: 2:1')) {
        if (level === 'novice') {
          return 'Avanceret formulering med 2:1 ratio mellem glucose og fructose. Brug det når du har stabil fueling-strategi og vil eksperimentere med højere indtag.';
        }
        return 'Med <strong>2:1 glucose/fructose ratio</strong> — optimeret til maksimal optagelse ved høje kulhydrat-niveauer. Et oplagt valg når din mave kan lide det.';
      }

      // Koffein-differentiering (kun når atleten ikke har valgt det aktivt)
      if (p.koffein === 'Med koffein' && (S.modifiers || []).indexOf('med-koffein') < 0) {
        return 'Hvis du vil afprøve koffein på race-day. Målbar boost på 30-60 min — start med en lille mængde i træning først.';
      }

      // Maurten hydrogel når mave-solid (specifik niche-fordel)
      if (p.brand === 'Maurten' && S.profile === 'mave-solid') {
        return 'Selv med solid mave er Maurtens hydrogel et stærkt fundament — særligt når intensiteten skruer op og maven presses.';
      }

      // Andet brand-perspektiv som fallback
      return 'Et alternativ med en anden styrkeprofil end bedste match. ' + getBrandCharacter(p.brand);
    }

    if (S.formal === 'hydrering') {
      // FASE 2.5.2: Hybrid hydration+energi-egenskab er primær differentiering.
      // Hvis Specialist har kulhydrat og Bedste match ikke har det, er det
      // den vigtigste forskel — vigtigere end natrium-niveau eller format.
      var pHasCarbs = (p.kulhydrat_hydration === 'Med kulhydrat');
      var kHasCarbs = klassiker && (klassiker.kulhydrat_hydration === 'Med kulhydrat');
      if (pHasCarbs && !kHasCarbs) {
        var carbAmt = p.carbPerPortion;
        if (carbAmt != null && carbAmt > 0) {
          if (level === 'novice') {
            return 'En hybrid drikke der både hydrerer og giver energi — <strong>' + carbAmt + 'g kulhydrat per portion</strong>. Værd at kende på længere pas hvor du har brug for begge dele.';
          }
          return 'En hybrid drikke der både hydrerer og giver energi — <strong>' + carbAmt + 'g kulhydrat per portion</strong>. Oplagt på længere pas hvor du har brug for begge dele i én blanding.';
        }
        // Fallback hvis carbAmt mangler
        return 'En hybrid drikke der både hydrerer og giver energi i samme blanding. Oplagt på længere pas hvor du har brug for begge dele.';
      }

      // Hydrering-specialister: oftest opgraderinger på natrium eller bredspektrum-elektrolyt
      // Lad os også her tjekke relativ forskel når muligt.
      var pSodium = p.sodiumPerPortion;
      var kSodium = klassiker && klassiker.sodiumPerPortion;

      // STEP UP: markant højere natrium end Bedste match
      if (pSodium != null && kSodium != null && pSodium >= kSodium + 200) {
        if (level === 'novice') {
          return 'Højere natrium-indhold (' + pSodium + 'mg per portion). Godt at kende til hvis du senere oplever kramper eller skal træne i varme — ikke nødvendigt fra start.';
        }
        return 'Højere natrium-indhold (' + pSodium + 'mg per portion). Værd at have i baghånden når racet falder på en varm dag eller hvis du opdager du sveder mere end normalt.';
      }

      // Bredspektrum elektrolyt (absolut differentiering)
      if (p.elektrolyt === 'Komplet elektrolyt (Alle mineraler)' &&
          (!klassiker || klassiker.elektrolyt !== 'Komplet elektrolyt (Alle mineraler)')) {
        if (level === 'novice') {
          return 'Komplet elektrolyt-profil med alle mineraler. Et opgrader-valg når du har bygget basis-rutinen og vil dække hele elektrolyttabet.';
        }
        return 'Komplet elektrolyt-profil med alle mineraler. Et opgrader-valg hvis du vil dække hele elektrolyttabet og ikke kun natrium.';
      }

      // Tablet-format (når Bedste match er pulver)
      var t = (p.title || '').toLowerCase();
      var kt = klassiker ? (klassiker.title || '').toLowerCase() : '';
      if (t.indexOf('tablet') >= 0 && kt.indexOf('tablet') < 0) {
        return 'Tabletter er kompakte og lettere at have med i tasken. Praktisk når du vil have elektrolytter uden flydende blandinger.';
      }
      // Pulver-format (når Bedste match er tablet)
      if (kt.indexOf('tablet') >= 0 && t.indexOf('tablet') < 0) {
        return 'Pulver-format giver mulighed for at justere koncentrationen i flasken. Praktisk når du vil have mere kontrol end tabletter giver.';
      }

      return 'Et alternativ med en anden tilgang. ' + getBrandCharacter(p.brand);
    }

    if (S.formal === 'restitution') {
      // FASE 2.5.2: Restitution-grene reorganiseret så protein-niveau-
      // sammenligning sker FØR hydrolyseret-tjek. Det sikrer at vi ikke
      // kalder noget en "opgradering" hvis det faktisk har lavere protein
      // end Bedste match. Atleten skal kende trade-offen.
      var pProtein_r = p.proteinPerPortion;
      var kProtein_r = klassiker && klassiker.proteinPerPortion;
      var proteinDelta = (pProtein_r != null && kProtein_r != null) ? (pProtein_r - kProtein_r) : null;
      var pIsHydrolyseret = (p.protein_type === 'Hydrolyseret (avanceret)');
      var kIsHydrolyseret = klassiker && (klassiker.protein_type === 'Hydrolyseret (avanceret)');

      // STEP UP: Specialist har markant højere protein end Bedste match
      if (proteinDelta != null && proteinDelta >= 5) {
        if (pIsHydrolyseret && !kIsHydrolyseret) {
          return 'Højere proteinindhold (<strong>' + pProtein_r + 'g per portion</strong>) OG hydrolyseret whey for hurtigere optagelse — opgrader-valg når både mængde og timing tæller.';
        }
        return 'Højere proteinindhold (<strong>' + pProtein_r + 'g per portion</strong>) — alternativ hvis du vil maksimere proteinet uden flere portioner.';
      }

      // TRADE-OFF: Specialist er hydrolyseret men har LAVERE protein end Bedste match
      // — det er ikke en ren opgradering, men en bytte: mindre protein for hurtigere optagelse.
      if (pIsHydrolyseret && !kIsHydrolyseret) {
        if (proteinDelta != null && proteinDelta <= -5) {
          if (level === 'novice') {
            return 'Hydrolyseret whey er hurtigere optaget end almindelig whey — men leverer mindre protein per portion (<strong>' + pProtein_r + 'g</strong> vs ' + kProtein_r + 'g i bedste match). Relevant hvis timing vejer tungere end ren mængde.';
          }
          return 'Hydrolyseret whey for hurtigere optagelse — men med mindre protein per portion (<strong>' + pProtein_r + 'g</strong> vs ' + kProtein_r + 'g). En trade-off du tager når timing er vigtigere end ren mængde, fx mellem to træninger samme dag.';
        }
        // Hydrolyseret med samme eller lidt lavere protein (delta < 5g) — stadig opgradering
        if (S.profile !== 'restitution-hurtig') {
          if (level === 'novice') {
            return 'Hydrolyseret whey er hurtigere optaget end almindelig whey. Relevant senere, når du har kort tid mellem træningspas — ikke nødvendigt fra start.';
          }
          return 'Hydrolyseret whey som opgrader-valg når timing betyder mest — fx mellem to træninger samme dag.';
        }
      }

      // Vegansk (alternativ kost-tilgang, ikke nødvendigvis opgradering)
      if (p.kosttype && p.kosttype.indexOf('Vegansk') >= 0 && S.profile !== 'restitution-vegansk' &&
          (!klassiker || !klassiker.kosttype || klassiker.kosttype.indexOf('Vegansk') < 0)) {
        return 'Plantebaseret alternativ. Nogle finder det lettere fordøjeligt end whey, og passer til flere kostvalg.';
      }

      // Fallback til kategorisk hvis ikke alle data er der
      if (p.protein === 'Højt' && (!klassiker || klassiker.protein !== 'Højt') && S.profile !== 'restitution-protein') {
        return 'Højt proteinindhold per portion — alternativ hvis du vil maksimere proteinet uden flere portioner.';
      }
      return 'Et alternativ med en anden proteinstrategi. ' + getBrandCharacter(p.brand);
    }

    return 'Et alternativ med en anden tilgang. ' + getBrandCharacter(p.brand);
  }

  // FASE 2.5.0: getVariationWhy refokuseret på SUPPLEMENT-rolle.
  // "Tag også" er nu kun aktiv på energi-under (supplerer hovednæring).
  // På andre formål returnerer pickClassicTrio null for variation, så denne
  // funktion kaldes ikke der. Vi beholder fallback-tekster for sikkerhed.
  function getVariationWhy(p) {
    var format = getProductFormat(p);

    if (S.formal === 'energi-under') {
      // Tag også er supplement til hovednæring (gel/drink). Forklar HVORDAN
      // det supplerer — ikke bare at det er "andet brand".
      if (format === 'waffle') return 'Tag den her ved siden af din hovedfueling. Fast tygge-følelse bryder monotonien efter 2 timer, hvor maven sætter pris på lidt variation fra gels.';
      if (format === 'bar')    return 'Tag den her ved siden af. En bar omkring midtvejs giver mæthed og tyggelig tekstur — perfekt på lange pas hvor gels alene bliver kedelige.';
      if (format === 'chew')   return 'Tag dem her som supplement til din hovedfueling. Nemme at dosere én ad gangen, og giver tyggelig variation når du har brug for noget andet end gel.';
      if (format === 'solid')  return 'Tag dem her som supplement. Faste blokke med kulhydrat i tygge-format — god afveksling fra gels på lange ture, og lettere at dosere end bars.';
      // Fallback hvis algoritmen returnerer noget andet (skulle ikke ske
      // efter rules-opstramning, men beskytter mod fejl).
      return 'Tag den ved siden af din hovedfueling. ' + getBrandCharacter(p.brand) + ' God afveksling på lange pas.';
    }

    // De følgende grene burde ikke nås — pickClassicTrio returnerer null
    // for variation på alt andet end energi-under. Defensivt fallback:
    if (S.formal === 'hydrering') {
      return 'Et alternativt format eller brand. ' + getBrandCharacter(p.brand);
    }
    if (S.formal === 'restitution') {
      if (p.kosttype && p.kosttype.indexOf('Vegansk') >= 0) {
        return 'Plantebaseret alternativ. Passer til flere kostvalg og nogle finder det lettere fordøjeligt end whey.';
      }
      return 'Anderledes brand og profil end bedste match. ' + getBrandCharacter(p.brand);
    }
    return 'Anderledes brand og profil end bedste match. ' + getBrandCharacter(p.brand);
  }

  // ══════════════════════════════════════════════════
  //  FIX 4: WHY-TEKSTER FOR MULTI-SELECT KATEGORI-CARDS
  // ══════════════════════════════════════════════════
  function getMultiCategoryWhy(p, label) {
    var brand = p.brand || '';
    if (label.indexOf('søvn') >= 0) {
      return 'Magnesium og hvile-fokuserede tilskud forbedrer søvnkvalitet og natlig restitution. ' + getBrandCharacter(brand);
    }
    if (label.indexOf('skadesforebyggelse') >= 0) {
      return 'Kollagen og led-supportende tilskud reducerer skadesrisiko ved hård træningsbelastning. ' + getBrandCharacter(brand);
    }
    if (label.indexOf('immunforsvar') >= 0) {
      return 'D-vitamin, C-vitamin og zink supporterer immunforsvaret særligt i hårde træningsperioder. ' + getBrandCharacter(brand);
    }
    if (label.indexOf('performance') >= 0) {
      return 'Kreatin, nitrat eller koffein giver målbar boost af præstation. Bruges som planlagt strategi. ' + getBrandCharacter(brand);
    }
    if (label.indexOf('mental') >= 0) {
      return 'Mental fokus-tilskud holder skarpheden på lange træninger. ' + getBrandCharacter(brand);
    }
    return getBrandCharacter(brand);
  }

  // ══════════════════════════════════════════════════
  //  CURATED CARDS — HTML-rendering
  // ══════════════════════════════════════════════════
  function buildCuratedSpecs(p) {
    var specs = [];
    var mods = S.modifiers || [];

    if (S.formal === 'energi-under') {
      if (p.kulhydrat) {
        // FASE 2.4.1: mave-følsom dækker nu hele følsom-spektret.
        // Standard 30-40g fremhæves som sikkert valg for følsom mave.
        var isStandardSafe = S.profile === 'mave-følsom'
                          && p.kulhydrat === 'Standard (30–40 g)';
        specs.push({text: p.kulhydrat, highlight: isStandardSafe});
      }
      if (p.kulhydratforhold) {
        specs.push({text: p.kulhydratforhold, highlight: false});
      }
      if (p.koffein === 'Med koffein') {
        specs.push({text: 'Koffein', highlight: mods.indexOf('med-koffein') >= 0});
      }
    } else if (S.formal === 'hydrering') {
      if (p.elektrolyt) {
        // FASE 2.4.1: svedtab-salt smeltet ind i svedtab-højt — kun én check nu.
        var isCompleteAndRelevant = p.elektrolyt === 'Komplet elektrolyt (Alle mineraler)'
                                 && S.profile === 'svedtab-højt';
        specs.push({text: p.elektrolyt, highlight: isCompleteAndRelevant});
      }
      if (p.natrium) {
        var isHighSodiumRelevant = p.natrium === '200 mg+' && S.profile === 'svedtab-højt';
        specs.push({text: 'Natrium: ' + p.natrium, highlight: isHighSodiumRelevant});
      }
    } else if (S.formal === 'restitution') {
      if (p.protein) {
        var isHighProteinRelevant = p.protein === 'Højt' && S.profile === 'restitution-protein';
        specs.push({text: 'Protein: ' + p.protein, highlight: isHighProteinRelevant});
      }
      if (p.protein_type) {
        var isFastAbsorptionRelevant = (p.protein_type === 'Hydrolyseret (avanceret)' || p.protein_type.indexOf('Whey') >= 0)
                                    && S.profile === 'restitution-hurtig';
        specs.push({text: p.protein_type, highlight: isFastAbsorptionRelevant});
      }
    }

    // FASE 5.8.1: Vegansk-chippen vises kun når den er relevant —
    // vegansk profil eller aktivt vegansk-filter. Ellers fylder den
    // på hvert andet kort uden at hjælpe valget.
    if (p.kosttype && p.kosttype.indexOf('Vegansk') >= 0) {
      var isVeganRelevant = S.profile === 'restitution-vegansk';
      var veganFilterOn = (S.activeFilters || []).indexOf('vegansk') >= 0
                       || (S.advancedFilters || []).indexOf('vegansk') >= 0;
      if (isVeganRelevant || veganFilterOn) {
        specs.push({text: 'Vegansk', highlight: isVeganRelevant});
      }
    }

    return specs;
  }

  // FASE 2.7.0: Mængdelinje på curated-cards. Regner kulhydrat-målet om
  // til konkrete antal — det sidste skridt atleten ellers selv skulle
  // tage. Selve beregningen ligger i rules-modulet; her formáteres kun
  // dansk tekst. Eksempler:
  //   '3–4 gels i timen · 6–15 til hele passet'    (afgrænset varighed)
  //   '4–5 gels i timen · mindst 15 til hele passet'  (over 4 timer)
  //   '2 gels i timen'                             (under 1 time)
  // FASE 5.8.0: gels/barer i hele enheder; pulver/chews i halve.
  function fmtQtyNum(n) {
    return ('' + n).replace('.', ',');
  }

  // FASE 2.14.3: Ental ved n <= 1 — '0,5 gel i timen', ikke '0,5 gels'.
  // Rammer multi-serving produkter (PF 300 Flow Gel: 300 g pr. flaske).
  function qtyUnitWord(unit, n) {
    if (unit === 'gel') return n <= 1 ? 'gel' : 'gels';
    if (unit === 'bar') return n <= 1 ? 'bar' : 'barer';
    return n <= 1 ? 'portion' : 'portioner';
  }

  function buildQuantityLine(p) {
    if (typeof SR.getQuantityEstimate !== 'function') return '';
    var q = SR.getQuantityEstimate(p, S);
    if (!q) return '';

    var perHour = (q.perHourMin === q.perHourMax)
      ? fmtQtyNum(q.perHourMin)
      : fmtQtyNum(q.perHourMin) + '–' + fmtQtyNum(q.perHourMax);
    var line = perHour + ' ' + qtyUnitWord(q.unit, q.perHourMax) + ' i timen';

    if (q.totalMin && q.totalMax) {
      line += ' · ' + (q.totalMin === q.totalMax
        ? q.totalMin
        : q.totalMin + '–' + q.totalMax) + ' til hele passet';
    } else if (q.totalMin) {
      line += ' · mindst ' + q.totalMin + ' til hele passet';
    }
    return line;
  }

  // FASE 5.8.0: Fælles faktuel bund til kort 2-3 — samme oplysninger
  // som kort 1 (gram per portion, atletens mål, varigheds-kontekst).
  // Springes over hvis teksten allerede nævner portions-tallet, eller
  // når data mangler.
  function buildWhyFactTail(p, existing) {
    if (S.formal !== 'energi-under') return '';
    if (!p || !p.carbPerPortion) return '';
    var target = getCarbTarget();
    var durTxt = S.duration === 'over-4t' ? 'på ultra-distancer'
              : S.duration === '2-4t'   ? 'på lange ture'
              : S.duration === '1-2t'   ? 'på mellemlange pas'
              : 'på kortere pas';
    if (existing && existing.indexOf('per portion') >= 0) {
      // Grammet er allerede nævnt i teksten — fyld kun mål og
      // varigheds-kontekst på, så længden følger de andre kort.
      return (target && target.display)
        ? ' Det passer til dit mål på <strong>' + target.display + '</strong> ' + durTxt + '.'
        : '';
    }
    return ' Produktet leverer <strong>' + p.carbPerPortion + ' g kulhydrat per portion</strong>'
      + (target && target.display ? ', hvilket passer til dit mål på <strong>' + target.display + '</strong>' : '')
      + ' ' + durTxt + '.';
  }

  // FASE 2.5.6: Tilføjet source-mapping fra label så klik bliver tracked korrekt.
  function buildCuratedCard(p, label, why, rankIdx) {
    // FASE 5.6.0: Source følger rangen (etiketten er nu fælles for
    // alle tre). Rang 1 beholder 'klassiker' så funnel-historikken
    // er ubrudt.
    var isRank = typeof rankIdx === 'number';
    var source = isRank
      ? (rankIdx === 0 ? 'klassiker' : 'match' + (rankIdx + 1))
      : (label === 'Specialisten' ? 'specialist'
        : label === 'Tag også'    ? 'variation'
        : 'curated');
    var isSel = isRank && rankIdx === resultUI.matchIdx;
    var specs = buildCuratedSpecs(p);

    // FASE 2.7.0: Mængdelinje — kun energi-under og kun når
    // carbPerPortion er kendt (ellers tom streng, ingen linje).
    var qtyLine = buildQuantityLine(p);
    var qtyHtml = qtyLine
      ? '<div class="curated-qty">' + escapeHtml(qtyLine) + '</div>'
      : '';
    var imageHtml = p.image
      ? '<img src="' + p.image + '" alt="' + escapeHtml(p.name || p.title || '') + '" loading="lazy">'
      : '<span class="curated-img-placeholder">' + escapeHtml(p.brand || '') + '<br>' + escapeHtml(p.name || '') + '</span>';

    // FASE 2.3.3: Pris-display.
    var priceText = p.price_kr != null ? Math.round(parseFloat(p.price_kr)) + ' kr' : '';
    var priceHtml = priceText
      ? '<div class="curated-price-row"><span class="curated-price">' + escapeHtml(priceText) + '</span></div>'
      : '';

    // FASE 2.3.2: "Læg i kurv"-knap.
    var hasVariant = p.default_variant_id && p.default_variant_id !== 0;
    var ctaHtml = hasVariant
      ? '<button class="curated-cta" onclick="SEG.addToCart(\'' + p.handle + '\', \'' + source + '\')">Læg i kurv</button>'
      : '<button class="curated-cta disabled" disabled>Udsolgt</button>';

    var cardOpen = isRank
      ? '<div class="curated-card gd-match' + (isSel ? ' gd-sel' : '') + '" data-idx="' + rankIdx + '" data-product-handle="' + escapeHtml(p.handle) + '" role="button" tabindex="0" aria-pressed="' + (isSel ? 'true' : 'false') + '" onclick="SEG.selectMatch(' + rankIdx + ', event)" onkeydown="SEG.matchKeydown(event, ' + rankIdx + ')">'
      : '<div class="curated-card" data-product-handle="' + escapeHtml(p.handle) + '">';
    var stripHtml = isRank
      ? '<div class="curated-label-strip gd-match-strip">'
          + '<span class="gd-rank" aria-hidden="true">' + (rankIdx + 1) + '</span>'
          + '<span class="gd-match-label">' + escapeHtml(label) + '</span>'
          + '<span class="gd-pick">Valgt</span>'
        + '</div>'
      : '<div class="curated-label-strip">' + escapeHtml(label) + '</div>';
    return ''
      + cardOpen
        + stripHtml
        + '<a class="curated-img" href="' + escapeHtml(productHref(p)) + '" tabindex="-1" aria-hidden="true" onclick="return SEG.goToProduct(\'' + p.handle + '\', \'' + source + '\')">'
          + imageHtml
        + '</a>'
        + '<div class="curated-body">'
          + '<div class="curated-brand">' + escapeHtml(p.brand || '') + '</div>'
          + '<a class="curated-name" href="' + escapeHtml(productHref(p)) + '" onclick="return SEG.goToProduct(\'' + p.handle + '\', \'' + source + '\')">' + escapeHtml(p.name || p.title || '') + '</a>'
          + '<div class="curated-why">' + why + '</div>'
          // FASE 5.8.0: Læs mere — klampen forkorter, knappen udvider.
          // Skjult som udgangspunkt; setupWhyToggles viser den kun
          // hvor teksten reelt er klippet.
          + '<button type="button" class="curated-why-more" hidden aria-expanded="false" onclick="SEG.toggleWhy(this, event)">Læs mere<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>'
          + '<div class="curated-specs">'
            + specs.map(function(s) {
                return '<span class="curated-spec' + (s.highlight ? ' highlight' : '') + '">' + escapeHtml(s.text) + '</span>';
              }).join('')
          + '</div>'
          + qtyHtml
          + priceHtml
          + ctaHtml
        + '</div>'
      + '</div>';
  }

  function buildCuratedSection() {
    var curated = selectCurated(currentMatched);
    currentCurated = curated; // FASE 2.8.0: bruges af kit-kortet
    var curatedEl = document.getElementById('r-curated');
    if (!curatedEl) return;

    var cards = [];
    var subTitle = '';  // sættes dynamisk baseret på antal kort

    if (curated.multiCards) {
      if (curated.multiCards.length === 0) {
        curatedEl.innerHTML = '';
        return;
      }
      cards = curated.multiCards.map(function(item) {
        return buildCuratedCard(item.product, item.label, getMultiCategoryWhy(item.product, item.label));
      });
      subTitle = curated.multiCards.length === 1
        ? 'Anbefaling til dit fokusområde'
        : 'En anbefaling til hvert af dine fokusområder';
    } else {
      if (!curated.klassiker) {
        curatedEl.innerHTML = '';
        return;
      }

      var modsForCard = S.modifiers || [];
      var atletWantsCaffeine = modsForCard.indexOf('med-koffein') >= 0;
      function addCaffeinePrefix(product, why) {
        if (product.koffein === 'Med koffein' && !atletWantsCaffeine) {
          return 'Med koffein-boost. ' + why;
        }
        return why;
      }

      // FASE 5.2.0: Tre rangerede match. Motoren scorer hele
      // sortimentet — nu viser vi rangeringen ærligt i stedet for ét
      // Bedste match plus to begrebskategorier atleterne ikke forstod.
      // Specialisten og Tag også er udgået (FASE 5.6.0) — chips
      // som 'Med koffein' og 'Noget fast at tygge' dækker behovet.
      currentTop = (typeof SR.selectTopMatches === 'function')
        ? SR.selectTopMatches(currentMatched, currentGroups, S, 3)
        : [];
      if (currentTop.length === 0) currentTop = [curated.klassiker];
      if (resultUI.matchIdx >= currentTop.length) resultUI.matchIdx = 0;

      // FASE 5.6.0: Alle tre ER bedste match — rangering uden
      // degradering. Chippen viser rækkefølgen, etiketten er fælles.
      // FASE 5.8.0: Fuld tekst på alle tre kort — klampen + Læs mere
      // styrer højden, ikke teksten. Kort 2-3 får samme faktuelle
      // bund som kort 1 (gram, mål, varighed), så længderne følges ad.
      cards = currentTop.map(function(p, idx) {
        var why = idx === 0
          ? getKlassikerWhy(p, false)
          : addCaffeinePrefix(p, getSpecialistWhy(p, currentTop[0]));
        if (idx > 0) why += buildWhyFactTail(p, why);
        return buildCuratedCard(p, 'Top match', why, idx);
      });
    }

    // FASE 2.5.0: Dynamisk subtitle baseret på faktisk antal kort.
    // Multi-cards branch (sportstilskud-fokusområder) har sat subTitle
    // selv ovenfor — vi rører den ikke. Normal-grenen sætter den her.
    if (!subTitle) {
      if (cards.length === 1) {
        subTitle = 'Vores anbefaling til din situation';
      } else if (S.formal === 'energi-under') {
        // FASE 5.6.0: Alle tre er svaret — valget styrer planen.
        subTitle = 'Alle tre er stærke match til dit pas — vælg det din plan skal bygge på';
      } else {
        subTitle = 'Alle er stærke match til din situation — vælg det der passer dig bedst';
      }
    }

    if (cards.length === 0) {
      curatedEl.innerHTML = '';
      return;
    }

    curatedEl.innerHTML = ''
      + '<div class="curated-section">'
        + '<div class="curated-header">'
          + '<span class="curated-title">Dine 3 bedste match</span>'
          + '<span class="curated-sub">' + escapeHtml(subTitle) + '</span>'
        + '</div>'
        + '<div class="curated-grid">' + cards.join('') + '</div>'
      + '</div>';

    setTimeout(function() {
      try { setupCuratedCarousel(); } catch (e) { console.error('Carousel setup error:', e); }
      try { setupWhyToggles(); } catch (e) {}
    }, 50);
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.11.0: FORTSÆT HVOR DU SLAP (PERSISTENS)
  // ══════════════════════════════════════════════════
  // Snapshot af seneste færdige resultat i localStorage. Genbesøg
  // uden URL-state får et stille kort på trin 1. Afvis sletter —
  // at gemme videre mod atletens ønske ville være forkert.
  var CONTINUE_KEY = 'seg_last_result_v1';
  var CONTINUE_TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 dage

  // FASE 2.12.1: guide_continue_shown må kun fyre én gang pr. page-load
  // — genopfriskninger af kortet (efter save/reset) er stille.
  var continueShownTracked = false;

  function saveLastResult() {
    try {
      localStorage.setItem(CONTINUE_KEY, JSON.stringify({
        v: 1,
        ts: Date.now(),
        formal: S.formal,
        sport: S.sport,
        duration: S.duration,
        durationMin: S.durationMin,
        sweatRateMl: S.sweatRateMl,
        intensity: S.intensity,
        profile: S.profile,
        modifiers: (S.modifiers || []).slice()
      }));
    } catch (e) { /* private mode mv. — persistens er nice-to-have */ }
    // FASE 2.12.1: Hold trin 1-kortet synkront med seneste snapshot,
    // så tilbage-navigation aldrig viser et forældet resumé.
    renderContinueCard();
  }

  function loadLastResult() {
    try {
      var raw = localStorage.getItem(CONTINUE_KEY);
      if (!raw) return null;
      var snap = JSON.parse(raw);
      if (!snap || snap.v !== 1) return null;
      if (Date.now() - snap.ts > CONTINUE_TTL_MS) {
        localStorage.removeItem(CONTINUE_KEY);
        return null;
      }
      var validFormal = ['energi-under', 'hydrering', 'restitution', 'sportstilskud'];
      if (validFormal.indexOf(snap.formal) < 0 || !snap.profile) return null;
      return snap;
    } catch (e) { return null; }
  }

  function clearLastResult() {
    try { localStorage.removeItem(CONTINUE_KEY); } catch (e) {}
  }

  function continueSummaryLabel(snap) {
    var formalLabels = {
      'energi-under': 'Energi',
      'hydrering': 'Hydrering',
      'restitution': 'Restitution',
      'sportstilskud': 'Sportstilskud'
    };
    function lookup(opts, v, short) {
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].v === v) return short ? (opts[i].lShort || opts[i].l) : opts[i].l;
      }
      return '';
    }
    var parts = [formalLabels[snap.formal] || ''];
    if (snap.sport) parts.push(lookup(sportOpts, snap.sport));
    if (snap.durationMin) parts.push(formatMinutes(snap.durationMin));
    else if (snap.duration) parts.push(lookup(durOpts, snap.duration));
    if (snap.intensity) parts.push(lookup(intensityOpts, snap.intensity, true));
    return parts.filter(Boolean).join(' · ');
  }

  function renderContinueCard() {
    var el = document.getElementById('s1-continue');
    if (!el) return;
    var snap = loadLastResult();
    if (!snap) { el.innerHTML = ''; return; }
    el.innerHTML = ''
      + '<div class="continue-card">'
        + '<div class="continue-text">'
          + '<div class="continue-kicker">Fortsæt hvor du slap</div>'
          + '<div class="continue-summary">' + escapeHtml(continueSummaryLabel(snap)) + '</div>'
        + '</div>'
        + '<button type="button" class="continue-cta" onclick="SEG.continueLastResult()">Vis min anbefaling</button>'
        + '<button type="button" class="continue-dismiss" aria-label="Fjern gemt anbefaling" onclick="SEG.dismissContinue()">×</button>'
      + '</div>';
    if (!continueShownTracked) {
      continueShownTracked = true;
      seg_track('guide_continue_shown', { formal: snap.formal });
    }
  }

  function continueLastResult() {
    var snap = loadLastResult();
    if (!snap) return;
    S.formal = snap.formal;
    S.sport = snap.sport;
    S.duration = snap.duration;
    S.durationMin = snap.durationMin || null;
    S.sweatRateMl = snap.sweatRateMl || null;
    S.intensity = snap.intensity;
    S.profile = snap.profile;
    S.modifiers = (snap.modifiers || []).slice();
    S.caffeine = S.modifiers.indexOf('med-koffein') >= 0;
    seg_track('guide_continue_accepted', { formal: snap.formal });
    renderResult();
    goToStep(4);
    updateURL(true);
  }

  function dismissContinue() {
    clearLastResult();
    var el = document.getElementById('s1-continue');
    if (el) el.innerHTML = '';
    seg_track('guide_continue_dismissed');
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.9.0: STATE-CHIPS (DET REDIGERBARE RESULTAT)
  // ══════════════════════════════════════════════════
  // Atletens valg som redigerbare chips øverst i resultatet.
  // Single-select (sport/varighed/intensitet/profil): tap åbner en
  // inline options-række, tap på option opdaterer state og
  // re-renderer hele resultatet. Toggles skifter med ét tap.
  // Renderes før noEnergyMode-mutationen, så chips altid viser
  // atletens faktiske valg — og også i empty-state, hvor de er
  // vejen ud af nul resultater. Sportstilskud (multi-select)
  // håndteres ikke af chips i denne fase — back-pillen dækker.
  var chipsOpenKey = null;
  var chipsPendingFocus = null;

  // FASE 2.10.0: Dansk tidslabel: 45 → '45 min', 120 → '2 t',
  // 210 → '3 t 30 min'.
  function formatMinutes(min) {
    var h = Math.floor(min / 60);
    var m = min % 60;
    if (h === 0) return m + ' min';
    if (m === 0) return h + ' t';
    return h + ' t ' + m + ' min';
  }

  function getChipDims() {
    if (S.formal !== 'energi-under' && S.formal !== 'hydrering' && S.formal !== 'restitution') return null;
    var dims = [{ key: 'sport', opts: sportOpts, value: S.sport }];
    if (S.formal === 'energi-under' || S.formal === 'hydrering') {
      dims.push({
        key: 'duration',
        opts: durOpts,
        value: S.duration,
        // FASE 2.10.0: præcis tid vises på chippen når den er sat
        customLabel: S.durationMin ? formatMinutes(S.durationMin) : null
      });
      dims.push({ key: 'intensity', opts: intensityOpts, value: S.intensity });
    }
    var profOpts = S.formal === 'energi-under' ? [STOMACH_SOLID, STOMACH_SENSITIVE]
                 : S.formal === 'hydrering'    ? [SWEAT_NORMAL, SWEAT_HIGH]
                 : [RECOVER_FAST, RECOVER_PROTEIN, RECOVER_VEGAN];
    dims.push({ key: 'profile', opts: profOpts, value: S.profile });
    return dims;
  }

  // Spejler toggle-logikken i getStep3Opts — hvilke modifiers giver
  // mening i den aktuelle kontekst.
  function getChipToggles() {
    if (S.formal === 'energi-under') {
      var t = [MOD_CAFFEINE];
      if (S.duration === '1-2t' || S.duration === '2-4t' || S.duration === 'over-4t') t.push(MOD_SOLID_FOOD);
      return t;
    }
    if (S.formal === 'hydrering') {
      var isLongOrRace = (S.duration === '2-4t' || S.duration === 'over-4t' || S.intensity === 'race');
      var ht = [MOD_CARB_IN_HYDR];
      if (!isLongOrRace) ht.push(MOD_TABLETS);
      return ht;
    }
    return [];
  }

  function chipLabelFor(dim) {
    if (dim.customLabel) return dim.customLabel;
    for (var i = 0; i < dim.opts.length; i++) {
      if (dim.opts[i].v === dim.value) return dim.opts[i].l;
    }
    return '';
  }

  function renderStateChips() {
    var el = document.getElementById('r-chips');
    if (!el) return;
    var dims = getChipDims();
    if (!dims) { el.innerHTML = ''; return; }

    // Sanér modifiers der ikke længere er gyldige i konteksten
    // (fx fast-mad efter skift til under 1 time).
    var validToggles = getChipToggles();
    var validValues = validToggles.map(function(t) { return t.v; });
    S.modifiers = (S.modifiers || []).filter(function(m) { return validValues.indexOf(m) >= 0; });

    var html = '<div class="state-chips" role="group" aria-label="Dine valg — tryk for at justere">';
    dims.forEach(function(d) {
      var open = chipsOpenKey === d.key;
      var label = chipLabelFor(d);
      if (!label) return; // valg uden værdi (bør ikke ske på resultatsiden)
      html += '<button type="button" class="state-chip' + (open ? ' open' : '') + '"'
        + ' id="chip-' + d.key + '"'
        + ' aria-expanded="' + (open ? 'true' : 'false') + '"'
        + (open ? ' aria-controls="chip-options"' : '')
        + ' onclick="SEG.chipToggleOpen(\'' + d.key + '\')">'
        + escapeHtml(label)
        + '<span class="state-chip-caret" aria-hidden="true">▾</span>'
        + '</button>';
    });
    validToggles.forEach(function(t) {
      var on = (S.modifiers || []).indexOf(t.v) >= 0;
      html += '<button type="button" class="state-chip toggle' + (on ? ' on' : '') + '"'
        + ' id="chip-mod-' + t.v + '"'
        + ' role="switch" aria-checked="' + (on ? 'true' : 'false') + '"'
        + ' onclick="SEG.chipToggleModifier(\'' + t.v + '\')">'
        + (on ? '' : '+ ') + escapeHtml(t.l)
        + '</button>';
    });
    html += '</div>';

    if (chipsOpenKey) {
      var openDim = null;
      dims.forEach(function(d) { if (d.key === chipsOpenKey) openDim = d; });
      if (openDim) {
        html += '<div class="chip-options" id="chip-options" role="group" aria-label="Vælg ny værdi">'
          + openDim.opts.map(function(o) {
              var sel = o.v === openDim.value;
              return '<button type="button" class="chip-opt' + (sel ? ' selected' : '') + '"'
                + ' aria-pressed="' + (sel ? 'true' : 'false') + '"'
                + ' onclick="SEG.chipPick(\'' + openDim.key + '\', \'' + o.v + '\')">'
                + escapeHtml(o.l)
                + '</button>';
            }).join('');

        // FASE 2.10.0: Præcis tid under bucket-valgene. 'input'
        // opdaterer kun labelen; 'change' committer beregningen.
        if (openDim.key === 'duration') {
          var sliderVal = S.durationMin
            || ({ 'under-1t': 45, '1-2t': 90, '2-4t': 180, 'over-4t': 300 })[S.duration]
            || 120;
          html += '<div class="chip-duration-precise">'
            + '<label class="chip-duration-label" for="chip-duration-range">'
              + 'Eller præcis tid: '
              + '<output id="chip-duration-out">' + formatMinutes(sliderVal) + '</output>'
            + '</label>'
            + '<input type="range" id="chip-duration-range" min="30" max="720" step="15"'
              + ' value="' + sliderVal + '"'
              + ' aria-valuetext="' + formatMinutes(sliderVal) + '"'
              + ' oninput="SEG.chipDurationSlide(this)"'
              + ' onchange="SEG.chipDurationCommit(this)">'
            + '</div>';
        }

        // FASE 2.13.0: Målt svedtab — kun på svedtab-chippen i
        // hydrering-flowet. Samme interaktionsmønster som varigheds-
        // slideren: 'input' = label, 'change' = commit, rækken åben.
        if (openDim.key === 'profile' && S.formal === 'hydrering') {
          var srVal = S.sweatRateMl || (S.profile === 'svedtab-højt' ? 1200 : 800);
          html += '<div class="chip-duration-precise">'
            + '<label class="chip-duration-label" for="chip-sweat-range">'
              + 'Kender du dit svedtab? '
              + '<output id="chip-sweat-out">' + (S.sweatRateMl ? S.sweatRateMl + ' ml/t' : 'Ikke målt') + '</output>'
            + '</label>'
            + '<input type="range" id="chip-sweat-range" min="400" max="2500" step="50"'
              + ' value="' + srVal + '"'
              + ' aria-valuetext="' + (S.sweatRateMl ? S.sweatRateMl + ' ml i timen' : 'Ikke målt') + '"'
              + ' oninput="SEG.chipSweatSlide(this)"'
              + ' onchange="SEG.chipSweatCommit(this)">'
            + '<div class="chip-sweat-howto">Sådan måler du: vej dig før og efter et times-pas. Hvert tabt kilo er en liter sved — læg det til, du drak undervejs.</div>'
            + (S.sweatRateMl
                ? '<button type="button" class="chip-sweat-clear" onclick="SEG.chipSweatClear()">Brug estimat i stedet</button>'
                : '')
          + '</div>';
        }

        html += '</div>';
      }
    }


    el.innerHTML = html;

    if (chipsPendingFocus) {
      var f = document.getElementById(chipsPendingFocus);
      if (f) f.focus({ preventScroll: true });
      chipsPendingFocus = null;
    }
  }

  function chipToggleOpen(key) {
    chipsOpenKey = (chipsOpenKey === key) ? null : key;
    chipsPendingFocus = 'chip-' + key;
    renderStateChips();
  }

  function chipPick(key, value) {
    var changed = false;
    if (key === 'sport')          { changed = S.sport !== value;     S.sport = value; }
    else if (key === 'duration')  {
      // FASE 2.10.0: bucket-valg nulstiller præcis tid — atleten har
      // aktivt valgt det grovere niveau.
      changed = S.duration !== value || S.durationMin !== null;
      S.duration = value;
      S.durationMin = null;
    }
    else if (key === 'intensity') { changed = S.intensity !== value; S.intensity = value; }
    else if (key === 'profile')   { changed = S.profile !== value;   S.profile = value; }
    chipsOpenKey = null;
    chipsPendingFocus = 'chip-' + key;
    if (!changed) { renderStateChips(); return; }
    seg_track('guide_chip_adjusted', { dim: key, value: value, formal: S.formal });
    renderResult();
    updateURL(true);
  }

  function chipToggleModifier(v) {
    S.modifiers = S.modifiers || [];
    var idx = S.modifiers.indexOf(v);
    if (idx >= 0) S.modifiers.splice(idx, 1);
    else S.modifiers.push(v);
    // FASE 2.12.1: Synk legacy-feltet — tips-sektionen læser S.caffeine
    // (trin 3-toggleren synker allerede; chip-vejen manglede).
    S.caffeine = S.modifiers.indexOf('med-koffein') >= 0;
    chipsPendingFocus = 'chip-mod-' + v;
    seg_track('guide_chip_adjusted', { dim: 'modifier', value: v, on: idx < 0, formal: S.formal });
    renderResult();
    updateURL(true);
  }

  // FASE 2.10.0: Slider-interaktion for præcis varighed. Rækken
  // forbliver åben efter commit — piletaster på slideren fyrer
  // 'change' pr. trin, og at smække rækken i ville være fjendsk
  // mod tastatur-brugere. Atleten lukker selv via chippen.
  function chipDurationSlide(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) return;
    var out = document.getElementById('chip-duration-out');
    if (out) out.textContent = formatMinutes(v);
    input.setAttribute('aria-valuetext', formatMinutes(v));
  }

  function chipDurationCommit(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 30 || v > 720) return;
    if (S.durationMin === v) return;
    S.durationMin = v;
    var bucket = (typeof SR.bucketFromMinutes === 'function') ? SR.bucketFromMinutes(v) : null;
    if (bucket) S.duration = bucket;
    chipsPendingFocus = 'chip-duration-range';
    seg_track('guide_chip_adjusted', { dim: 'durationMin', value: v, formal: S.formal });
    renderResult();
    updateURL(true);
  }

  // FASE 2.13.0: Svedtab-slider — samme mønster som varigheds-slideren.
  function chipSweatSlide(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) return;
    var out = document.getElementById('chip-sweat-out');
    if (out) out.textContent = v + ' ml/t';
    input.setAttribute('aria-valuetext', v + ' ml i timen');
  }

  // FASE 3.0.1: Bro til atlet-profilen (sport-energy-profile.js).
  // Graceful: mangler modulet, opfører guiden sig som før.
  function profileSweatRate() {
    return window.SportEnergyProfile
      ? window.SportEnergyProfile.getSweatRate()
      : null;
  }

  function profileWriteSweat(ml, source) {
    if (window.SportEnergyProfile) {
      window.SportEnergyProfile.setSweatRate(ml, source);
    }
  }

  function chipSweatCommit(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 400 || v > 2500) return;
    if (S.sweatRateMl === v) return;
    S.sweatRateMl = v;
    profileWriteSweat(v, 'manual'); // FASE 3.0.1: huskes på tværs af besøg
    chipsPendingFocus = 'chip-sweat-range';
    seg_track('guide_sweat_rate_set', { ml: v, profile: S.profile });
    renderResult();
    updateURL(true);
  }

  // FASE 2.14.1: Åbner svedtab-chippen direkte fra badge-hintet —
  // ét tap fra mål til måling i stedet for en tekst-instruktion.
  function openSweatSetting() {
    chipsOpenKey = 'profile';
    chipsPendingFocus = 'chip-sweat-range';
    renderStateChips();
    var el = document.getElementById('r-chips');
    if (el && el.scrollIntoView) {
      var reduce = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }

  function chipSweatClear() {
    if (S.sweatRateMl === null) return;
    // FASE 3.0.2: Profilen ryddes kun når session-tallet ER profilens
    // eget — et delt links sr må ikke trække atletens måling med ned.
    var ownNumber = S.sweatRateMl === profileSweatRate();
    S.sweatRateMl = null;
    if (ownNumber) profileWriteSweat(null); // 'brug estimat' skal holde ved næste besøg
    chipsPendingFocus = 'chip-sweat-range';
    seg_track('guide_sweat_rate_cleared');
    renderResult();
    updateURL(true);
  }

  // FASE 2.9.0: Del-link. Skriver først nuværende state til URL'en
  // (replaceState), kopierer den derefter. Clipboard API med
  // execCommand-fallback til ældre browsere.
  function copyResultLink() {
    updateURL(true);
    var url = window.location.href;

    function done(ok) {
      seg_track('guide_share_link', { ok: ok });
      var btn = document.getElementById('chip-share');
      if (!btn) return;
      btn.textContent = ok ? 'Link kopieret' : 'Kunne ikke kopiere — kopiér adressen manuelt';
      setTimeout(function() {
        var b = document.getElementById('chip-share');
        if (b) b.textContent = 'Kopiér link til din anbefaling';  // matcher knappen i handlingsrækken
      }, 2200);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function() { done(true); }, function() { done(false); });
    } else {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done(ok);
    }
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.8.0: PAK TIL PASSET (KIT-KORT)
  // ══════════════════════════════════════════════
  // Syntesen af anbefalingen: ét konkret, justerbart indkøb.
  // kitState nulstilles ved hver renderResult. Stepperen er pointen:
  // tallet er vores beregning, men atleten ejer beslutningen.

  function kitHoursLabel(hours) {
    if (hours === 1)   return '1 time';
    if (hours === 1.5) return '1½ time';
    return hours + ' timer';
  }

  function kitComputeTotal() {
    if (!kitState) return 0;
    var main = P[kitState.mainHandle];
    var total = kitState.mainQty * parseFloat(main.price_kr || 0);
    if (kitState.addonOn && kitState.addonHandle) {
      total += parseFloat(P[kitState.addonHandle].price_kr || 0);
    }
    return Math.round(total);
  }

  // ══════════════════════════════════════════════════
  //  FASE 5.2.0: MATCH-VALG — KITTET FØLGER VALGET
  // ══════════════════════════════════════════════════
  function selectMatch(i, ev) {
    // Links (produktside) og knapper (Læg i kurv) ejer deres klik.
    if (ev && ev.target && ev.target.closest && ev.target.closest('a, button, input')) return;
    if (!currentTop || !currentTop[i]) return;
    if (resultUI.matchIdx === i) return;
    resultUI.matchIdx = i;
    var els = document.querySelectorAll('#r-curated .gd-match');
    for (var c = 0; c < els.length; c++) {
      var on = parseInt(els[c].getAttribute('data-idx'), 10) === i;
      els[c].classList.toggle('gd-sel', on);
      els[c].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    renderKitCard();
    seg_track('guide_match_selected', { idx: i, handle: currentTop[i].handle });
  }

  function matchKeydown(ev, i) {
    if (!ev) return;
    if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
      if (ev.target && ev.target.closest && ev.target.closest('a, button, input')) return;
      ev.preventDefault();
      selectMatch(i, null);
    }
  }

  function renderKitCard() {
    var el = document.getElementById('r-kit');
    if (!el) return;
    el.innerHTML = '';
    kitState = null;

    // FASE 5.8.0: Kittet udgår. Ingen pakker til ét enkelt pas —
    // mængdelinjen på kortene informerer, kortene har Læg i kurv, og
    // hele løb planlægges i race-kittet (rk-bridge i handlingsrækken).
    // Koden under står urørt; genaktivering kræver kun at fjerne
    // denne return.
    return;

    // Kun energi-under. I noEnergyMode er S.formal midlertidigt
    // 'hydrering' under render, så kittet falder automatisk fra.
    if (S.formal !== 'energi-under') return;
    if (!currentCurated || !currentCurated.klassiker) return;

    // FASE 5.2.0: Kittet følger det match atleten har valgt blandt de
    // tre rangerede kort — Klassikeren er kun fallback.
    var main = (currentTop && currentTop[resultUI.matchIdx]) || currentCurated.klassiker;
    if (!main.default_variant_id || main.price_kr == null) return;
    var kq = (typeof SR.getKitQuantity === 'function')
      ? SR.getKitQuantity(main, S)
      : null;
    if (!kq) return;

    var addon = null;
    var v = currentCurated.variation;
    if (v && v.default_variant_id && v.price_kr != null && v.handle !== main.handle) {
      addon = v;
    }

    kitState = {
      mainHandle: main.handle,
      mainQty: kq.qty,
      addonHandle: addon ? addon.handle : null,
      addonOn: false,
      hours: kq.hours,
      planOpen: true,    // FASE 5.6.0: planen ER kroppen — altid synlig
      planTracked: false
    };

    var ct = getCarbTarget();
    // FASE 2.10.0: Med præcis varighed beregnes kittet til den
    // faktiske tid — 'justér op til din distance'-forbeholdet
    // gælder kun bucket-mode på over 4 timer.
    var subText;
    if (S.durationMin) {
      subText = 'Beregnet til ' + formatMinutes(S.durationMin) + ' ved ' + (ct ? ct.display : '') + '. Justér selv — du kender din mave bedst.';
    } else if (S.duration === 'over-4t') {
      subText = 'Beregnet til 4 timer ved ' + (ct ? ct.display : '') + '. Justér op til din distance — du kender din mave bedst.';
    } else {
      subText = 'Beregnet til ca. ' + kitHoursLabel(kq.hours) + ' ved ' + (ct ? ct.display : '') + '. Justér selv — du kender din mave bedst.';
    }

    // FASE 5.2.0: Hvorfor-linjen. Atleterne forstod ikke hvorfor
    // kittet findes — mekanismen først: én enhed dækker kun en del
    // af passet. Kun for enheds-formater (gel/bar); drikke og chews
    // doseres anderledes og beholder den rene beregnings-tekst.
    var unitMin = (main.carbPerPortion && kq.gMid)
      ? Math.round((main.carbPerPortion / kq.gMid) * 60)
      : null;
    var kitTitle = 'Dit pas, samlet';
    if (unitMin && kq.unit === 'gel') {
      kitTitle = 'Én gel dækker ikke et pas';
      subText = 'Én gel dækker ca. ' + unitMin + ' minutter ved dit mål. ' + subText;
    } else if (unitMin && kq.unit === 'bar') {
      kitTitle = 'Én bar dækker ikke et pas';
      subText = 'Én bar dækker ca. ' + unitMin + ' minutter ved dit mål. ' + subText;
    }

    var mainPrice = Math.round(kitState.mainQty * parseFloat(main.price_kr));
    // FASE 5.5.0: Kittet er et tilbud bag en fold — ikke et krav midt
    // på siden. Folden bærer hvorfor-linjen som titel og summen til
    // højre, så atleten ved hvad der venter, før den åbnes.
    var kitOpen = resultUI.kitOpen;
    var html = ''
      + '<button type="button" class="fold-toggle gd-kit-fold" id="kit-fold-toggle" aria-expanded="' + (kitOpen ? 'true' : 'false') + '" aria-controls="kit-fold-body" onclick="SEG.toggleKit()">'
        + '<span class="gd-fold-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4"/><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5"/></svg></span>'
        + '<span class="gd-fold-meta">'
          + '<span class="fold-kicker">Din plan til passet</span>'
          + '<span class="gd-fold-title" id="kit-title">' + escapeHtml(kitTitle) + '</span>'
        + '</span>'
        + '<span class="gd-fold-sum" id="kit-fold-sum">' + kitComputeTotal() + ' kr</span>'
        + '<span class="fold-caret gd-caret" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>'
      + '</button>'
      + '<div class="fold-body" id="kit-fold-body"' + (kitOpen ? '' : ' hidden') + '>'
      + '<section class="kit-card" aria-labelledby="kit-title">'
        + '<p class="kit-sub">' + escapeHtml(subText) + '</p>'
        + '<div class="kit-plan" id="kit-plan">' + buildKitPlanHtml() + '</div>'
        + '<div class="kit-buy-head">Pak det med</div>'
        + '<div class="kit-line">'
          + '<div class="kit-line-main">'
            + '<span class="kit-line-qty" id="kit-qty">' + kitState.mainQty + ' ×</span> '
            + '<span class="kit-line-name">' + escapeHtml((main.brand ? main.brand + ' ' : '') + (main.name || main.title || '')) + '</span>'
          + '</div>'
          + '<div class="kit-stepper" role="group" aria-label="Justér antal">'
            + '<button type="button" class="kit-step-btn" aria-label="Én færre" onclick="SEG.kitAdjust(-1)">−</button>'
            + '<button type="button" class="kit-step-btn" aria-label="Én mere" onclick="SEG.kitAdjust(1)">+</button>'
          + '</div>'
          + '<span class="kit-line-price" id="kit-main-price">' + mainPrice + ' kr</span>'
        + '</div>';

    if (addon) {
      html = html
        + '<label class="kit-addon">'
          + '<input type="checkbox" class="kit-addon-check" onchange="SEG.kitToggleAddon(this)">'
          // FASE 2.15.2: Egen tegnet boks — temaet styler native
          // checkboxes som switches (med id-scopet specificitet vi
          // ikke kan slå), så input'et skjules visuelt og boksen
          // tegnes af et span, temaet ikke kender. Input'et beholdes
          // for tastatur og skærmlæsere; label-klik rammer det stadig.
          + '<span class="kit-addon-box" aria-hidden="true"></span>'
          + '<span class="kit-addon-text">Tilføj også: ' + escapeHtml((addon.brand ? addon.brand + ' ' : '') + (addon.name || addon.title || '')) + '</span>'
          + '<span class="kit-addon-price">' + Math.round(parseFloat(addon.price_kr)) + ' kr</span>'
        + '</label>';
    }

    html = html
        + '<div class="kit-total-row">'
          + '<span class="kit-total-label">I alt</span>'
          + '<span class="kit-total" id="kit-total" aria-live="polite">' + kitComputeTotal() + ' kr</span>'
        + '</div>'
        + '<button type="button" class="kit-cta" id="kit-cta" onclick="SEG.addKitToCart()">Læg samlet i kurven</button>'
        + '<div class="kit-trust">Levering 1–2 dage · Gratis fragt over 599 kr</div>'
      + '</section>'
      + '</div>';

    el.innerHTML = html;

    // FASE 2.12.1: Track kun når kittet reelt har ændret sig.
    var kitShownKey = main.handle + ':' + kq.qty + ':' + (addon ? addon.handle : '');
    if (kitShownKey !== lastKitShownKey) {
      lastKitShownKey = kitShownKey;
      seg_track('guide_kit_shown', {
        handle: main.handle,
        qty: kq.qty,
        has_addon_option: !!addon,
        duration: S.duration,
        intensity: S.intensity
      });
    }
  }

  // FASE 5.5.0: Kit-folden.
  function toggleKit() {
    resultUI.kitOpen = !resultUI.kitOpen;
    var btn = document.getElementById('kit-fold-toggle');
    var body = document.getElementById('kit-fold-body');
    if (btn) btn.setAttribute('aria-expanded', resultUI.kitOpen ? 'true' : 'false');
    if (body) body.hidden = !resultUI.kitOpen;
    if (resultUI.kitOpen) seg_track('guide_kit_expanded', { formal: S.formal });
  }

  function kitRefreshNumbers() {
    if (!kitState) return;
    var main = P[kitState.mainHandle];
    var qtyEl = document.getElementById('kit-qty');
    if (qtyEl) qtyEl.textContent = kitState.mainQty + ' ×';
    var mp = document.getElementById('kit-main-price');
    if (mp) mp.textContent = Math.round(kitState.mainQty * parseFloat(main.price_kr)) + ' kr';
    var tot = document.getElementById('kit-total');
    if (tot) tot.textContent = kitComputeTotal() + ' kr';
    // FASE 5.5.0: Foldens sum følger med, også når folden er lukket.
    var foldSum = document.getElementById('kit-fold-sum');
    if (foldSum) foldSum.textContent = kitComputeTotal() + ' kr';
    // FASE 2.14.0: Åben plan genberegnes — reserve-linjen følger antallet.
    if (kitState.planOpen) {
      var planEl = document.getElementById('kit-plan');
      if (planEl) planEl.innerHTML = buildKitPlanHtml();
    }
  }

  function kitAdjust(delta) {
    if (!kitState) return;
    var next = kitState.mainQty + delta;
    if (next < 1 || next > 99) return;
    kitState.mainQty = next;
    kitRefreshNumbers();
    seg_track('guide_kit_adjusted', { qty: next, handle: kitState.mainHandle });
  }

  function kitToggleAddon(input) {
    if (!kitState) return;
    kitState.addonOn = !!(input && input.checked);
    kitRefreshNumbers();
  }

  function setKitCtaState(state, label) {
    var btn = document.getElementById('kit-cta');
    if (!btn) return;
    btn.classList.remove('loading', 'success', 'error');
    if (state !== 'default') btn.classList.add(state);
    btn.disabled = (state === 'loading');
    btn.textContent = label;
  }

  function addKitToCart() {
    if (!kitState || kitLoading) return;
    var main = P[kitState.mainHandle];
    if (!main || !main.default_variant_id) return;

    var items = [{ id: main.default_variant_id, quantity: kitState.mainQty }];
    var addon = kitState.addonOn && kitState.addonHandle ? P[kitState.addonHandle] : null;
    if (addon && addon.default_variant_id) {
      items.push({ id: addon.default_variant_id, quantity: 1 });
    }

    seg_track('guide_kit_add_to_cart', {
      handle: main.handle,
      qty: kitState.mainQty,
      addon: !!addon,
      total_kr: kitComputeTotal()
    });

    kitLoading = true;
    setKitCtaState('loading', 'Tilføjer…');
    setGuideCartAttributes(main.handle, 'kit');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(errData) {
          throw new Error(errData.description || errData.message || 'Kunne ikke tilføje til kurven.');
        });
      }
      return response.json();
    })
    .then(function() {
      seg_track('guide_kit_add_to_cart_success', { handle: main.handle, qty: kitState ? kitState.mainQty : null });
      refreshCartDrawer();
      setKitCtaState('success', 'Tilføjet');
      setTimeout(function() {
        var opened = openCartDrawer();
        if (!opened) showCartToast('Kittet er lagt i kurven');
        setTimeout(function() {
          setKitCtaState('default', 'Læg samlet i kurven');
          kitLoading = false;
        }, 1200);
      }, 250);
    })
    .catch(function(err) {
      console.error('[Sport Energy Guide] addKitToCart failed:', err);
      seg_track('guide_kit_add_to_cart_error', { handle: main.handle, error: err.message });
      setKitCtaState('error', 'Prøv igen');
      showCartToast(err.message || 'Kunne ikke tilføje til kurven. Prøv igen.', true);
      setTimeout(function() {
        setKitCtaState('default', 'Læg samlet i kurven');
        kitLoading = false;
      }, 2500);
    });
  }

  // ══════════════════════════════════════════════
  //  FASE 2.14.0: RACE-PLANEN
  // ══════════════════════════════════════════════════
  // Planen bygges af rules-modulets getFuelingPlan ud fra MÅLET —
  // ikke stepper-antallet. Tallet i kurven er indkøb (med reserve);
  // planen er fagligheden. Har atleten flere med end planen bruger,
  // siger reserve-linjen det ærligt.
  function fmtClock(min) {
    var h = Math.floor(min / 60);
    var m = min % 60;
    return h + ':' + ('0' + m).slice(-2);
  }

  function buildKitPlanHtml() {
    if (!kitState) return '';
    var main = P[kitState.mainHandle];
    if (!main) return '';
    var plan = (typeof SR.getFuelingPlan === 'function')
      ? SR.getFuelingPlan(main, S)
      : null;
    if (!plan) return '';

    var name = (main.brand ? main.brand + ' ' : '') + (main.name || main.title || '');
    var html = '';

    if (plan.type === 'drink') {
      html += '<div class="kit-plan-head">' + escapeHtml(name) + '</div>'
        + '<div class="kit-plan-row"><span class="kit-plan-time">Før start</span>'
        + '<span class="kit-plan-what">Bland ' + plan.portions + (plan.portions === 1 ? ' portion' : ' portioner') + ' — ca. ' + fmtQtyNum(plan.perHour) + ' i timen</span></div>'
        + '<div class="kit-plan-note">Drik jævnt fra første kvarter — små slurke hver 10.–15. minut hele vejen.</div>';
      if (plan.openEnded) {
        html += '<div class="kit-plan-note">Planen dækker de første 4 timer — bland efter samme mønster resten af vejen.</div>';
      }
      // FASE 2.14.1: Kopiér-knappen hører til begge plan-typer.
      html += '<button type="button" class="kit-plan-copy" id="kit-plan-copy" onclick="SEG.copyKitPlan()">Kopiér planen</button>';
      return html;
    }

    html += '<div class="kit-plan-head">Én ' + qtyUnitWord(plan.unit, 1) + ' cirka hver ' + plan.intervalMin + '. minut</div>';
    // FASE 2.14.1: Ultra-planer komprimeres — 36 rækker er en mur på
    // mobil. Første 10 + resumé; kopi-versionen er altid fuld (sedlen).
    var visibleSlots = plan.slots;
    var planTruncated = false;
    if (plan.slots.length > 12) {
      visibleSlots = plan.slots.slice(0, 10);
      planTruncated = true;
    }
    visibleSlots.forEach(function(slot, i) {
      var what = slot.n + '. ' + qtyUnitWord(plan.unit, 1);
      if (i === plan.caffeineIdx) what += ' — med koffein';
      var time = slot.min === 0 ? 'Før start' : fmtClock(slot.min);
      html += '<div class="kit-plan-row' + (i === plan.caffeineIdx ? ' caffeine' : '') + '">'
        + '<span class="kit-plan-time">' + time + '</span>'
        + '<span class="kit-plan-what">' + escapeHtml(what) + '</span>'
        + '</div>';
    });

    if (planTruncated) {
      var lastSlot = plan.slots[plan.slots.length - 1];
      var truncNote = '… og videre hver ' + plan.intervalMin + '. minut frem til '
        + fmtClock(lastSlot.min) + ' — ' + plan.slots.length + ' i alt. Kopiér planen for den fulde liste.';
      if (plan.caffeineIdx >= visibleSlots.length) {
        truncNote += ' Koffein-enheden ligger ved ' + fmtClock(plan.slots[plan.caffeineIdx].min) + '.';
      }
      html += '<div class="kit-plan-note">' + escapeHtml(truncNote) + '</div>';
    }

    if (kitState.mainQty > plan.slots.length) {
      html += '<div class="kit-plan-note">Du har ' + kitState.mainQty + ' med — de sidste ' + (kitState.mainQty - plan.slots.length) + ' er reserve.</div>';
    }
    html += '<div class="kit-plan-note">Drik små slurke hver 10.–15. minut hele vejen.</div>';
    if (plan.openEnded) {
      html += '<div class="kit-plan-note">Planen dækker de første 4 timer — fortsæt mønstret resten af vejen.</div>';
    }
    html += '<button type="button" class="kit-plan-copy" id="kit-plan-copy" onclick="SEG.copyKitPlan()">Kopiér planen</button>';
    return html;
  }

  function toggleKitPlan() {
    if (!kitState) return;
    var planEl = document.getElementById('kit-plan');
    var btn = document.getElementById('kit-plan-toggle');
    if (!planEl || !btn) return;
    kitState.planOpen = !kitState.planOpen;
    if (kitState.planOpen) {
      var planHtml = buildKitPlanHtml();
      if (!planHtml) { kitState.planOpen = false; return; } // FASE 2.14.1: guard
      planEl.innerHTML = planHtml;
      planEl.hidden = false;
      btn.textContent = 'Skjul race-planen';
      btn.setAttribute('aria-expanded', 'true');
      if (!kitState.planTracked) {
        kitState.planTracked = true;
        seg_track('guide_plan_shown', { handle: kitState.mainHandle, duration: S.duration, durationMin: S.durationMin });
      }
    } else {
      planEl.hidden = true;
      planEl.innerHTML = '';
      btn.textContent = 'Se din race-plan';
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  function copyKitPlan() {
    if (!kitState) return;
    var main = P[kitState.mainHandle];
    var plan = (main && typeof SR.getFuelingPlan === 'function')
      ? SR.getFuelingPlan(main, S)
      : null;
    if (!plan) return;
    var ct = getCarbTarget();
    var name = (main.brand ? main.brand + ' ' : '') + (main.name || main.title || '');
    var lines = ['Sport Energy — race-plan', name + (ct ? ' · mål ' + ct.display : ''), ''];
    if (plan.type === 'drink') {
      lines.push('Før start: bland ' + plan.portions + (plan.portions === 1 ? ' portion' : ' portioner') + ' (ca. ' + fmtQtyNum(plan.perHour) + ' i timen)');
    } else {
      plan.slots.forEach(function(slot, i) {
        var what = slot.n + '. ' + qtyUnitWord(plan.unit, 1) + (i === plan.caffeineIdx ? ' — med koffein' : '');
        lines.push((slot.min === 0 ? 'Før start' : fmtClock(slot.min)) + ' — ' + what);
      });
    }
    lines.push('');
    lines.push('Drik små slurke hver 10.–15. minut.');
    var text = lines.join('\n');

    function done(ok) {
      seg_track('guide_plan_copied', { ok: ok });
      var b = document.getElementById('kit-plan-copy');
      if (!b) return;
      b.textContent = ok ? 'Plan kopieret' : 'Kunne ikke kopiere';
      setTimeout(function() {
        var b2 = document.getElementById('kit-plan-copy');
        if (b2) b2.textContent = 'Kopiér planen';
      }, 2200);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() { done(true); }, function() { done(false); });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done(ok);
    }
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.4.0: LÆRINGSBLOK
  // ══════════════════════════════════════════════════
  // Renderer læringsblokken mellem result-banner og curated-cards.
  // Henter blokken fra window.SportEnergyLearning.getBlock(S) — som returnerer
  // {title, paragraphs[]} eller null hvis ingen relevant arketype matcher.
  // Læringsmodul er valgfrit (graceful degradation hvis ikke loadet).
  function renderLearningBlock() {
    // FASE 5.6.0: Mekanismen bor i banneret — det er en del af Din
    // personlige anbefaling, ikke en løsrevet sektion. Togglen er en
    // tydelig, trykbar række med chevron-cirkel (affordance var
    // problemet med den gamle fold).
    var legacy = document.getElementById('r-learning');
    if (legacy) legacy.innerHTML = '';
    var el = document.getElementById('banner-learning-slot');
    if (!el) return;
    if (!SL || typeof SL.getBlock !== 'function') {
      el.innerHTML = '';
      return;
    }
    var block = SL.getBlock(S);
    if (!block || !block.paragraphs || block.paragraphs.length === 0) {
      el.innerHTML = '';
      return;
    }
    var open = resultUI.learningOpen;
    var html = ''
      + '<button type="button" class="banner-learning-toggle" aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="learning-body" onclick="SEG.toggleLearning()">'
        + '<span class="banner-learning-label">Sådan tænker vi om dit pas</span>'
        + '<span class="fold-caret gd-caret gd-caret-dark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>'
      + '</button>'
      + '<div class="banner-learning-body" id="learning-body"' + (open ? '' : ' hidden') + '>'
        + block.paragraphs.map(function(p) {
            return '<p class="learning-paragraph">' + p + '</p>';
          }).join('')
      + '</div>';
    el.innerHTML = html;
    if (open) trackLearningShown();
  }

  function trackLearningShown() {
    seg_track('guide_learning_block_shown', {
      formal: S.formal || null,
      sport: S.sport || null,
      duration: S.duration || null,
      intensity: S.intensity || null,
      profile: S.profile || null
    });
  }

  function toggleLearning() {
    resultUI.learningOpen = !resultUI.learningOpen;
    renderLearningBlock();
    if (resultUI.learningOpen) seg_track('guide_learning_expanded', { formal: S.formal });
  }

  // FASE 2.15.0: Extras-folden (tips + guides) er statisk DOM i
  // liquid'en — ren hidden-toggle, ingen re-render nødvendig.
  function toggleExtras() {
    var body = document.getElementById('r-extras-body');
    var btn = document.getElementById('extras-toggle');
    if (!body || !btn) return;
    var opening = body.hidden;
    body.hidden = !opening;
    btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
    if (opening) seg_track('guide_extras_expanded', { formal: S.formal });
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.4.5: FILTER-STATUS RENDERING
  // ══════════════════════════════════════════════════
  // Når matchProducts har anvendt hardt format-filter, kan resultatet være
  // tom (EMPTY/INCOMPATIBLE) eller meget lille (LIMITED). UI'et viser så
  // en empty-state eller en banner, så atleten ser hvad deres valg betød.

  // Pæne labels for filter-navne (bruges i empty-state, banner og chips).
  // Skal matche labels brugt i Step 3 wizard-toggles (MOD_*-konstanter
  // og SUP_*-konstanter inde i buildStep3Modifiers). Hvis et filter ikke
  // er listet her, fallbackes til selve filter-id'et.
  var FILTER_LABELS = {
    // Energi-under modifiers
    'fast-mad':         'Noget fast at tygge',
    'med-koffein':      'Med koffein',
    // Hydrering modifiers
    'tabletter':        'Tabletter',
    'med-kulhydrat':    'Lidt energi i drikken',
    // Restitution modifiers
    'med-kreatin':      'Med kreatin',
    // Sportstilskud-fokusområder
    'søvn-restitution':   'Søvn & restitution',
    'skadesforebyggelse': 'Skadesforebyggelse',
    'immunforsvar':       'Immunforsvar',
    'performance':        'Performance',
    'mental-fokus':       'Mental fokus'
  };

  function getFilterLabel(name) {
    return FILTER_LABELS[name] || name;
  }

  // I sætningskontekst (empty-state/banner) skal første bogstav være lowercase
  function getFilterLabelInSentence(name) {
    var label = FILTER_LABELS[name] || name;
    return label.charAt(0).toLowerCase() + label.slice(1);
  }

  // Liste-format: "noget fast at tygge og tabletter" — bruges i banner-tekst
  function joinFilterLabels(filters) {
    var labels = filters.map(getFilterLabelInSentence);
    if (labels.length === 0) return '';
    if (labels.length === 1) return labels[0];
    if (labels.length === 2) return labels[0] + ' og ' + labels[1];
    return labels.slice(0, -1).join(', ') + ' og ' + labels[labels.length - 1];
  }

  // Fjern et specifikt filter fra S.modifiers og re-render
  function removeFilterAndRerender(filterName) {
    if (!S.modifiers) S.modifiers = [];
    var idx = S.modifiers.indexOf(filterName);
    if (idx >= 0) {
      S.modifiers.splice(idx, 1);
      seg_track('guide_filter_removed_via_empty_state', { filter: filterName });
      renderResult();
    }
  }
  // (window.SEG.removeFilter og goBackToStep3 eksponeres via PUBLIC API
  // længere nede i filen, ikke her — window.SEG-objektet skrives som
  // ét object literal og ville overskrive tidlige tildelinger.)

  // Render aktive filter-chips ovenfor curated-cards. Hver chip har label
  // og X-knap. Klik på X fjerner filteret og re-renderer resultatet.
  // Container indsættes som første barn af r-curated. Hvis ingen filtre
  // er aktive, eller curated-elementet ikke findes, returneres uden DOM-mutation.
  function renderActiveFilterChips() {
    var curatedEl = document.getElementById('r-curated');
    if (!curatedEl) return;

    // Fjern eventuel eksisterende chip-container fra forrige render
    var existing = document.getElementById('active-filter-chips');
    if (existing) existing.parentNode.removeChild(existing);

    var mods = (S.modifiers || []).slice();
    if (mods.length === 0) return;

    // Filtrer til kun de modifiers der har et label — beskytter mod
    // ukendte filter-id'er (skulle ikke ske, men gør chip-rækken robust).
    var visibleMods = mods.filter(function(m) {
      return FILTER_LABELS[m] != null;
    });
    if (visibleMods.length === 0) return;

    var chipsHtml = visibleMods.map(function(name) {
      var label = getFilterLabel(name);
      return ''
        + '<button class="active-filter-chip" '
        +     'onclick="window.SEG.removeFilter(\'' + name + '\')" '
        +     'aria-label="Fjern filter: ' + escapeHtml(label) + '">'
          + '<span class="active-filter-chip-label">' + escapeHtml(label) + '</span>'
          + '<span class="active-filter-chip-x" aria-hidden="true">'
            + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">'
              + '<line x1="18" y1="6" x2="6" y2="18"></line>'
              + '<line x1="6" y1="6" x2="18" y2="18"></line>'
            + '</svg>'
          + '</span>'
        + '</button>';
    }).join('');

    var container = document.createElement('div');
    container.id = 'active-filter-chips';
    container.className = 'active-filter-chips';
    container.innerHTML = ''
      + '<span class="active-filter-chips-label">Dine valg:</span>'
      + '<div class="active-filter-chips-row">' + chipsHtml + '</div>';

    // Indsæt FØR r-curated, så det fremstår som en separat sektion
    curatedEl.parentNode.insertBefore(container, curatedEl);
  }

  // Render empty-state inde i r-curated. Skjuler de andre sektioner.
  function renderEmptyState(filterStatus) {
    var curatedEl = document.getElementById('r-curated');
    if (!curatedEl) return;

    var blockingFilter = filterStatus.incompatibleFilter
      || (filterStatus.appliedFilters && filterStatus.appliedFilters[0])
      || null;

    var heading, body;

    if (filterStatus.status === 'INCOMPATIBLE') {
      heading = 'Dit valg passer ikke til din situation';
      body = filterStatus.incompatibleReason || 'Det valgte filter passer ikke til dette formål.';
    } else {
      // EMPTY
      var filterLabelSentence = blockingFilter ? getFilterLabelInSentence(blockingFilter) : 'dit valg';
      heading = 'Vi fandt ingen produkter der matcher';
      body = 'Vi har ingen produkter i sortimentet der matcher <strong>"'
           + escapeHtml(filterLabelSentence) + '"</strong> til netop denne situation. '
           + 'Du kan fjerne præferencen for at se de bedste alternativer, '
           + 'eller gå tilbage og justere dine valg.';
    }

    var actionRemoveLabel = blockingFilter
      ? 'Fjern "' + getFilterLabelInSentence(blockingFilter) + '"'
      : 'Fjern præference';

    var actionRemoveAttr = blockingFilter
      ? 'onclick="window.SEG.removeFilter(\'' + blockingFilter + '\')"'
      : '';

    var html = ''
      + '<div class="empty-state">'
        + '<div class="empty-state-icon" aria-hidden="true">'
          + '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
            + '<circle cx="12" cy="12" r="10"></circle>'
            + '<line x1="12" y1="8" x2="12" y2="12"></line>'
            + '<line x1="12" y1="16" x2="12.01" y2="16"></line>'
          + '</svg>'
        + '</div>'
        + '<h3 class="empty-state-heading">' + escapeHtml(heading) + '</h3>'
        + '<p class="empty-state-body">' + body + '</p>'
        + '<div class="empty-state-actions">'
          + (blockingFilter
              ? '<button class="empty-state-btn empty-state-btn-primary" ' + actionRemoveAttr + '>'
                + escapeHtml(actionRemoveLabel) + '</button>'
              : '')
          + '<button class="empty-state-btn empty-state-btn-secondary" onclick="window.SEG.goBackToStep3()">'
            + 'Gå tilbage og juster'
          + '</button>'
        + '</div>'
      + '</div>';

    curatedEl.innerHTML = html;

    // Skjul de andre result-sektioner — de er ikke relevante når der intet er at vise
    var hideEls = ['r-explore-header', 'r-grid', 'r-tabs', 'r-filters', 'r-panels'];
    hideEls.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.innerHTML = '';
    });

    seg_track('guide_empty_state_shown', {
      status: filterStatus.status,
      filter: blockingFilter,
      formal: S.formal || null
    });
  }

  // Render limited-banner over curated. Indsættes i r-curated som en
  // banner-blok før selve curated-cards.
  function renderLimitedBanner(filterStatus) {
    var curatedEl = document.getElementById('r-curated');
    if (!curatedEl) return null;

    var filtersText = joinFilterLabels(filterStatus.appliedFilters || []);
    var count = filterStatus.matchedCount;
    var produktOrd = count === 1 ? 'produkt' : 'produkter';

    var banner = ''
      + '<div class="limited-banner">'
        + '<div class="limited-banner-icon" aria-hidden="true">'
          + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'
            + '<circle cx="12" cy="12" r="10"></circle>'
            + '<line x1="12" y1="8" x2="12" y2="12"></line>'
            + '<line x1="12" y1="16" x2="12.01" y2="16"></line>'
          + '</svg>'
        + '</div>'
        + '<div class="limited-banner-text">'
          + 'Vi har <strong>' + count + ' ' + produktOrd + '</strong> der matcher '
          + '<strong>"' + escapeHtml(filtersText) + '"</strong> til din situation. '
          + 'Hvis du vil se flere muligheder, kan du fjerne præferencen.'
        + '</div>'
      + '</div>';

    return banner;
  }

  // FASE 2.15.0: Udforsk-sektionen er foldet bag headeren. Det samlede
  // antal (samme tælle-pipeline som tabs og paneler) gør togglen
  // ærlig: atleten ved hvad der venter bag klikket.
  function buildExploreHeader() {
    var el = document.getElementById('r-explore-header');
    if (!el) return;
    var total = 0;
    Object.keys(currentGroups || {}).forEach(function(t) {
      if (currentGroups[t] && currentGroups[t].length) total += visibleTabCount(t);
    });
    var open = resultUI.exploreOpen;
    el.innerHTML = ''
      + '<button type="button" class="fold-toggle explore-fold" aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="r-explore-body" onclick="SEG.toggleExplore()">'
        + '<span class="gd-fold-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg></span>'
        + '<span class="explore-fold-text gd-fold-meta">'
          + '<span class="fold-kicker">Hele sortimentet</span>'
          + '<span class="explore-title gd-fold-title">Flere matchende produkter</span>'
          + '<span class="explore-sub">' + total + (total === 1 ? ' produkt' : ' produkter') + ' — udforsk og filtrér</span>'
        + '</span>'
        + '<span class="fold-caret gd-caret" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>'
      + '</button>';
    var body = document.getElementById('r-explore-body');
    if (body) body.hidden = !open;
  }

  function toggleExplore() {
    resultUI.exploreOpen = !resultUI.exploreOpen;
    buildExploreHeader();
    updateMobileFab();
    if (resultUI.exploreOpen) seg_track('guide_explore_expanded', { formal: S.formal });
  }

  function setupCuratedCarousel() {
    var grid = document.querySelector('.curated-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.curated-card');
    if (cards.length === 0) return;

    var existingDots = document.querySelector('.curated-scroll-dots');
    if (existingDots) existingDots.remove();
    var existingHint = document.querySelector('.curated-scroll-hint');
    if (existingHint) existingHint.remove();

    var section = document.querySelector('.curated-section');
    if (!section) return;

    var dotsHtml = '<div class="curated-scroll-dots" id="curated-dots">';
    Array.prototype.forEach.call(cards, function(_, i) {
      dotsHtml += '<span class="curated-scroll-dot' + (i === 0 ? ' active' : '') + '"></span>';
    });
    dotsHtml += '</div><div class="curated-scroll-hint">Swipe for at se flere anbefalinger</div>';
    section.insertAdjacentHTML('beforeend', dotsHtml);

    var updateActiveDot = function() {
      var dots = document.querySelectorAll('.curated-scroll-dot');
      if (dots.length === 0) return;
      var scrollLeft = grid.scrollLeft;
      var cardWidth = cards[0].offsetWidth + 12;
      var activeIdx = Math.round(scrollLeft / cardWidth);
      Array.prototype.forEach.call(dots, function(d, i) {
        d.classList.toggle('active', i === Math.min(activeIdx, dots.length - 1));
      });
    };
    grid.addEventListener('scroll', updateActiveDot, {passive: true});
  }

  // FASE 5.8.0: Læs mere på match-kortene. Klampen (CSS, 6 linjer)
  // holder kort-rytmen; knappen vises kun hvor teksten reelt er
  // klippet, og udvider så atleten kan læse det hele.
  function setupWhyToggles() {
    var cards = document.querySelectorAll('#r-curated .gd-match');
    Array.prototype.forEach.call(cards, function(card) {
      var why = card.querySelector('.curated-why');
      var btn = card.querySelector('.curated-why-more');
      if (!why || !btn) return;
      btn.hidden = !(why.scrollHeight > why.clientHeight + 2);
    });
  }

  function toggleWhy(btn, ev) {
    // Knappen bor inde i et klikbart kort — valget må ikke udløses.
    if (ev && ev.stopPropagation) ev.stopPropagation();
    var card = btn.closest ? btn.closest('.gd-match') : null;
    var why = card ? card.querySelector('.curated-why') : null;
    if (!why) return;
    var open = why.classList.toggle('why-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.firstChild.nodeValue = open ? 'Vis mindre' : 'Læs mere';
    if (open) seg_track('guide_why_expanded', { handle: card.getAttribute('data-product-handle') || '' });
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  // ══════════════════════════════════════════════════
  //  FASE 2.3.2: ADD-TO-CART (Kaching cart-drawer)
  // ══════════════════════════════════════════════════
  // Tilføjer et produkt til kurven og åbner cart-drawer.
  //
  // Sport Energy bruger Kaching som cart-drawer-app. Det eksponerer et
  // globalt API på window.kachingCartApi med methods som openCart,
  // closeCart, refreshCart, getCartData. Vi kalder refreshCart for at
  // synkronisere efter Shopify cart-API kald, så åbner vi drawer'en.
  //
  // Flow:
  //   1. Slå produkt op i P-katalog via handle
  //   2. Validér default_variant_id (sat af Liquid v9.1)
  //   3. Disable knap, vis loading-state
  //   4. POST /cart/add.js med variant_id og quantity 1
  //   5. På success: refresh + open Kaching drawer
  //   6. På error: vis toast med besked
  //
  // Faglige beslutninger:
  //   - Mængde altid 1 — atleten kan justere i drawer'en
  //   - Ved fejl forbliver knappen aktiv så atleten kan prøve igen
  //   - Hvis kachingCartApi ikke findes (sjældent edge case), klikker vi
  //     på cart-icon i header som fallback

  // Tracker hvilken handle der lige nu er ved at blive lagt i kurv.
  // Forhindrer dobbelt-klik og bruges til at finde det rigtige knap-element
  // når vi skal opdatere loading-state.
  var cartLoadingHandle = null;

  function findCartButtons(handle) {
    if (!handle) return [];
    var cards = document.querySelectorAll('[data-product-handle="' + handle + '"]');
    var btns = [];
    cards.forEach(function(card) {
      var btn = card.querySelector('.btn-add, .curated-cta');
      if (btn) btns.push(btn);
    });
    return btns;
  }

  function setCartButtonState(handle, state, label) {
    var btns = findCartButtons(handle);
    btns.forEach(function(btn) {
      // Fjern alle states
      btn.classList.remove('loading', 'success', 'error');
      btn.disabled = false;

      if (state === 'loading') {
        btn.classList.add('loading');
        btn.disabled = true;
        btn.innerHTML = '<span class="btn-spinner"></span> ' + escapeHtml(label || 'Tilføjer...');
      } else if (state === 'success') {
        btn.classList.add('success');
        btn.disabled = true;
        btn.innerHTML = '✓ ' + escapeHtml(label || 'Tilføjet');
      } else if (state === 'error') {
        btn.classList.add('error');
        btn.innerHTML = escapeHtml(label || 'Prøv igen');
      } else {
        // default — tilbage til "Læg i kurv"
        btn.innerHTML = escapeHtml(label || 'Læg i kurv');
      }
    });
  }

  function showCartToast(message, isError) {
    // Brug eksisterende .toast-element hvis det findes, ellers opret
    var toast = document.querySelector('.seg-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast seg-cart-toast';
      var dot = document.createElement('span');
      dot.className = 'toast-dot';
      var msg = document.createElement('span');
      msg.className = 'toast-msg';
      toast.appendChild(dot);
      toast.appendChild(msg);
      document.body.appendChild(toast);
    }
    toast.classList.toggle('error', !!isError);
    toast.querySelector('.toast-msg').textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function() {
      toast.classList.remove('show');
    }, 3500);
  }

  // Trigger Kaching cart-drawer. Returnerer true hvis det lykkedes.
  function openCartDrawer() {
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
        window.kachingCartApi.openCart();
        return true;
      }
      // Fallback: klik på cart-icon i header
      var cartIcon = document.querySelector('.header__icon--cart, [data-cart-drawer-toggle], a[href="/cart"]');
      if (cartIcon) {
        cartIcon.click();
        return true;
      }
    } catch (e) {
      console.error('[Sport Energy Guide] openCartDrawer failed:', e);
    }
    return false;
  }

  function refreshCartDrawer() {
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
        window.kachingCartApi.refreshCart();
      }
    } catch (e) {
      console.error('[Sport Energy Guide] refreshCart failed:', e);
    }
  }

  // FASE 2.5.6: Udvidet med source-parameter + cart attributes.
  // source identificerer hvilket kort: 'klassiker', 'specialist', 'variation', 'grid'.
  // Cart attributes sættes FØR produktet tilføjes, så vi har dem klar når
  // ordren afgives. Attributes med __ prefix er "private" i Shopify — de
  // vises ikke i kurv/checkout, men er tilgængelige i Order API og admin.
  // FASE 2.5.6: Sæt cart attributes der følger med ordren.
  // Disse identificerer ordren som "kommer fra guiden" i Shopify Admin.
  // Vi bruger __ prefix for at gøre attributes private (ikke synlige i
  // checkout-flowet for atleten, men tilgængelige i Order API).
  //
  // Vi sætter kun guide-context på FØRSTE produkt der tilføjes — efterfølgende
  // klik på samme session opdaterer ikke attributes (så vi ikke overskriver
  // den oprindelige guide-source). Hvis cart er tom (fx ny session), nulstilles
  // attributes igen.
  function setGuideCartAttributes(handle, source) {
    var attrs = {
      '__guide_used': 'true',
      '__guide_source': source,
      '__guide_first_handle': handle,
      '__guide_formal': S.formal || '',
      '__guide_sport': S.sport || '',
      '__guide_profile': S.profile || '',
      '__guide_timestamp': new Date().toISOString()
    };

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function(err) {
      // Stille fejl — tracking må ikke blokere shopping-oplevelsen
      console.warn('[Sport Energy Guide] setGuideCartAttributes failed:', err);
    });
  }

  function addToCart(handle, source) {
    if (!handle) return;
    if (cartLoadingHandle === handle) return; // forhindre dobbelt-klik

    source = source || 'unknown';

    var product = (window.SportEnergyGuideData && window.SportEnergyGuideData.products || [])
      .filter(function(p) { return p.handle === handle; })[0];

    if (!product) {
      console.error('[Sport Energy Guide] addToCart: produkt ikke fundet for handle:', handle);
      showCartToast('Kunne ikke finde produktet. Prøv igen.', true);
      return;
    }

    var variantId = product.default_variant_id;
    if (!variantId || variantId === 0) {
      // Produkt er udsolgt eller har ingen tilgængelig variant
      showCartToast('Produktet er desværre udsolgt.', true);
      return;
    }

    seg_track('guide_add_to_cart_clicked', {
      handle: handle,
      source: source,
      variant_id: variantId,
      brand: product.brand || null,
      formal: S.formal || null
    });

    cartLoadingHandle = handle;
    setCartButtonState(handle, 'loading', 'Tilføjer...');

    // FASE 2.5.6: Sæt cart attributes asynkront før produkt tilføjes.
    // Vi venter ikke på resultatet — det er fire-and-forget for at undgå
    // at bremse add-to-cart-flowet hvis attributes-call fejler.
    setGuideCartAttributes(handle, source);

    // POST til Shopify cart-API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) {
        // Shopify returnerer JSON med error info ved 422 etc.
        return response.json().then(function(errData) {
          throw new Error(errData.description || errData.message || 'Kunne ikke tilføje til kurven.');
        });
      }
      return response.json();
    })
    .then(function(data) {
      // Success — refresh Kaching's cart-state og åbn drawer
      seg_track('guide_add_to_cart_success', {
        handle: handle,
        source: source,
        variant_id: variantId
      });

      refreshCartDrawer();

      // Kort delay så atleten ser "✓ Tilføjet" feedback før drawer åbner.
      // Kaching's refreshCart kan også have brug for et tick.
      setCartButtonState(handle, 'success', 'Tilføjet');

      setTimeout(function() {
        var opened = openCartDrawer();
        if (!opened) {
          // Fallback hvis hverken Kaching eller cart-icon kunne klikkes
          showCartToast('Tilføjet til kurven');
        }
        // Reset knap efter drawer er åbnet — så hvis atleten lukker drawer
        // og kommer tilbage, er knappen klar igen.
        setTimeout(function() {
          setCartButtonState(handle, 'default', 'Læg i kurv');
          cartLoadingHandle = null;
        }, 1200);
      }, 250);
    })
    .catch(function(err) {
      console.error('[Sport Energy Guide] addToCart failed:', err);
      seg_track('guide_add_to_cart_error', {
        handle: handle,
        source: source,
        variant_id: variantId,
        error: err.message
      });
      setCartButtonState(handle, 'error', 'Prøv igen');
      showCartToast(err.message || 'Kunne ikke tilføje til kurven. Prøv igen.', true);
      // Reset til normal efter 2.5s så atleten kan prøve igen
      setTimeout(function() {
        setCartButtonState(handle, 'default', 'Læg i kurv');
        cartLoadingHandle = null;
      }, 2500);
    });
  }


  // ══════════════════════════════════════════════════
  //  TRACKING
  // ══════════════════════════════════════════════════
  function seg_track(eventName, props) {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', eventName);
      if (props && typeof props === 'object') {
        for (var key in props) {
          if (Object.prototype.hasOwnProperty.call(props, key)) {
            var value = props[key];
            if (value === null || value === undefined || value === '') continue;
            window.clarity('set', 'guide_' + key, String(value));
          }
        }
      }
    } catch (e) {
      // stille fejl
    }
  }

  // ══════════════════════════════════════════════════
  //  STEP 5 — TABS, FILTRE OG PRODUKTLISTE
  // ══════════════════════════════════════════════════
  function buildTabsAndFilters() {
    var tabLabels = {
      'for':  {label:'Før træning',   labelShort:'Før',    when:'Inden start'},
      under:  {label:'Under træning', labelShort:'Under',  when:'Løbende'},
      efter:  {label:'Efter træning', labelShort:'Efter',  when:'Inden for 30–60 min'},
      daglig: {label:'Til daglig',    labelShort:'Daglig', when:'Dagligt'}
    };

    var activeTabs = ['for','under','efter','daglig'].filter(function(t) {
      return currentGroups[t] && currentGroups[t].length > 0;
    });

    if (activeTabs.indexOf(S.activeTab) < 0) {
      S.activeTab = activeTabs.indexOf('under') >= 0 ? 'under'
                  : activeTabs.indexOf('efter') >= 0 ? 'efter'
                  : activeTabs.indexOf('daglig') >= 0 ? 'daglig'
                  : activeTabs[0];
    }

    var tabsHtml = '';
    if (activeTabs.length > 1) {
      tabsHtml = '<div class="result-tabs">'
        + activeTabs.map(function(t) {
            return '<button class="tab-btn ' + (S.activeTab === t ? 'active' : '') + '" onclick="SEG.switchTab(\'' + t + '\')">'
              + '<span class="tab-btn-label-full">' + tabLabels[t].label + '</span>'
              + '<span class="tab-btn-label-short">' + tabLabels[t].labelShort + '</span>'
              + '<span class="tab-btn-count">' + visibleTabCount(t) + '</span>'
            + '</button>';
          }).join('')
      + '</div>';
    }
    var tabsWrap = document.getElementById('r-tabs-wrap');
    if (tabsWrap) tabsWrap.innerHTML = tabsHtml;

    var filterConfig = getFilterConfig(currentMatched);

    var level1Html = filterConfig.level1.map(function(f) {
      return '<button class="filter-chip ' + (S.activeFilters.indexOf(f.v) >= 0 ? 'active' : '') + (f.v === 'alle' ? ' all' : '') + '" '
        + 'onclick="SEG.toggleFilter(\'' + f.v + '\')">' + escapeHtml(f.l) + '</button>';
    }).join('');

    var level2Total = filterConfig.level2.reduce(function(sum, g) { return sum + g.options.length; }, 0);

    var moreBtn = '';
    if (level2Total > 0) {
      moreBtn = '<button class="more-filters-btn ' + (S.showAdvanced ? 'open' : '') + '" onclick="SEG.toggleAdvancedFilters()">'
        + '<span>Flere filtre</span>'
        + (S.advancedFilters.length > 0 ? '<span class="adv-count">' + S.advancedFilters.length + '</span>' : '')
        + '<span class="caret">▾</span>'
      + '</button>';
    }

    var advHtml = '';
    if (level2Total > 0) {
      advHtml = '<div class="advanced-filters ' + (S.showAdvanced ? 'open' : '') + '">'
        + filterConfig.level2.map(function(group) {
            return '<div class="filter-group">'
              + '<span class="filter-group-label">' + escapeHtml(group.label) + '</span>'
              + '<div class="filter-group-chips">'
                + group.options.map(function(f) {
                    return '<button class="filter-chip ' + (S.advancedFilters.indexOf(f.v) >= 0 ? 'active' : '') + '" '
                      + 'onclick="SEG.toggleAdvFilter(\'' + f.v + '\')">' + escapeHtml(f.l) + '</button>';
                  }).join('')
              + '</div>'
            + '</div>';
          }).join('')
      + '</div>';
    }

    var filtersWrap = document.getElementById('r-filters-wrap');
    if (filtersWrap) {
      filtersWrap.innerHTML = '<div class="filter-bar">'
        + '<div class="filter-chips">'
          + '<span class="filter-label">Filtrér</span>'
          + level1Html
          + moreBtn
        + '</div>'
        + advHtml
      + '</div>';
    }
  }

  function getFilterConfig(products) {
    var uniqueBrands = {};
    var uniqueKulhydrat = {};
    var uniqueRatio = {};
    var uniqueElektrolyt = {};
    var hasVegansk = false;
    var hasKoffein = false;

    products.forEach(function(p) {
      if (p.brand) uniqueBrands[p.brand] = true;
      if (p.kulhydrat) uniqueKulhydrat[p.kulhydrat] = true;
      if (p.kulhydratforhold) uniqueRatio[p.kulhydratforhold] = true;
      if (p.elektrolyt) uniqueElektrolyt[p.elektrolyt] = true;
      if (p.kosttype && p.kosttype.indexOf('Vegansk') >= 0) hasVegansk = true;
      if (p.koffein === 'Med koffein') hasKoffein = true;
    });

    // FASE 5.8.1: Vegansk er ikke et primært valgkriterie for de
    // fleste atleter — det bor under Flere filtre (gruppen Kost).
    var level1 = [{v:'alle', l:'Alle'}];
    if (hasKoffein) level1.push({v:'koffein-med', l:'Med koffein'});

    var level2 = [];
    if (hasVegansk) {
      level2.push({
        label: 'Kost',
        options: [{v:'vegansk', l:'Vegansk'}]
      });
    }

    var brandKeys = Object.keys(uniqueBrands);
    if (brandKeys.length > 1) {
      level2.push({
        label: 'Brand',
        options: brandKeys.sort().map(function(b) { return {v: 'br-' + b, l: b}; })
      });
    }

    var khKeys = Object.keys(uniqueKulhydrat);
    if (S.formal === 'energi-under' && khKeys.length > 1) {
      var orderMap = {'Let (0–29 g)':1, 'Standard (30–40 g)':2, 'Stor (41–59 g)':3, 'Ekstra stor (60 g+)':4};
      var sorted = khKeys.sort(function(a, b) { return (orderMap[a] || 99) - (orderMap[b] || 99); });
      level2.push({
        label: 'Kulhydrat-niveau',
        options: sorted.map(function(k) { return {v: 'kh-' + k, l: k}; })
      });
    }

    var ratioKeys = Object.keys(uniqueRatio);
    if (S.formal === 'energi-under' && ratioKeys.length > 1) {
      level2.push({
        label: 'Glucose/Fructose ratio',
        options: ratioKeys.sort().map(function(r) { return {v: 'rt-' + r, l: r}; })
      });
    }

    var elKeys = Object.keys(uniqueElektrolyt);
    if (S.formal === 'hydrering' && elKeys.length > 1) {
      level2.push({
        label: 'Elektrolyt-niveau',
        options: elKeys.sort().map(function(e) { return {v: 'el-' + e, l: e}; })
      });
    }

    return { level1: level1, level2: level2 };
  }

  function switchTab(tab) {
    S.activeTab = tab;
    seg_track('guide_tab_changed', {tab: tab});
    buildTabsAndFilters();
    renderPanels();
  }

  // FASE 2.2.3: "Se flere"-handlers.
  // expandTab udvider et tab til ny limit (24 eller alle). Den bevarer state
  // i S.expandedTabs så atleten ikke mister sin udvidelse ved tab-skift.
  // Efter render scrolles til den nye knap-position så atleten ikke skal
  // lede efter "Vis færre"-knappen.
  function expandTab(tab, newLimit) {
    S.expandedTabs[tab] = newLimit;
    seg_track('guide_show_more_clicked', {tab: tab, new_limit: newLimit});
    renderPanels();
    // Scroll til bunden af det aktive panel så atleten ser de nye produkter
    // og finder "Vis færre"-knappen umiddelbart.
    setTimeout(function() {
      var panel = document.getElementById('panel-' + tab);
      if (!panel) return;
      var btn = panel.querySelector('.btn-show-more');
      if (btn) {
        btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 80);
  }

  function collapseTab(tab) {
    delete S.expandedTabs[tab];
    seg_track('guide_show_less_clicked', {tab: tab});
    renderPanels();
    // Scroll tilbage til toppen af panelet så atleten ikke står midt i
    // grid'et med ingen kontekst om hvor de er.
    setTimeout(function() {
      var panel = document.getElementById('panel-' + tab);
      if (!panel) return;
      var rect = panel.getBoundingClientRect();
      var progressBar = document.querySelector('.progress-bar');
      var progressH = progressBar ? progressBar.getBoundingClientRect().height : 44;
      var top = rect.top + window.scrollY - progressH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 80);
  }

  function toggleFilter(filter) {
    if (filter === 'alle') {
      S.activeFilters = ['alle'];
    } else {
      S.activeFilters = S.activeFilters.filter(function(f) { return f !== 'alle'; });
      if (S.activeFilters.indexOf(filter) >= 0) {
        S.activeFilters = S.activeFilters.filter(function(f) { return f !== filter; });
      } else {
        S.activeFilters.push(filter);
      }
      if (S.activeFilters.length === 0) S.activeFilters = ['alle'];
    }
    seg_track('guide_filter_used', {filter: filter, level: 'primary'});
    buildTabsAndFilters();
    renderPanels();
  }

  function toggleAdvFilter(filter) {
    if (S.advancedFilters.indexOf(filter) >= 0) {
      S.advancedFilters = S.advancedFilters.filter(function(f) { return f !== filter; });
    } else {
      S.advancedFilters.push(filter);
    }
    seg_track('guide_filter_used', {filter: filter, level: 'advanced'});
    buildTabsAndFilters();
    renderPanels();
  }

  function toggleAdvancedFilters() {
    S.showAdvanced = !S.showAdvanced;
    buildTabsAndFilters();
  }

  // ══════════════════════════════════════════════════
  //  STEP 6 — MOBIL: BOTTOM-SHEET TIL FILTRE
  // ══════════════════════════════════════════════════
  var sheetLastFocus = null;

  function sheetKeydown(e) {
    if (e.key === 'Escape') { closeFilterSheet(); return; }
    var sh = document.getElementById('filter-sheet');
    if (sh) trapFocusKeydown(sh, e);
  }

  function openFilterSheet() {
    seg_track('guide_filter_sheet_opened');
    buildSheetContent();
    var ov = document.getElementById('sheet-overlay');
    var sh = document.getElementById('filter-sheet');
    if (ov) ov.classList.add('show');
    if (sh) sh.classList.add('show');
    document.body.style.overflow = 'hidden';
    // FASE 2.6.0: Fokus ind i sheetet + Escape og fokus-fælde aktiveres.
    sheetLastFocus = document.activeElement;
    if (sh) {
      var firstFocusable = sh.querySelector('.sheet-clear') || sh.querySelector(FOCUSABLE_SEL);
      if (firstFocusable) firstFocusable.focus();
    }
    document.addEventListener('keydown', sheetKeydown);
  }

  function closeFilterSheet() {
    var ov = document.getElementById('sheet-overlay');
    var sh = document.getElementById('filter-sheet');
    if (ov) ov.classList.remove('show');
    if (sh) sh.classList.remove('show');
    document.body.style.overflow = '';
    // FASE 2.6.0: Fjern keydown-lytter og giv fokus tilbage til
    // elementet der åbnede sheetet (typisk filter-FAB'en).
    document.removeEventListener('keydown', sheetKeydown);
    if (sheetLastFocus && typeof sheetLastFocus.focus === 'function') {
      sheetLastFocus.focus();
    }
    sheetLastFocus = null;
    buildTabsAndFilters();
    renderPanels();
    updateMobileFab();
  }

  function buildSheetContent() {
    var filterConfig = getFilterConfig(currentMatched);
    var html = '';

    if (filterConfig.level1.length > 1) {
      html += '<div class="sheet-section">'
        + '<span class="sheet-section-label">Hurtige filtre</span>'
        + '<div class="sheet-section-chips">'
          + filterConfig.level1.map(function(f) {
              return '<button class="filter-chip ' + (S.activeFilters.indexOf(f.v) >= 0 ? 'active' : '') + (f.v === 'alle' ? ' all' : '') + '" '
                + 'onclick="SEG.toggleFilterSheet(\'' + f.v + '\')">' + escapeHtml(f.l) + '</button>';
            }).join('')
        + '</div>'
      + '</div>';
    }

    filterConfig.level2.forEach(function(group) {
      html += '<div class="sheet-section">'
        + '<span class="sheet-section-label">' + escapeHtml(group.label) + '</span>'
        + '<div class="sheet-section-chips">'
          + group.options.map(function(f) {
              return '<button class="filter-chip ' + (S.advancedFilters.indexOf(f.v) >= 0 ? 'active' : '') + '" '
                + 'onclick="SEG.toggleAdvFilterSheet(\'' + f.v + '\')">' + escapeHtml(f.l) + '</button>';
            }).join('')
        + '</div>'
      + '</div>';
    });

    if (html === '') {
      html = '<div style="text-align:center;padding:40px 20px;color:var(--text-soft);font-size:13px;">Ingen filtre tilgængelige for denne kategori.</div>';
    }

    var body = document.getElementById('sheet-body');
    if (body) body.innerHTML = html;
    updateSheetCount();
  }

  function toggleFilterSheet(filter) {
    if (filter === 'alle') {
      S.activeFilters = ['alle'];
    } else {
      S.activeFilters = S.activeFilters.filter(function(f) { return f !== 'alle'; });
      if (S.activeFilters.indexOf(filter) >= 0) {
        S.activeFilters = S.activeFilters.filter(function(f) { return f !== filter; });
      } else {
        S.activeFilters.push(filter);
      }
      if (S.activeFilters.length === 0) S.activeFilters = ['alle'];
    }
    buildSheetContent();
    updateFabCount();
  }

  function toggleAdvFilterSheet(filter) {
    if (S.advancedFilters.indexOf(filter) >= 0) {
      S.advancedFilters = S.advancedFilters.filter(function(f) { return f !== filter; });
    } else {
      S.advancedFilters.push(filter);
    }
    buildSheetContent();
    updateFabCount();
  }

  function clearAllFilters() {
    S.activeFilters = ['alle'];
    S.advancedFilters = [];
    buildSheetContent();
    updateFabCount();
  }

  function updateSheetCount() {
    var countEl = document.getElementById('sheet-count');
    if (!countEl) return;
    var poolForTab = currentGroups[S.activeTab] || [];
    var filtered = filterProducts(poolForTab);
    countEl.textContent = filtered.length;
  }

  function updateFabCount() {
    var count = S.activeFilters.filter(function(f) { return f !== 'alle'; }).length + S.advancedFilters.length;
    var countEl = document.getElementById('fab-count');
    if (!countEl) return;
    if (count > 0) {
      countEl.textContent = count;
      countEl.style.display = 'inline-block';
    } else {
      countEl.style.display = 'none';
    }
  }

  var sheetStartY = 0;
  var sheetCurrentY = 0;

  function initSheetHandle() {
    var handle = document.getElementById('sheet-handle');
    var sheet = document.getElementById('filter-sheet');
    if (!handle || !sheet) return;

    function onStart(e) {
      sheetStartY = e.touches ? e.touches[0].clientY : e.clientY;
      sheetCurrentY = sheetStartY;
    }
    function onMove(e) {
      var y = e.touches ? e.touches[0].clientY : e.clientY;
      var delta = y - sheetStartY;
      if (delta > 0) {
        sheetCurrentY = y;
        sheet.style.transform = 'translateY(' + delta + 'px)';
        sheet.style.transition = 'none';
      }
    }
    function onEnd() {
      var delta = sheetCurrentY - sheetStartY;
      sheet.style.transform = '';
      sheet.style.transition = '';
      if (delta > 80) closeFilterSheet();
    }

    handle.addEventListener('touchstart', onStart, {passive: true});
    handle.addEventListener('touchmove', onMove, {passive: true});
    handle.addEventListener('touchend', onEnd);
  }

  function filterProducts(products) {
    var l1 = S.activeFilters.filter(function(f) { return f !== 'alle'; });
    var l2 = S.advancedFilters;
    var all = l1.concat(l2);

    if (all.length === 0) return products;

    return products.filter(function(p) {
      return all.every(function(f) {
        if (f.indexOf('br-') === 0) return p.brand === f.substring(3);
        if (f.indexOf('kh-') === 0) return p.kulhydrat === f.substring(3);
        if (f.indexOf('rt-') === 0) return p.kulhydratforhold === f.substring(3);
        if (f.indexOf('el-') === 0) return p.elektrolyt === f.substring(3);
        if (f === 'vegansk')        return p.kosttype && p.kosttype.indexOf('Vegansk') >= 0;
        if (f === 'koffein-med')    return p.koffein === 'Med koffein';
        return true;
      });
    });
  }

  function renderPanels() {
    var tabLabels = {
      'for':  {label:'Før træning',     when:'Inden start'},
      under:  {label:'Under træning',   when:'Løbende'},
      efter:  {label:'Efter træning',   when:'Inden for 30–60 min'},
      daglig: {label:'Til daglig brug', when:'Dagligt'}
    };

    var activeTabs = ['for','under','efter','daglig'].filter(function(t) {
      return currentGroups[t] && currentGroups[t].length > 0;
    });

    var panelsHtml = activeTabs.map(function(t) {
      var filtered = filterProducts(currentGroups[t]);

      filtered = filtered.filter(function(p) { return !p.isMaurtenAddition; });

      // FASE 5.7.0: Dedupe mod top 3 — samme pipeline som
      // visibleTabCount, så badge og panel viser samme tal.
      filtered = filtered.filter(function(p) { return !isInTopMatches(p); });

      var seenNames = {};
      filtered = filtered.filter(function(p) {
        var key = p.name || p.handle;
        if (seenNames[key]) return false;
        seenNames[key] = true;
        return true;
      });

      // FASE 5.7.0: Sortimentet er en flugtvej, ikke en omvej.
      // Default er én kompakt række (3), trinvis 3 → 12 → alle.
      // Guiden har allerede valgt for atleten — kataloget skal være
      // synligt uden at genåbne hele beslutningen (Hicks lov).
      var INITIAL_LIMIT = 3;
      var STEP_LIMIT = 12;
      var savedLimit = S.expandedTabs[t];
      var currentLimit = savedLimit || INITIAL_LIMIT;
      var totalCount = filtered.length;
      var topProducts = filtered.slice(0, currentLimit);
      var isActive = S.activeTab === t;

      var inner;
      if (topProducts.length > 0) {
        inner = '<div class="product-row">'
          + topProducts.map(function(p, i) {
              return renderProductCard(p, i === 0 && t === 'under');
            }).join('')
        + '</div>';

        // Bestem næste trin og knap-tekst.
        // Tre tilstande:
        //   1. Initial (12): vis "Se flere" der går til 24 (eller alle hvis < 24)
        //   2. Mellemtrin (24): vis "Se de sidste N" der går til alle
        //   3. Alle vist: vis "Vis færre" der reducerer til 12
        if (totalCount > INITIAL_LIMIT) {
          var btnHtml = '';
          var captionHtml = '';

          if (currentLimit >= totalCount) {
            // Tilstand 3: alle er vist
            captionHtml = 'Viser alle ' + totalCount + ' matchende produkter';
            btnHtml = '<button class="btn-show-more" onclick="SEG.collapseTab(\'' + t + '\')">'
                    + 'Vis færre'
                    + '</button>';
          } else if (currentLimit < STEP_LIMIT && totalCount > STEP_LIMIT) {
            // Tilstand 1: initial → step
            var nextStep = STEP_LIMIT;
            var moreCount = nextStep - currentLimit;
            captionHtml = 'Viser top ' + currentLimit + ' af ' + totalCount + ' matchende produkter';
            btnHtml = '<button class="btn-show-more" onclick="SEG.expandTab(\'' + t + '\', ' + nextStep + ')">'
                    + 'Se ' + moreCount + ' mere →'
                    + '</button>';
          } else {
            // Tilstand 2: step → alle (eller initial → alle hvis total <= 24)
            var remaining = totalCount - currentLimit;
            captionHtml = 'Viser top ' + currentLimit + ' af ' + totalCount + ' matchende produkter';
            btnHtml = '<button class="btn-show-more" onclick="SEG.expandTab(\'' + t + '\', ' + totalCount + ')">'
                    + 'Se de sidste ' + remaining + ' →'
                    + '</button>';
          }

          inner += '<div class="show-more-wrap">'
                 + '<div class="show-more-caption">' + captionHtml + '</div>'
                 + btnHtml
                 + '</div>';
        }
      } else {
        inner = '<div class="panel-empty">'
          + '<div class="panel-empty-icon">🔍</div>'
          + '<div>Ingen produkter matcher dine filtre i denne kategori.</div>'
        + '</div>';
      }

      return '<div class="product-panel ' + (isActive ? 'active' : '') + '" id="panel-' + t + '">'
        + '<div class="product-count">'
          + '<span class="product-count-label">' + tabLabels[t].label + ' · '
            + '<span class="product-count-num">' + filtered.length + ' produkter</span>'
          + '</span>'
          + '<span class="panel-when">' + tabLabels[t].when + '</span>'
        + '</div>'
        + inner
      + '</div>';
    }).join('');

    var panelsEl = document.getElementById('r-panels');
    if (panelsEl) panelsEl.innerHTML = panelsHtml;

    // FASE 2.6.0: Annoncér produktantal i aktivt tab til skærmlæsere.
    // Filterskift re-renderer panelerne uden side-navigation — uden
    // aria-live får skærmlæser-brugere ingen feedback på deres valg.
    var liveCount = visibleTabCount(S.activeTab);
    announceLive(liveCount === 1
      ? '1 produkt vist'
      : liveCount + ' produkter vist');
  }

  // FASE 2.14.3: Én tælle-pipeline for alt atleten ser — tab-badge,
  // aria-live og panel skal vise samme tal. Før viste badget den rå
  // gruppestørrelse (fx 105) mod panelets 37 efter filtre, dedupe og
  // Maurten-additions — et løfte der ikke blev holdt.
  // FASE 5.7.0: Top 3 står allerede øverst på siden — i sortimentet
  // er de en dublet der underminerer tilliden ("har systemet styr på
  // det?"). Én sandhed pr. produkt pr. side.
  function isInTopMatches(p) {
    if (!currentTop || currentTop.length === 0) return false;
    for (var i = 0; i < currentTop.length; i++) {
      if (currentTop[i].handle === p.handle || currentTop[i].name === p.name) return true;
    }
    return false;
  }

  function visibleTabCount(t) {
    var pool = currentGroups[t] || [];
    var filtered = filterProducts(pool).filter(function(p) { return !p.isMaurtenAddition; });
    filtered = filtered.filter(function(p) { return !isInTopMatches(p); });
    var seen = {};
    return filtered.filter(function(p) {
      var key = p.name || p.handle;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).length;
  }

  // FASE 2.6.0: Skriver til den visuelt skjulte aria-live region
  // (#seg-live i page.guide.liquid).
  function announceLive(msg) {
    var live = document.getElementById('seg-live');
    if (live) live.textContent = msg;
  }

  function renderProductCard(p, isTopMatch) {
    var imageHtml = p.image
      ? '<img src="' + p.image + '" alt="' + escapeHtml(p.name || p.title || '') + '" loading="lazy">'
      : '<span class="product-img-placeholder">' + escapeHtml(p.brand || '') + '<br>' + escapeHtml(p.name || '') + '</span>';

    // FASE 2.3.5: Specs som chips — samme stil som curated-cards.
    // Tidligere viste vi flydende tekst som "Standard (30-40 g) · Max: 1:0.8 · Vegansk".
    // Det skaber visuel dissonans når atleten ser product-cards ved siden af
    // curated-cards der bruger chips. Vi ensretter til chips for konsistens.
    // Begrænset til max 3 chips for at holde card-højden i grid-rytme.
    var specs = buildCuratedSpecs(p).slice(0, 3);
    var specsHtml = specs.length > 0
      ? '<div class="product-specs">'
        + specs.map(function(s) {
            return '<span class="product-spec' + (s.highlight ? ' highlight' : '') + '">' + escapeHtml(s.text) + '</span>';
          }).join('')
        + '</div>'
      : '';

    // FASE 2.3.3: Pris-display.
    var priceText = p.price_kr != null ? Math.round(parseFloat(p.price_kr)) + ' kr' : '';
    var priceHtml = priceText
      ? '<div class="product-price-row"><span class="product-price">' + escapeHtml(priceText) + '</span></div>'
      : '';

    // FASE 2.3.2: "Læg i kurv"-knap.
    var hasVariant = p.default_variant_id && p.default_variant_id !== 0;
    var btnHtml = hasVariant
      ? '<button class="btn-add" onclick="SEG.addToCart(\'' + p.handle + '\', \'grid\')">Læg i kurv</button>'
      : '<button class="btn-add disabled" disabled>Udsolgt</button>';

    return '<div class="product-card" data-product-handle="' + escapeHtml(p.handle) + '">'
      + '<a class="product-img" href="' + escapeHtml(productHref(p)) + '" tabindex="-1" aria-hidden="true" onclick="return SEG.goToProduct(\'' + p.handle + '\', \'grid\')">' + imageHtml + '</a>'
      + '<div class="product-body">'
        + '<div class="product-brand">' + escapeHtml(p.brand || '') + '</div>'
        + '<a class="product-name" href="' + escapeHtml(productHref(p)) + '" onclick="return SEG.goToProduct(\'' + p.handle + '\', \'grid\')">' + escapeHtml(p.name || p.title || '') + '</a>'
        + specsHtml
        + priceHtml
        + '<div class="product-foot">'
          + btnHtml
        + '</div>'
      + '</div>'
    + '</div>';
  }

  function buildWhyText(p) {
    var parts = [];
    if (p.kulhydrat        && S.formal === 'energi-under') parts.push(p.kulhydrat);
    if (p.kulhydratforhold && S.formal === 'energi-under') parts.push(p.kulhydratforhold);
    if (p.elektrolyt && p.elektrolyt !== 'Uden elektrolyt' && S.formal === 'hydrering') parts.push(p.elektrolyt);
    if (p.koffein === 'Med koffein') parts.push('Med koffein');
    if (p.kosttype && p.kosttype.indexOf('Vegansk') >= 0) parts.push('Vegansk');
    if (p.protein_type && S.formal === 'restitution') parts.push(p.protein_type);
    if (p.testet && p.testet.length > 0) parts.push(p.testet[0]);

    return parts.length > 0 ? parts.join(' · ') : (p.name || '');
  }

  // ══════════════════════════════════════════════════
  //  TIPS
  // ══════════════════════════════════════════════════
  function renderTips() {
    var tips = getTips();
    var tipsEl = document.getElementById('r-tips');
    if (!tipsEl) return;
    tipsEl.innerHTML = tips.map(function(t, i) {
      return '<li><span class="tip-num">' + (i+1) + '</span><span>' + t + '</span></li>';
    }).join('');
  }

  // ══════════════════════════════════════════════════
  //  FASE 2.3.3: RELATED GUIDES
  // ══════════════════════════════════════════════════
  // Viser links til Phillip's eksisterende guides på sport-energy.dk efter
  // produkt-anbefalingerne. Kontekst-afhængig: vi viser guides der matcher
  // det formål atleten har valgt. Det giver atleten dybere viden uden at
  // skubbe dem væk fra konverteringen — guide-links ligger efter Tips og
  // før footer.
  //
  // Datakilde: hentet fra sport-energy.dk/pages/guides-til-sportsnaering-og-traening
  // 29. apr 2026. Hvis Phillip tilføjer nye guides, opdateres listen her.
  var RELATED_GUIDES = {
    'energi-under': [
      { title: 'Sådan vælger du det rigtige energi-produkt',     url: '/pages/vaelg-det-rigtige-energiprodukt' },
      { title: 'Fordele ved forskellige energi-produkter',       url: '/pages/fordele-ved-forskellige-energi-produkter' },
      { title: 'Sådan kombinerer du energi-produkter',           url: '/pages/sadan-kombinerer-du-energi-produkter-for-maksimal-ydeevne' }
    ],
    'hydrering': [
      { title: 'Hvornår har du brug for elektrolytter?',         url: '/pages/hvorn-r-har-du-brug-for-elektrolytter' },
      { title: 'Find den rigtige type elektrolyt',               url: '/pages/find-den-rigtige-type-elektrolyt' },
      { title: 'Sådan undgår du kramper og træthed',             url: '/pages/s-dan-undg-r-du-kramper-og-tr-thed-med-elektrolytter' }
    ],
    'restitution': [
      { title: 'Hvad er protein, og hvorfor er det vigtigt?',    url: '/pages/hvad-er-protein-og-hvorfor-er-det-vigtigt' },
      { title: 'Hvornår bør du tage protein?',                   url: '/pages/hvornar-skal-man-tage-protein' },
      { title: 'Hvor meget protein har du brug for?',            url: '/pages/hvor-meget-protein-har-du-brug-for' }
    ],
    'sportstilskud': [
      { title: 'Hvornår giver det mening at tage sportstilskud?', url: '/pages/hvorn-r-giver-det-mening-at-tage-sportstilskud' },
      { title: 'Hvilke sportstilskud passer til din sport?',     url: '/pages/hvilke-sportstilskud-har-jeg-brug-for' }
    ]
  };

  var ALL_GUIDES_URL = '/pages/guides-til-sportsnaering-og-traening';

  function renderRelatedGuides() {
    // Fjern eksisterende related-section hvis den findes (re-render)
    var existing = document.getElementById('seg-related-guides');
    if (existing) existing.remove();

    var guides = RELATED_GUIDES[S.formal];
    if (!guides || guides.length === 0) return;

    // Find indsætningssted: efter tips-block, før collection-btn eller før result-actions
    var stepResult = document.getElementById('step-result');
    if (!stepResult) return;
    var tipsBlock = stepResult.querySelector('.tips-block');
    if (!tipsBlock) return;

    var html = '<div class="related" id="seg-related-guides">'
      + '<div class="related-title">Læs også</div>'
      + '<ul class="related-list">'
      + guides.map(function(g) {
          return '<li><a href="' + g.url + '" onclick="SEG.trackGuideClick(\'' + escapeHtml(g.title.replace(/'/g, '')) + '\')">' + escapeHtml(g.title) + '</a></li>';
        }).join('')
      + '<li><a href="' + ALL_GUIDES_URL + '" class="related-all" onclick="SEG.trackGuideClick(\'__all__\')">Se alle guides →</a></li>'
      + '</ul>'
    + '</div>';

    // Indsæt efter tips-block
    tipsBlock.insertAdjacentHTML('afterend', html);
  }

  function trackGuideClick(guideTitle) {
    seg_track('guide_related_link_clicked', {
      title: guideTitle,
      formal: S.formal || null
    });
    // Lad browseren navigere normalt — ingen preventDefault
  }

  function getTips() {
    var profileTips = {
      // FASE 2.4.1: mave-meget-følsom og mave-ny smeltet ind i mave-følsom.
      // Tippet kombinerer det vigtigste fra de tidligere tre tips:
      // forsigtighed, gradvis opbygning, og vand-strategi.
      'mave-følsom':          'Test ét produkt ad gangen i træning, og drik rigeligt vand sammen med gels — koncentreret kulhydrat uden væske er den hyppigste årsag til mave-problemer',
      // FASE 2.4.1: svedtab-salt smeltet ind i svedtab-højt. Tip dækker nu
      // begge — saltrande er nævnt eksplicit som det stærkeste signal.
      'svedtab-højt':         'Vej dig før og efter et hårdt pas — vægttab over 2% er signal om utilstrækkelig hydrering. Saltrande på tøjet betyder du skal sigte mod 800–1200mg natrium per time',
      'restitution-hurtig':   'Restitutionsvinduet er størst de første 30 minutter — ikke vent med at indtage protein',
      'restitution-vegansk':  'Plantebaseret protein har lidt anderledes aminosyreprofil — overvej en lidt større portion (30–40g)'
    };

    var level = getAthleteLevel();
    var levelTips = {
      'energi-under': {
        novice:      'Træn fueling i træning — ikke på race-day. Det kræver typisk 4–6 lange pas at finde noget der virker for din mave',
        experienced: 'Hvis du tolererer 75–90g/time, er det værd at eksperimentere med 105–120g/time over flere uger — målrettet mod race-mål'
      },
      'hydrering': {
        novice:      'Drik når du er tørstig på korte pas — på lange varme pas skal du drikke før tørsten',
        experienced: 'Match natrium-indtag til dit svedtab — 500–1500mg per time afhængigt af temperatur og din individuelle profil'
      },
      'restitution': {
        novice:      'Du behøver ikke et tilskud efter hvert pas — fokus på proteinrigt aftensmad gør størstedelen af arbejdet',
        experienced: 'Casein før sengetid kan øge muskel-protein-syntese natten over — særligt relevant i træningsblok med to daglige pas'
      }
    };

    function applyPrependedTip(baseList) {
      if (profileTips[S.profile]) {
        return [profileTips[S.profile]].concat(baseList.slice(0, 3));
      }
      var formalTips = levelTips[S.formal];
      if (formalTips && formalTips[level]) {
        return [formalTips[level]].concat(baseList.slice(0, 3));
      }
      return baseList;
    }

    if (S.formal === 'energi-under') {
      // FASE 2.2.1: Tips for under-1t + let er opdateret til at understrege
      // hydrering først, da vi nu viser hydrerings-anbefalinger i denne case.
      if (S.duration === 'under-1t' && S.intensity === 'let') {
        return [
          'God hydrering før start er vigtigere end energi undervejs på lette korte pas',
          'Kroppens glykogen-depoter holder rigeligt til lette pas under én time',
          'Drik når du er tørstig — forhåndshydrering 30 min før start gør stor forskel',
          'Gem energi-produkter til længere eller hårdere pas hvor du reelt får brug for dem'
        ];
      }
      var base = [
        S.duration === 'over-4t'
          ? 'Start ernæringen fra minut 0 — ventetid straffer dig senere'
          : 'Start energiindtag ved minut 20–30 — ikke når du føler dig træt',
        getSportContextText().replace(/<[^>]+>/g, ''),
        S.caffeine
          ? 'Koffein tages 15–20 min før eller gemmes til sidste tredjedel'
          : 'Overvej koffein-gel til næste race for målbar boost',
        'Træn din ernæringsplan — prøv aldrig noget nyt på race-day'
      ];
      return applyPrependedTip(base);
    }

    if (S.formal === 'hydrering') {
      var hBase = [
        'Drik 500–800ml per time i moderat temperatur — 800–1000ml i varme',
        'Forhåndshydrering 30 min før start gør stor forskel',
        'Kramper skyldes oftest natrium-mangel — ikke vand alene',
        getSportContextText().replace(/<[^>]+>/g, '')
      ];
      return applyPrependedTip(hBase);
    }

    if (S.formal === 'restitution') {
      var rBase = [
        '20–35g protein inden for 30–60 min efter træning',
        'Kombinér protein og kulhydrat for at fylde glykogen-depoter',
        'Magnesium om aftenen forbedrer søvn og muskelrelaksation',
        'Et rigtigt måltid inden for 2 timer efter'
      ];
      return applyPrependedTip(rBase);
    }

    return [
      'Konsistens over uger giver større effekt end korte intensive perioder',
      'Tag tilskud på samme tidspunkt hver dag for stabil virkning',
      'Lyt til kroppen — ingen tilskud erstatter hvile og søvn',
      'Test nye tilskud i rolige perioder — ikke op til konkurrencer'
    ];
  }

  // ══════════════════════════════════════════════════
  //  goToProduct
  // ══════════════════════════════════════════════════
  // FASE 2.5.6: Udvidet med source-parameter for konverterings-tracking.
  // source angiver hvilket kort der trak klikket: 'klassiker', 'specialist',
  // 'variation', 'grid'. Bruges til at identificere hvilke kort der virker.
  // FASE 2.6.0: Kanonisk produkt-URL til href på kort-links.
  // Kortene er nu rigtige <a>-elementer (tastatur, cmd-klik, SEO);
  // onclick kalder goToProduct for tracking + sessionStorage-context
  // og returnerer false så browseren ikke navigerer dobbelt.
  function productHref(p) {
    var base = (p && p.url) ? p.url : '/products/' + ((p && p.handle) || '');
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'ref=guide';
  }

  function goToProduct(handle, source) {
    if (!handle) return false;
    var p = P[handle];
    source = source || 'unknown';

    seg_track('guide_product_clicked', {
      handle: handle,
      source: source,
      brand: p ? p.brand : '',
      formal: S.formal,
      sport: S.sport,
      profile: S.profile,
      tab: S.activeTab
    });

    // Gem guide-context i sessionStorage så det følger atleten over til
    // produktsiden. Hvis de derefter add-to-carter på selve produktsiden
    // (og ikke fra guiden), kan vi stadig markere ordren som guide-genereret.
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('seg_guide_context', JSON.stringify({
          source: source,
          handle: handle,
          formal: S.formal || '',
          sport: S.sport || '',
          profile: S.profile || '',
          timestamp: Date.now()
        }));
      }
    } catch (e) { /* ignore */ }

    // Tilføj URL-parametre så Shopify Analytics og Clarity kan se trafikken
    var baseUrl = (p && p.url) ? p.url : '/products/' + handle;
    var separator = baseUrl.indexOf('?') >= 0 ? '&' : '?';
    var url = baseUrl + separator + 'ref=guide&source=' + encodeURIComponent(source);
    window.location.href = url;
    return false; // FASE 2.6.0: forhindrer default-navigation fra <a href>
  }

  // ══════════════════════════════════════════════════
  //  RESULT (Fase 2.2.1 — med noEnergyMode)
  // ══════════════════════════════════════════════════
  function renderResult() {
    // FASE 2.2.1: Detektér "Ingen ekstra energi"-tilfældet (Roche regel 1).
    // Når atleten har valgt energi-under + under-1t + let, har de fagligt
    // ikke brug for ekstra energi. I stedet for at vise energi-produkter
    // alligevel, skifter vi midlertidigt S.formal til 'hydrering' så hele
    // pipelinen (matchProducts, scoreProduct, selectCurated, tabs, filtre)
    // automatisk bruger hydrerings-grenen. Banneret beholder sin egen
    // forklaring der gør skiftet tydeligt for atleten.
    //
    // S.formal resettes til den oprindelige værdi efter render-blokken,
    // så Step 3-tilbage og URL-state stadig fungerer korrekt.
    var ct = getCarbTarget();
    var noEnergyMode = (S.formal === 'energi-under' && ct && ct.rule === 1);
    var originalFormal = S.formal;

    // FASE 2.9.0: Chips renderes FØR formal-mutationen, så de viser
    // atletens faktiske valg — også i noEnergyMode. Sanering af
    // modifiers sker her, altså før matchProducts læser dem.
    renderStateChips();

    if (noEnergyMode) S.formal = 'hydrering';
    currentMatched = matchProducts();
    currentGroups = groupByHvornar(currentMatched);
    if (noEnergyMode) S.formal = originalFormal;

    DBG('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    DBG('[Fase 2.2.1] State:', JSON.parse(JSON.stringify(S)));
    DBG('[Fase 2.2.1] Niveau:', getAthleteLevel(), '| Carb-target:', ct);
    DBG('[Fase 2.2.1] noEnergyMode:', noEnergyMode);
    DBG('[Fase 2.2.1] Required ratios:', getRequiredRatios());
    DBG('[Fase 2.2.1] Total matchede produkter:', currentMatched.length);
    DBG('[Fase 2.2.1] Top 5 (med klassifikation):');
    currentMatched.slice(0, 5).forEach(function(p, i) {
      var classInfo = '';
      if (p.mainPurpose) classInfo += ' | purpose: ' + p.mainPurpose;
      if (p.subCategory) classInfo += ' | sub: ' + p.subCategory;
      if (p.specialFlags && p.specialFlags.length) classInfo += ' | flags: ' + p.specialFlags.join(',');
      classInfo += ' | isMaurtenAddition: ' + (p.isMaurtenAddition === true ? 'TRUE' : 'false');
      classInfo += ' | brand: "' + p.brand + '"';
      classInfo += ' | variant: "' + p.variant + '"';
      DBG('  ' + (i+1) + '. ' + p.title + classInfo);
    });
    DBG('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

    var titleEl = document.getElementById('r-title');
    if (titleEl) {
      var titles = {
        'energi-under':  'Energi til ' + sportLabel() + ' ' + durationLabel(),
        'hydrering':     'Hydrering til ' + sportLabel() + ' ' + durationLabel(),
        'restitution':   'Restitution efter ' + sportLabel(),
        'sportstilskud': 'Dine sportstilskud'
      };
      // FASE 2.2.1: I noEnergyMode viser vi hydrerings-titel — det er mere
      // ærligt overfor hvad atleten faktisk får i resten af resultatet.
      var titleKey = noEnergyMode ? 'hydrering' : S.formal;
      titleEl.textContent = (titles[titleKey] || 'Dine anbefalinger').trim();
    }

    var summaryEl = document.getElementById('r-summary');
    if (summaryEl) {
      var summary = '';
      if (noEnergyMode) {
        // FASE 2.2.1: Ærlig forklaring af hvorfor vi skifter til hydrering.
        // Kerne-budskab: kroppen har glykogen nok, hydrering er stadig værdifuld.
        summary = 'På lette pas under én time har <strong>kroppens glykogen-depoter rigeligt</strong> ' +
                  'til at klare turen — du behøver ikke ekstra energi. Til gengæld er <strong>hydrering</strong> ' +
                  'altid værdifuld, så her er vores anbefalinger til netop dette pas.';
      } else if (S.formal === 'energi-under') {
        if (ct) {
          // FASE 2.14.3: Målet står i badget lige under — at gentage det
          // i brødteksten var dobbelt-information på fire linjer.
          summary = getSportContextText();
        }
      } else if (S.formal === 'hydrering') {
        summary = '<strong>Væskebalance og elektrolytter</strong> er kritiske for præstation. ' + getSportContextText();
      } else if (S.formal === 'restitution') {
        summary = 'Inden for <strong>30–60 minutter efter træning</strong> er kroppen mest modtagelig for protein og kulhydrat til genopbygning.';
      } else {
        summary = '<strong>Det daglige fundament</strong> der supporterer din træning og restitution over uger.';
      }
      summaryEl.innerHTML = summary;
    }

    var carbSection = document.getElementById('r-carb-section');
    if (carbSection) {
      // FASE 2.2.1: I noEnergyMode skjuler vi carb-badget. Det giver ikke
      // mening at vise "Ingen ekstra energi" som mål når guiden anbefaler
      // hydrering — banneret-summary forklarer allerede situationen.
      if (ct && S.formal === 'energi-under' && !noEnergyMode) {
        var level = getAthleteLevel();
        var carbContext = '';
        if (ct.rule !== 1) {
          if (level === 'novice') {
            carbContext = '<div class="carb-context">Det er målet — start lavere og byg op over flere uger træning.</div>';
          } else if (level === 'experienced') {
            carbContext = '<div class="carb-context">Hvis du allerede tolererer dette komfortabelt, kan øvre ende eller højere være på bordet.</div>';
          }
        }
        carbSection.innerHTML = ''
          + '<div class="carb-section">'
            + '<div class="carb-badge">'
              + '<span class="carb-badge-label">Dit mål</span>'
              + '<span class="carb-badge-value">' + ct.display + '</span>'
            + '</div>'
            + '<button class="read-more-btn" onclick="SEG.openModal()">Læs mere →</button>'
            + carbContext
          + '</div>';
      } else if (S.formal === 'hydrering' || noEnergyMode) {
        // FASE 2.13.0: Hydrerings-mål — også i noEnergyMode, hvor
        // sektionen før var tom. Væskemålet er netop dét banneret
        // lover atleten dér.
        var hyd = (typeof SR.getHydrationTarget === 'function')
          ? SR.getHydrationTarget(S)
          : null;
        if (hyd) {
          var bMin = Math.round(hyd.fluidMinMl / 500 * 2) / 2;
          var bMax = Math.round(hyd.fluidMaxMl / 500 * 2) / 2;
          var bottleTxt = (bMin === bMax ? fmtQtyNum(bMin) : fmtQtyNum(bMin) + '–' + fmtQtyNum(bMax))
            + (bMax === 1 ? ' flaske' : ' flasker') + ' (500 ml) i timen';
          // FASE 2.14.1: Hintet er en klikbar handling — og kun i ægte
          // hydrering-flow. I noEnergyMode er profil-chippen maven, så
          // et svedtab-hint ville pege på noget der ikke findes.
          var hydContext = hyd.precise
            ? escapeHtml('Beregnet ud fra dit målte svedtab på ' + S.sweatRateMl + ' ml/t — ca. ' + bottleTxt + '.')
            : escapeHtml('Estimat ud fra din profil — ca. ' + bottleTxt + '.')
              + (S.formal === 'hydrering'
                  ? ' <button type="button" class="hyd-set-link" onclick="SEG.openSweatSetting()">Sæt dit målte svedtab</button>'
                  : '');
          carbSection.innerHTML = ''
            + '<div class="carb-section">'
              + '<div class="carb-badge">'
                + '<span class="carb-badge-label">Dit væskemål</span>'
                + '<span class="carb-badge-value">' + hyd.fluidMinMl + '–' + hyd.fluidMaxMl + ' ml/t · ' + hyd.sodiumMinMg + '–' + hyd.sodiumMaxMg + ' mg natrium</span>'
              + '</div>'
              + '<div class="carb-context">' + hydContext + '</div>'
            + '</div>';
        } else {
          carbSection.innerHTML = '';
        }
      } else {
        carbSection.innerHTML = '';
      }
    }

    // FASE 2.2.1: Skift S.formal igen for resten af render-blokken.
    // Alle hjælpefunktioner under dette punkt læser S.formal til at bestemme
    // why-tekster, specs, filtre, collection-link og tabs. Vi resetter til
    // sidst så Step 3-tilbage og URL-state ser den oprindelige formal-værdi.
    if (noEnergyMode) S.formal = 'hydrering';

    var colTitleEl = document.getElementById('r-col-title');
    if (colTitleEl) colTitleEl.textContent = getCollectionTitle();

    // FASE 2.3.4: Erstat collection-btn med premium pille-knap centreret.
    // Den oprindelige collection-btn er en stor card-lignende knap med titel
    // + subtitel + lille pil. Det fyldte for meget visuelt og signalerede
    // ikke "klikbar handling" tydeligt. Vi omskriver hele indholdet til en
    // centreret pille-knap der matcher æstetikken fra "LÆG I KURV"-knapperne
    // (versaler, full-width, outline-stil), men med ekstra kolonne-padding
    // så den ikke fylder hele bredden af cardet.
    rebuildCollectionButton();

    // FASE 2.4.5: Tjek filter-status FØR vi rendrer normale sektioner.
    // Hvis filter har efterladt 0 produkter (EMPTY/INCOMPATIBLE), viser
    // vi en empty-state og skipper resten af render-pipelinen. Læringsblok
    // og top-banner bevarer vi — de er stadig relevant kontekst.
    var filterStatus = (typeof SR.getFilterStatus === 'function')
      ? SR.getFilterStatus()
      : { status: 'OK', appliedFilters: [], matchedCount: 0, unfilteredCount: 0 };

    if (filterStatus.status === 'EMPTY' || filterStatus.status === 'INCOMPATIBLE') {
      renderLearningBlock();
      renderActiveFilterChips();
      renderEmptyState(filterStatus);
      // FASE 2.8.0: Ryd kit-kortet — et kit uden produkter giver ikke mening.
      var kitEl = document.getElementById('r-kit');
      if (kitEl) kitEl.innerHTML = '';
      kitState = null;
      // FASE 2.15.0: Luk udforsk-wrapperen i empty-state — ellers kan
      // den statiske kollektions-knap stå alene tilbage, hvis atleten
      // havde sektionen åben før chip-skiftet ind i nul resultater.
      var exploreBody = document.getElementById('r-explore-body');
      if (exploreBody) exploreBody.hidden = true;
      // Skip buildCuratedSection, buildExploreHeader, buildTabsAndFilters, renderPanels
      renderTips();
      renderRelatedGuides();

      if (noEnergyMode) S.formal = originalFormal;
      saveLastResult(); // FASE 2.11.0 — også empty-state er et resultat
      updateMobileFab();
      return;
    }

    renderLearningBlock();
    renderActiveFilterChips();

    buildCuratedSection();

    // Hvis filter-status er LIMITED, indsæt banner ØVERST i r-curated
    // (over curated-cards). Det giver kontekst uden at skjule produkterne.
    if (filterStatus.status === 'LIMITED') {
      var curatedEl = document.getElementById('r-curated');
      if (curatedEl && curatedEl.innerHTML) {
        var banner = renderLimitedBanner(filterStatus);
        if (banner) {
          curatedEl.innerHTML = banner + curatedEl.innerHTML;
        }
      }
    }

    renderKitCard(); // FASE 2.8.0: efter curated (kittet står efter sortimentet i DOM'en)

    buildExploreHeader();
    buildTabsAndFilters();
    renderPanels();
    renderTips();
    renderRelatedGuides();

    if (noEnergyMode) S.formal = originalFormal;

    saveLastResult(); // FASE 2.11.0: snapshot af det færdige resultat

    // FASE 4.3.0: Bro til race-kit byggeren — kulhydrat-målet tages
    // med over, så atleten ikke skal gætte sit g/t på ny. Kun
    // energi-formålet har et g-mål; ellers skjules linket.
    try {
      var rkBridge = document.getElementById('rk-bridge');
      if (rkBridge) {
        var rkT = window.SportEnergyRules && window.SportEnergyRules.getCarbTarget
          ? window.SportEnergyRules.getCarbTarget(S) : null;
        if (S.formal === 'energi-under' && rkT && rkT.gMin) {
          rkBridge.href = '/pages/race-kit?c='
            + Math.round((rkT.gMin + (rkT.gMax || rkT.gMin)) / 2);
          rkBridge.hidden = false;
        } else {
          rkBridge.hidden = true;
        }
      }
    } catch (eRk) {}

    updateMobileFab();
  }

  // ══════════════════════════════════════════════════
  //  NAVIGATION
  // ══════════════════════════════════════════════════
  function goToStep(n) {
    document.querySelectorAll('.step').forEach(function(s) { s.classList.remove('active'); });
    var labels = ['', 'Trin 1 af 3', 'Trin 2 af 3', 'Trin 3 af 3', 'Din anbefaling'];
    var label = document.getElementById('progress-label');
    if (label) label.textContent = labels[n];
    ['p1','p2','p3'].forEach(function(id, i) {
      var p = document.getElementById(id);
      if (!p) return;
      p.classList.remove('active','done');
      if (n === 4 || i < n-1) p.classList.add('done');
      else if (i === n-1) p.classList.add('active');
    });
    if (n === 4) {
      var sr = document.getElementById('step-result');
      if (sr) sr.classList.add('active');
    } else {
      var stepEl = document.getElementById('step-' + n);
      if (stepEl) stepEl.classList.add('active');
    }

    var mobileBar = document.getElementById('mobile-continue-bar');
    if (mobileBar) {
      if (n === 2) mobileBar.classList.add('visible');
      else mobileBar.classList.remove('visible');
    }

    var root = document.querySelector('.seg-root');
    if (root) {
      if (n === 2) root.classList.add('step-2-active');
      else root.classList.remove('step-2-active');

      // FASE 2.3.5: Step-state class på root.
      // Bruges til at conditionalisere CSS — fx skjule progress-bar
      // og reducere hero på step 4 hvor atleten er færdig med flowet.
      root.classList.remove('seg-step-1', 'seg-step-2', 'seg-step-3', 'seg-on-result');
      if (n === 4) root.classList.add('seg-on-result');
      else root.classList.add('seg-step-' + n);
    }

    // FASE 2.6.0: Flyt fokus til det aktive trins overskrift, så
    // tastatur- og skærmlæser-brugere lander det rigtige sted efter
    // trinskift. Vi flytter kun fokus hvis brugeren allerede har fokus
    // inde i guiden — ellers ville vi stjæle fokus ved page-load og
    // popstate (browser-tilbage).
    var ae = document.activeElement;
    if (ae && ae !== document.body && ae.closest && ae.closest('.seg-root')) {
      var focusTarget = (n === 4)
        ? document.getElementById('r-title')
        : document.querySelector('#step-' + n + ' .step-title');
      if (focusTarget) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
      }
    }

    updateMobileFab();
    updateHeroPill(n);
    scrollToActiveStep(n);
  }

  function updateHeroPill(n) {
    var pill   = document.getElementById('hero-pill');
    var text   = document.getElementById('hero-pill-text');
    var dot    = document.getElementById('hero-pill-dot');
    if (!pill || !text) return;

    if (n === 4) {
      text.textContent = 'Juster mine valg';
      pill.classList.add('hero-pill-action');
      pill.setAttribute('aria-label', 'Gå tilbage og juster dine valg i guiden');
      if (dot) dot.style.display = 'none';
    } else if (n === 3) {
      text.textContent = 'Næsten færdig';
      pill.classList.remove('hero-pill-action');
      pill.removeAttribute('aria-label');
      if (dot) dot.style.display = '';
    } else {
      text.textContent = 'Under ét minut';
      pill.classList.remove('hero-pill-action');
      pill.removeAttribute('aria-label');
      if (dot) dot.style.display = '';
    }
  }

  function heroPillClick() {
    var stepResult = document.getElementById('step-result');
    var onResult = stepResult && stepResult.classList.contains('active');
    if (!onResult) return;

    seg_track('guide_adjust_clicked', {
      formal: S.formal, sport: S.sport, profile: S.profile
    });

    goToStep(1);
    setTimeout(function() {
      try {
        var tiles = document.querySelectorAll('#step-1-content .opt-tile');
        tiles.forEach(function(t) {
          if (t.dataset.value === S.formal) t.classList.add('selected');
        });
      } catch (e) {}
    }, 50);
  }

  function scrollToActiveStep(n) {
    var targetEl = (n === 4)
      ? document.getElementById('step-result')
      : document.getElementById('step-' + n);
    if (!targetEl) return;

    if (window.scrollY < 40 && n === 1) return;

    var progressBar = document.querySelector('.progress-bar');
    var progressH = progressBar ? progressBar.getBoundingClientRect().height : 44;
    var offset = progressH + 16;

    var top = targetEl.getBoundingClientRect().top + window.scrollY - offset;
    // FASE 2.6.0: Respektér prefers-reduced-motion — JS-scroll med
    // behavior:'smooth' overstyres ikke af CSS-reglen, så vi tjekker selv.
    var reduceMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function toggleHelp(btn) {
    btn.parentElement.classList.toggle('open');
  }

  function updateMobileFab() {
    var fab = document.getElementById('filter-fab');
    if (!fab) return;
    var stepResult = document.getElementById('step-result');
    var resultActive = stepResult && stepResult.classList.contains('active');
    // FASE 2.15.0: FAB'en hører til udforsk-sektionen — foldet
    // sektion, ingen FAB.
    if (resultActive && resultUI.exploreOpen) {
      fab.classList.add('show');
      updateFabCount();
    } else {
      fab.classList.remove('show');
    }
  }

  function loadFromURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('f')) return false;

      // FASE 2.4.1: Validér mod ikke-længere-supporterede profil/sport-værdier.
      // Hvis URL'en bruger fjernede værdier (HYROX, mave-meget-følsom, mave-ny,
      // svedtab-salt), reset'er vi til step 1 så atleten starter forfra med
      // de nye options. Dette er ærligere end stille mapping.
      var legacySport = params.get('s');
      var legacyProfile = params.get('p');
      var hasLegacyValues = legacySport === 'hyrox'
                         || legacyProfile === 'mave-meget-følsom'
                         || legacyProfile === 'mave-ny'
                         || legacyProfile === 'svedtab-salt'
                         || params.has('h'); // gammel hyroxMode-param

      if (hasLegacyValues) {
        // Ryd URL'en og lad atleten starte forfra
        try {
          history.replaceState({}, '', window.location.pathname);
        } catch (e) { /* ignore */ }
        seg_track('guide_legacy_url_reset', {
          old_sport: legacySport || null,
          old_profile: legacyProfile || null
        });
        return false;
      }

      S.formal     = params.get('f');
      S.sport      = params.get('s');
      S.duration   = params.get('d');
      // FASE 2.10.0: Præcis varighed fra URL — valider og afled
      // bucket defensivt, så d og dm aldrig er i konflikt.
      var dm = parseInt(params.get('dm'), 10);
      if (!isNaN(dm) && dm >= 30 && dm <= 720) {
        S.durationMin = dm;
        if (typeof SR.bucketFromMinutes === 'function') S.duration = SR.bucketFromMinutes(dm);
      } else {
        S.durationMin = null;
      }
      // FASE 2.13.0: Målt svedtab fra URL — samme validering som slideren.
      // FASE 3.0.1: Mangler sr i linket, falder vi tilbage på atletens
      // egen profil. Et delt tal vinder eksplicit (det var pointen med
      // linket) — men det skrives ALDRIG ind i modtagerens profil.
      var sr = parseInt(params.get('sr'), 10);
      S.sweatRateMl = (!isNaN(sr) && sr >= 400 && sr <= 2500)
        ? sr
        : profileSweatRate();
      S.intensity  = params.get('i');
      S.profile    = params.get('p');
      S.modifiers  = params.has('m') ? params.get('m').split(',').filter(Boolean) : [];
      S.caffeine = S.modifiers.indexOf('med-koffein') >= 0;
      if (!S.formal || !S.profile) return false;
      renderResult();
      goToStep(4);
      seg_track('guide_loaded_from_url', {formal: S.formal, profile: S.profile});
      return true;
    } catch (e) {
      console.error('[Sport Energy Guide] loadFromURL error:', e);
      return false;
    }
  }

  // FASE 2.9.0: replace=true bruger replaceState i stedet for pushState
  // — chip-justeringer skal ikke fylde browser-historikken med ét hop
  // pr. tap. Trin-navigation bruger fortsat pushState (tilbage-knappen
  // skal stadig kunne gå trin tilbage).
  function updateURL(replace) {
    try {
      var params = new URLSearchParams();
      if (S.formal)    params.set('f', S.formal);
      if (S.sport)     params.set('s', S.sport);
      if (S.duration)  params.set('d', S.duration);
      if (S.durationMin) params.set('dm', S.durationMin);
      if (S.sweatRateMl) params.set('sr', S.sweatRateMl);
      if (S.intensity) params.set('i', S.intensity);
      if (S.profile)   params.set('p', S.profile);
      if (S.modifiers && S.modifiers.length) params.set('m', S.modifiers.join(','));
      var stateCopy = JSON.parse(JSON.stringify(S));
      stateCopy.step = 4;
      var newUrl = window.location.pathname + '?' + params.toString();
      if (replace) {
        history.replaceState(stateCopy, '', newUrl);
      } else {
        history.pushState(stateCopy, '', newUrl);
      }
    } catch (e) {
      // pushState kan fejle i sandboxed kontekster
    }
  }

  function resetWizard() {
    Object.assign(S, {formal:null, sport:null, duration:null, durationMin:null, sweatRateMl:profileSweatRate() /* FASE 3.0.2 */, intensity:null, profile:null, modifiers:[], caffeine:false, activeTab:'under', activeFilters:['alle'], advancedFilters:[], showAdvanced:false, expandedTabs:{}});
    document.querySelectorAll('.opt-tile, .opt-pill, .segmented-option').forEach(function(e) { e.classList.remove('selected'); });
    try {
      history.pushState({}, '', window.location.pathname);
    } catch (e) {}
    seg_track('guide_reset');
    // FASE 2.15.0: Frisk start = foldet udgangspunkt.
    resultUI.learningOpen = false;
    resultUI.exploreOpen = true; // FASE 5.6.0: åben som standard
    resultUI.kitOpen = false;    // FASE 5.5.0
    resultUI.matchIdx = 0;       // FASE 5.2.0
    currentTop = [];
    var extrasBody = document.getElementById('r-extras-body');
    if (extrasBody) extrasBody.hidden = true;
    var extrasBtn = document.getElementById('extras-toggle');
    if (extrasBtn) extrasBtn.setAttribute('aria-expanded', 'false');
    goToStep(1);
    // FASE 2.12.1: Vejen tilbage findes altid — også efter 'start
    // forfra'. Snapshottet overlever bevidst en reset; kun afvis-
    // krydset og TTL sletter det.
    renderContinueCard();
  }

  // FASE 2.6.0: Tilgængelighed for modal og bottom-sheet.
  // - Escape lukker dialogen
  // - Fokus flyttes ind i dialogen ved åbning og tilbage til
  //   udgangspunktet ved lukning
  // - Tab/Shift+Tab holdes inde i dialogen (fokus-fælde) så
  //   tastatur-brugere ikke lander bag overlayet
  var FOCUSABLE_SEL = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocusKeydown(container, e) {
    if (e.key !== 'Tab') return;
    var items = container.querySelectorAll(FOCUSABLE_SEL);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  var modalLastFocus = null;

  function modalKeydown(e) {
    if (e.key === 'Escape') { closeModal(); return; }
    var m = document.getElementById('roche-modal');
    var dialog = m ? m.querySelector('.modal') : null;
    if (dialog) trapFocusKeydown(dialog, e);
  }

  function closeModal(event) {
    if (event && event.target !== event.currentTarget) return;
    var m = document.getElementById('roche-modal');
    if (m) m.classList.remove('show');
    document.removeEventListener('keydown', modalKeydown);
    if (modalLastFocus && typeof modalLastFocus.focus === 'function') {
      modalLastFocus.focus();
    }
    modalLastFocus = null;
  }
  function openModal() {
    var m = document.getElementById('roche-modal');
    if (!m) return;
    modalLastFocus = document.activeElement;
    m.classList.add('show');
    var closeBtn = m.querySelector('.modal-close');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', modalKeydown);
  }

  // ══════════════════════════════════════════════════
  //  PUBLIC API
  // ══════════════════════════════════════════════════
  window.SEG = {
    selectFormal: selectFormal,
    pickSport: pickSport,
    pickDuration: pickDuration,
    pickIntensity: pickIntensity,
    continueStep2: continueStep2,
    pickProfile: pickProfile,
    toggleModifier: toggleModifier,
    toggleMultiTile: toggleMultiTile,
    confirmMultiSelect: confirmMultiSelect,
    goToStep: goToStep,
    goToProduct: goToProduct,
    toggleHelp: toggleHelp,
    heroPillClick: heroPillClick,
    switchTab: switchTab,
    expandTab: expandTab,
    collapseTab: collapseTab,
    addToCart: addToCart,
    kitAdjust: kitAdjust,
    kitToggleAddon: kitToggleAddon,
    addKitToCart: addKitToCart,
    toggleKitPlan: toggleKitPlan,
    toggleLearning: toggleLearning,
    toggleExplore: toggleExplore,
    toggleExtras: toggleExtras,
    toggleKit: toggleKit,
    selectMatch: selectMatch,
    matchKeydown: matchKeydown,
    toggleWhy: toggleWhy,
    copyKitPlan: copyKitPlan,
    chipToggleOpen: chipToggleOpen,
    chipPick: chipPick,
    chipToggleModifier: chipToggleModifier,
    chipDurationSlide: chipDurationSlide,
    chipDurationCommit: chipDurationCommit,
    chipSweatSlide: chipSweatSlide,
    chipSweatCommit: chipSweatCommit,
    chipSweatClear: chipSweatClear,
    openSweatSetting: openSweatSetting,
    copyResultLink: copyResultLink,
    continueLastResult: continueLastResult,
    dismissContinue: dismissContinue,
    trackGuideClick: trackGuideClick,
    toggleFilter: toggleFilter,
    toggleAdvFilter: toggleAdvFilter,
    toggleAdvancedFilters: toggleAdvancedFilters,
    openFilterSheet: openFilterSheet,
    closeFilterSheet: closeFilterSheet,
    toggleFilterSheet: toggleFilterSheet,
    toggleAdvFilterSheet: toggleAdvFilterSheet,
    clearAllFilters: clearAllFilters,
    resetWizard: resetWizard,
    openModal: openModal,
    closeModal: closeModal,
    // FASE 2.4.5: Filter-management fra empty-state og active-filter-chips
    removeFilter: removeFilterAndRerender,
    goBackToStep3: function() { goToStep(3); }
  };

  // ══════════════════════════════════════════════════
  //  INIT
  // ══════════════════════════════════════════════════
  try {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'auto';
    }

    var urlHasState = (function() {
      try {
        var p = new URLSearchParams(window.location.search);
        return p.has('f') && p.has('p');
      } catch (e) { return false; }
    })();

    // FASE 2.15.1: Trin 1 renderes ALTID ved init — også når der
    // loades direkte fra URL-state. Før blev renderStep1 sprunget
    // over ved delte links, og trinnet stod TOMT når atleten senere
    // navigerede tilbage (juster-pillen, popstate, start forfra).
    // Eksisterende fejl fra del-link-funktionen — først set live i
    // dag, fordi kombinationen 'delt link → gå tilbage' aldrig var
    // prøvet. Reproduceret og låst med jsdom-harness.
    renderStep1();
    // FASE 3.0.1: Atletens målte svedtab (svedtest/slider) læses ind
    // før begge init-stier; loadFromURL kan derefter overstyre med
    // et eksplicit delt tal.
    S.sweatRateMl = profileSweatRate();
    if (urlHasState) {
      var loaded = loadFromURL();
      if (!loaded) {
        renderContinueCard(); // FASE 2.11.0: ugyldig URL → tilbyd seneste resultat
      }
    } else {
      renderContinueCard(); // FASE 2.11.0
      seg_track('guide_started');
    }

    updateMobileFab();
    initSheetHandle();

    var root = document.querySelector('.seg-root');
    if (root) root.classList.add('seg-ready');
  } catch (e) {
    console.error('[Sport Energy Guide] Init error:', e);
    try { renderStep1(); } catch (e2) {}
    var root2 = document.querySelector('.seg-root');
    if (root2) root2.classList.add('seg-ready');
  }

  window.addEventListener('load', function() {
    try {
      var stepResult = document.getElementById('step-result');
      var alreadyOnResult = stepResult && stepResult.classList.contains('active');
      if (!alreadyOnResult) {
        loadFromURL();
      }
      updateMobileFab();
    } catch (e) {
      console.error('[Sport Energy Guide] load error:', e);
    }
  });

  window.addEventListener('popstate', function() {
    try {
      var p = new URLSearchParams(window.location.search);
      if (p.has('f') && p.has('p')) {
        loadFromURL();
      } else {
        Object.assign(S, {formal:null, sport:null, duration:null, durationMin:null, sweatRateMl:profileSweatRate() /* FASE 3.0.2 */, intensity:null, profile:null, modifiers:[], caffeine:false, expandedTabs:{}});
        goToStep(1);
      }
      updateMobileFab();
    } catch (e) {
      console.error('[Sport Energy Guide] popstate error:', e);
    }
  });

  // FASE 2.1: Debug-funktion. Kald window.SEG_debug('powergel') i konsollen
  // for at se klassifikations-status på et produkt-mønster.
  window.SEG_debug = function(searchTerm) {
    var search = (searchTerm || '').toLowerCase();
    var matches = window.SportEnergyGuideData.products.filter(function(p) {
      return (p.title || '').toLowerCase().indexOf(search) >= 0
          || (p.handle || '').toLowerCase().indexOf(search) >= 0;
    });
    console.log('=== SEG_debug for "' + search + '" ===');
    console.log('Fundet ' + matches.length + ' produkter:');
    matches.forEach(function(p) {
      console.log('  ' + p.title);
      console.log('    handle: ' + p.handle);
      console.log('    brand: "' + p.brand + '" (raw: "' + p.brand_raw + '")');
      console.log('    variant: "' + p.variant + '" (raw: "' + p.variant_raw + '")');
      console.log('    --- variant kilde-diagnose ---');
      console.log('    metafields.custom.variant.value: ' + JSON.stringify(p._debug_variant_metafield));
      console.log('    metafields.custom.variant (raw): ' + JSON.stringify(p._debug_variant_raw));
      console.log('    (gammel) metafields.nutrition.variant.value: ' + JSON.stringify(p._debug_old_nutrition_variant));
      console.log('    product.type: ' + JSON.stringify(p._debug_product_type));
      console.log('    product.category: ' + JSON.stringify(p._debug_product_category));
      console.log('    product.product_type: ' + JSON.stringify(p._debug_product_product_type));
      console.log('    type_raw: ' + JSON.stringify(p.type_raw));
      console.log('    --- klassifikation ---');
      console.log('    kulhydrater_raw: ' + JSON.stringify(p.kulhydrater_raw));
      console.log('    carbPerPortion: ' + p.carbPerPortion);
      console.log('    isMaurtenAddition: ' + p.isMaurtenAddition);
      console.log('    mainPurpose: ' + p.mainPurpose);
    });
  };

  DBG('[Sport Energy Guide / Fase 2.4.1] Wizard klar. ' +
    Object.keys(P).length + ' produkter loaded i P-katalog. ' +
    'Profil-konsolidering: 2 mave-options, 2 svedtab-options, 3 sportsgrene (HYROX fjernet). ' +
    'Læringsblok aktiv: ' + (SL ? 'ja ✓' : 'modul ikke loadet — graceful degradation') + '. ' +
    'Cart-drawer via Kaching: ' + (window.kachingCartApi ? 'fundet ✓' : 'ikke loadet endnu (trigger ved første klik)') + '. ' +
    'Kald window.SEG_debug("powergel") i konsollen for at debugge.');
})();